(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6101],{

/***/ 21753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38494);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);





var AnimatedButton = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.button */ .E.button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        whileTap: {
            scale: 0.92
        }
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AnimatedButton);


/***/ }),

/***/ 64591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PoiCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(43000);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/design-lib/base-ui/Typography/index.ts + 1 modules
var Typography = __webpack_require__(54985);
// EXTERNAL MODULE: ./src/utils/points-of-interest.ts
var points_of_interest = __webpack_require__(13782);
// EXTERNAL MODULE: src/components/PoiCard/styles.css.tsx.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/PoiCard/styles.css.tsx.vanilla.css","source":"LnI5Mjg5dzAgewogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgYmFja2dyb3VuZC1jb2xvcjogI0ZGRkZGRjsKICBib3JkZXItcmFkaXVzOiA4cHg7CiAgYm94LXNoYWRvdzogMHB4IDBweCA1cHggcmdiYSgwLCAwLCAwLCAwLjUpOwogIGRpc3BsYXk6IGZsZXg7CiAgZ2FwOiA4cHg7CiAgaGVpZ2h0OiAxMDBweDsKICBsaW5lLWhlaWdodDogMS41OwogIHdpZHRoOiAxMDAlOwp9Ci5yOTI4OXcxIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRkY5OTFGOwogIGJhY2tncm91bmQtcG9zaXRpb246IGNlbnRlcjsKICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0OwogIGJhY2tncm91bmQtc2l6ZTogNDBweDsKICBib3JkZXItYm90dG9tLWxlZnQtcmFkaXVzOiA4cHg7CiAgYm9yZGVyLXRvcC1sZWZ0LXJhZGl1czogOHB4OwogIGZsZXgtc2hyaW5rOiAwOwogIGhlaWdodDogMTAwcHg7CiAgd2lkdGg6IDEwMHB4Owp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDEwMjRweCkgewogIC5yOTI4OXcwIHsKICAgIHdpZHRoOiAzMzBweDsKICB9Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(71766);
;// CONCATENATED MODULE: ./src/components/PoiCard/styles.css.tsx

var poiCard = 'r9289w0';
var poiCardLeft = 'r9289w1';
;// CONCATENATED MODULE: ./src/components/PoiCard/index.tsx








var PoiCard = function(param) {
    var poi = param.poi;
    var t = (0,useTranslation/* default */.Z)().t;
    var poiCategory = (0,points_of_interest/* getPoiCategoryFromType */.Qv)(poi.poiType);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: poiCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: poiCardLeft,
                style: {
                    backgroundImage: "url(/lisa/images/poi/".concat(poi.poiType.toLowerCase(), "-icon-white.svg")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                        color: "greyscale500",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* TokenSupport */.B, {
                            values: {
                                distance: poi.distance
                            },
                            children: "listing-detail:".concat(poiCategory, ".").concat(poi.poiType, "_distance")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                        color: "greyscale500",
                        children: poi.name ? (0,fp.upperFirst)(poi.name) : (0,fp.upperFirst)(t("listing-detail:".concat(poiCategory, ".").concat(poi.poiType, "_label")))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_PoiCard = (PoiCard);


/***/ }),

/***/ 30906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ containers_ListingDetail; }
});

// UNUSED EXPORTS: parseListingPrice, partialIdfromPropertySlug

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(63796);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(76131);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js + 2 modules
var AnimatePresence = __webpack_require__(62978);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(87385);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 97 modules
var motion = __webpack_require__(38494);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(25911);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(93229);
// EXTERNAL MODULE: ./src/components/InventoryBannerBig/ThisIsACasavoClaim.tsx
var ThisIsACasavoClaim = __webpack_require__(91686);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
;// CONCATENATED MODULE: ./src/components/LinkArrow/index.tsx









var linkAnimation = {
    animate: {
        transition: {
            delay: 4.5,
            duration: 0.5
        },
        x: [
            0,
            10,
            0
        ]
    }
};
var svgAnimation = {
    hover: {
        transition: {
            duration: 0.5,
            type: "tween"
        },
        x: [
            0,
            3,
            0
        ]
    }
};
var LinkArrow = function(_param) {
    var _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _fontSize = _param.fontSize, fontSize = _fontSize === void 0 ? 16 : _fontSize, href = _param.href, _iconSize = _param.iconSize, iconSize = _iconSize === void 0 ? 16 : _iconSize, inView = _param.inView, label = _param.label, onClick = _param.onClick, _spacing = _param.spacing, spacing = _spacing === void 0 ? 16 : _spacing, linkProps = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "fontSize",
        "href",
        "iconSize",
        "inView",
        "label",
        "onClick",
        "spacing"
    ]);
    var device = (0,Device/* useDevice */.Fy)();
    var linkTag = motion/* motion.a */.E.a;
    var buttonTag = motion/* motion.button */.E.button;
    var CustomTag = href ? linkTag : buttonTag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        animate: inView && "animate",
        className: (0,sprinkles_css/* sprinkles */.K)({
            alignItems: "center",
            cursor: "pointer",
            display: "flex",
            gap: "s",
            margin: "0 auto"
        }),
        href: href,
        initial: "initial",
        style: {
            color: color,
            fontSize: fontSize
        },
        variants: linkAnimation,
        whileHover: "hover",
        onClick: onClick
    }, linkProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                strong: true,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.svg */.E.svg, {
                fill: "none",
                height: iconSize,
                variants: svgAnimation,
                viewBox: "0 0 16 16",
                width: iconSize,
                xmlns: "http://www.w3.org/2000/svg",
                children: device === "desktop" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    clipRule: "evenodd",
                    d: "M8 0L6.59 1.41L12.17 7H0L0 9H12.17L6.58 14.58L8 16L16 8L8 0Z",
                    fill: color,
                    fillRule: "evenodd"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    fill: "none",
                    height: "16",
                    viewBox: "0 0 16 16",
                    width: "16",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        clipRule: "evenodd",
                        d: "M5.70718 0.292892L13.4143 8L5.70718 15.7071L4.29297 14.2929L10.5851 8L4.29297 1.70711L5.70718 0.292892Z",
                        fill: color,
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var components_LinkArrow = (LinkArrow);

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/design-lib/style-theme/theme.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/theme.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx+PN+HpviGoxnG0Q/yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx/6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I/MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN/xuQI/Ob/nviaZJHQ+EFSd7nQndD4SVF577QV/Yv+VVVbo3PF5EyYU9zgxVxhQ+P/M+psxDoLv2X+TYhT+vxBUwfbJi/s98L34vrE+50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ/mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE/Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K+3m+8qnvHrz5qf+odIeOQENc0Qvhb/xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV+AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6/+y/r7Dy2XybuPCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(19636);
// EXTERNAL MODULE: src/components/BannerCasavoProperties/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/BannerCasavoProperties/styles.css.ts.vanilla.css","source":"Ll8xZGh4Z2xuMSB7CiAgYmFja2dyb3VuZDogdmFyKC0tXzFtdWg4bmtnKTsKfQouXzFkaHhnbG4zIHsKICBtYXgtd2lkdGg6IDExMjBweDsKfQouXzFkaHhnbG45Omxhc3Qtb2YtdHlwZSB7CiAgcGFkZGluZy1ib3R0b206IDA7Cn0KQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogNzY4cHgpIHsKICAuXzFkaHhnbG4xIHsKICAgIG1pbi1oZWlnaHQ6IDI1MnB4OwogICAgcGFkZGluZy1ib3R0b206IDA7CiAgfQp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(27405);
;// CONCATENATED MODULE: ./src/components/BannerCasavoProperties/styles.css.ts



var bannerBackground = '_1dhxgln1 _1b5wm207u tfghjggo tfghjgjf';
var bannerBody = '_1dhxgln3 tfghjghf tfghjgil tfghjgbr tfghjgg9';
var bannerListItem = '_1dhxgln9 tfghjg1u tfghjgg9 tfghjg6';
var content = 'tfghjggc tfghjg1v tfghjg7j tfghjga7';
var contentLeft = 'tfghjg73 tfghjgid tfghjgko';
;// CONCATENATED MODULE: ./src/components/BannerCasavoProperties/BannerList/index.tsx






var BannerListComponent = function(param) {
    var description = param.description, image = param.image, _imageSize = param.imageSize, imageSize = _imageSize === void 0 ? "s" : _imageSize, title = param.title;
    if (!title) {
        return null;
    }
    var imageSrc = image || "check";
    var compoundImageSize = imageSize === "s" ? 20 : 48;
    var ref = config_default()(), imageBasePath = ref.publicRuntimeConfig.imageBasePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: bannerListItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    flexShrink: 0,
                    marginRight: "m"
                }),
                height: compoundImageSize,
                src: "".concat(imageBasePath, "/images/banner-casavo-property/").concat(imageSrc, ".svg"),
                width: compoundImageSize
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                        strong: true,
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            textTransform: "uppercase"
                        }),
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                        children: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BannerList = (BannerListComponent);

;// CONCATENATED MODULE: ./src/components/BannerCasavoProperties/index.tsx













var BannerCasavoProperties = function(param) {
    var onClickCta = param.onClickCta;
    var t = (0,useTranslation/* default */.Z)().t;
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    }), inView = ref.inView, ref1 = ref.ref;
    var bannerAnimation = {
        hidden: {
            opacity: 0,
            y: 50
        },
        show: {
            opacity: 1,
            y: 0
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            marginBottom: "2xl"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThisIsACasavoClaim/* ThisIsACasavoClaim */.l, {
                className: styles_css/* marginBottom.s */.yl.s,
                i18nKey: "PropertyAdvantages:PropertyAdvantages_CasavoProperty_BannerIntro"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref1,
                className: bannerBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: bannerBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: contentLeft,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                            animate: inView ? "show" : "hidden",
                                            className: (0,sprinkles_css/* sprinkles */.K)({
                                                paddingBottom: {
                                                    mobile: "m",
                                                    tablet: "s"
                                                }
                                            }),
                                            initial: "hidden",
                                            transition: {
                                                duration: 1.3,
                                                type: "tween"
                                            },
                                            variants: bannerAnimation,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading5 */.by, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                    components: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, "0")
                                                    ],
                                                    i18nKey: "casavo-properties-banner:title_detail"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                            animate: inView ? "show" : "hidden",
                                            className: (0,sprinkles_css/* sprinkles */.K)({
                                                paddingBottom: {
                                                    mobile: "l",
                                                    tablet: "2xl"
                                                }
                                            }),
                                            initial: "hidden",
                                            transition: {
                                                delay: 0.5,
                                                duration: 1.3,
                                                type: "tween"
                                            },
                                            variants: bannerAnimation,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* BodyM */.iO, {
                                                children: [
                                                    " ",
                                                    t("casavo-properties-banner:text_detail")
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        paddingBottom: {
                                            mobile: "xl",
                                            tablet: 0
                                        }
                                    }),
                                    children: [
                                        t("casavo-properties-banner:advantage_first"),
                                        t("casavo-properties-banner:advantage_second"),
                                        t("casavo-properties-banner:advantage_third"), 
                                    ].map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerList, {
                                            title: item
                                        }, "advantage-".concat(index));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                textAlign: "center"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LinkArrow, {
                                "data-testid": "discover_all_the_advantages",
                                fontSize: 13,
                                inView: inView,
                                label: t("casavo-properties-banner:discover_all_the_advantages"),
                                onClick: onClickCta
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_BannerCasavoProperties = (BannerCasavoProperties);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(88718);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(41354);
// EXTERNAL MODULE: ./src/components/ConditionalWrapper/index.tsx
var ConditionalWrapper = __webpack_require__(28820);
// EXTERNAL MODULE: ./src/design-lib/theme.ts
var theme = __webpack_require__(56161);
// EXTERNAL MODULE: ./src/lib/api-gluglu-open.ts
var api_gluglu_open = __webpack_require__(18872);
// EXTERNAL MODULE: ./src/utils/dom-interactions-helpers.ts
var dom_interactions_helpers = __webpack_require__(16360);
;// CONCATENATED MODULE: ./src/utils/get-ga-client-id.ts
function getGAClientIDCore(w) {
    var ref;
    var googleAnalyticsEntryPointGetAll = ((ref = w.ga) === null || ref === void 0 ? void 0 : ref.getAll) || function() {
        return [];
    };
    var trackers = googleAnalyticsEntryPointGetAll() || [];
    if (trackers.length === 0) {
        return null;
    }
    var trackerThatContainsClientId = trackers[0];
    if (!trackerThatContainsClientId.get) {
        return null;
    }
    return trackerThatContainsClientId.get("clientId") || null;
}
var getGAClientId = function() {
    return getGAClientIDCore(window);
};
var _test = {
    getGAClientIDCore: getGAClientIDCore
};

// EXTERNAL MODULE: ./src/utils/isStorageSupported.ts
var isStorageSupported = __webpack_require__(17668);
;// CONCATENATED MODULE: ./src/utils/listing/listingType.ts
var LISTING_TYPE;
(function(LISTING_TYPE) {
    LISTING_TYPE["IBUYER_BROKERED"] = "ibuyer_brokered";
    LISTING_TYPE["IBUYER_DIRECT"] = "ibuyer_direct";
    LISTING_TYPE["ODA_BROKERED"] = "oda_brokered";
    LISTING_TYPE["ODA_DIRECT"] = "oda_direct";
    LISTING_TYPE["THIRD_PARTY"] = "third_party";
})(LISTING_TYPE || (LISTING_TYPE = {}));
var INVENTORY;
(function(INVENTORY) {
    INVENTORY["IBUYER"] = "ibuyer";
    INVENTORY["ODA"] = "oda";
    INVENTORY["THIRD_PARTY"] = "third_party";
})(INVENTORY || (INVENTORY = {}));
var SALES_PIPELINE;
(function(SALES_PIPELINE) {
    SALES_PIPELINE["BROKERED"] = "brokered";
    SALES_PIPELINE["DIRECT"] = "direct";
})(SALES_PIPELINE || (SALES_PIPELINE = {}));
var getListingType = function(listing) {
    var _detail = listing.detail, inventory = _detail.inventory, salesPipeline = _detail.salesPipeline;
    if (inventory === INVENTORY.IBUYER) {
        return salesPipeline === SALES_PIPELINE.DIRECT ? LISTING_TYPE.IBUYER_DIRECT : LISTING_TYPE.IBUYER_BROKERED;
    }
    if (inventory === INVENTORY.ODA) {
        return salesPipeline === SALES_PIPELINE.DIRECT ? LISTING_TYPE.ODA_DIRECT : LISTING_TYPE.ODA_BROKERED;
    }
    if (inventory === INVENTORY.THIRD_PARTY && salesPipeline === null) return LISTING_TYPE.THIRD_PARTY;
};
var isDirectSales = function(listing) {
    return [
        LISTING_TYPE.IBUYER_DIRECT,
        LISTING_TYPE.ODA_DIRECT
    ].includes(getListingType(listing));
};
var isOwnedByCasavo = function(listing) {
    return [
        LISTING_TYPE.IBUYER_DIRECT,
        LISTING_TYPE.IBUYER_BROKERED,
        LISTING_TYPE.ODA_BROKERED,
        LISTING_TYPE.ODA_DIRECT, 
    ].includes(getListingType(listing));
};
var isThirdParty = function(listing) {
    return getListingType(listing) === LISTING_TYPE.THIRD_PARTY;
};

// EXTERNAL MODULE: ./src/utils/prefix.ts
var prefix = __webpack_require__(41073);
// EXTERNAL MODULE: ./src/utils/third-party/recaptcha/api.ts
var api = __webpack_require__(73293);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: ./src/context/ModalContext.tsx
var ModalContext = __webpack_require__(32228);
// EXTERNAL MODULE: ./src/components/Icon/Calendar/index.tsx
var Calendar = __webpack_require__(31552);
// EXTERNAL MODULE: ./src/components/Icon/BaseSvg.tsx
var BaseSvg = __webpack_require__(57586);
;// CONCATENATED MODULE: ./src/components/Icon/FlashOn/index.tsx




var FlashOn = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: props.className
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.166687 0.333496V7.66683H2.16669V13.6668L6.83335 5.66683H4.16669L6.16669 0.333496H0.166687Z"
        })
    }));
};
/* harmony default export */ var Icon_FlashOn = (FlashOn);

// EXTERNAL MODULE: ./src/components/Icon/Phone/index.tsx
var Phone = __webpack_require__(41800);
// EXTERNAL MODULE: ./src/components/Modal/ModalBase/index.tsx + 1 modules
var ModalBase = __webpack_require__(59850);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 21 modules
var Icon = __webpack_require__(81016);
// EXTERNAL MODULE: ./src/utils/get-translated-title.ts
var get_translated_title = __webpack_require__(22862);
// EXTERNAL MODULE: ./src/components/ConceptImage.tsx
var ConceptImage = __webpack_require__(24454);
// EXTERNAL MODULE: ./src/components/Translated.tsx
var Translated = __webpack_require__(36510);
// EXTERNAL MODULE: src/components/RequestContactCTA/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/RequestContactCTA/styles.css.ts.vanilla.css","source":"LnQ0cTJkdzEgewogIGJhY2tncm91bmQtY29sb3I6ICNGRkY1RTk7CiAgZGlzcGxheTogZmxleDsKICB3aWR0aDogMTAwJTsKICBhbGlnbi1pdGVtczogY2VudGVyOwp9Ci50NHEyZHczIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRkZGRkZGOwogIGJvcmRlcjogMXB4IHNvbGlkOwogIGJvcmRlci1jb2xvcjogI0Q0RDREMzsKfQoudDRxMmR3NCB7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICBjb2x1bW4tZ2FwOiAxNnB4OwogIGRpc3BsYXk6IGZsZXg7Cn0KLnQ0cTJkdzUgewogIG1heC13aWR0aDogMDsKfQoudDRxMmR3NiB7CiAgbWFyZ2luOiAwIGF1dG8gMjRweCBhdXRvOwogIG1heC13aWR0aDogMzAwcHg7Cn0KLnQ0cTJkdzcgewogIG1pbi1oZWlnaHQ6IDQwMHB4Owp9Ci50NHEyZHc4IHsKICBib3JkZXItY29sb3I6ICNCM0IzQjI7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(31675);
;// CONCATENATED MODULE: ./src/components/RequestContactCTA/styles.css.ts


var divider = 't4q2dw8';
var errorToast = 't4q2dw6';
var maxWidthZero = 't4q2dw5';
var requestContactItem = 't4q2dw4';
var requestInfoReasonButton = 't4q2dw3 tfghjghi tfghjgio tfghjgju tfghjggc tfghjgl6 tfghjga6 tfghjg1u tfghjg6 tfghjg9c _1b5wm207u';
var slotOuter = 't4q2dw7';
var warn = 't4q2dw1 tfghjger tfghjgf8 tfghjgb3 tfghjgbk tfghjghi tfghjgio tfghjgju tfghjggc tfghjg9l';
;// CONCATENATED MODULE: ./src/components/RequestContactCTA/requestContactFeedback.tsx















var RequestContactFeedback = function(param) {
    var listing = param.listing, requestType = param.requestType, similarPropertiesRef = param.similarPropertiesRef;
    var ref;
    var closeModal = (0,ModalContext/* useModal */.dd)().closeModal;
    var device = (0,Device/* useDevice */.Fy)();
    var isVisitType = requestType === "visit";
    var ref1 = (0,useTranslation/* default */.Z)(), lang = ref1.lang, t = ref1.t;
    (0,react.useEffect)(function() {
        (0,eventsHandlers/* handleShow */.Hf)(isVisitType ? "BookVisitFeedbackModal" : "BookCallFeedbackModal", "Open");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBase/* ModalBase */.e, {
        "data-testid": "request-feedback",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    alignSelf: "center",
                    paddingBottom: "m"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                    height: 106,
                    name: "phone",
                    width: 106
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                alignment: "center",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingBottom: "l"
                }),
                "data-testid": "request-feedback-title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                    components: {
                        0: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: index_es/* colorVariants.deepGreen600 */.Jj.deepGreen600
                        })
                    },
                    i18Key: isVisitType ? t("listing-detail:request_visit_modal_thank_you_title") : t("listing-detail:request_call_modal_thank_you_title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                alignment: "center",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingBottom: "xl"
                }),
                children: (0,get_translated_title/* default */.Z)((ref = listing.detail) === null || ref === void 0 ? void 0 : ref.titles, lang)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                strong: true,
                alignment: "center",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingBottom: "l"
                }),
                "data-testid": "request-feedback-title-2",
                children: isVisitType ? t("listing-detail:request_visit_modal_thank_you_title_2") : t("listing-detail:request_call_modal_thank_you_title_2")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    paddingBottom: "xl",
                    paddingX: {
                        mobile: "m",
                        tablet: "2xl"
                    },
                    rowGap: "m",
                    textAlign: "left"
                }),
                role: "list",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: requestContactItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Check */.Z.Check, {
                                className: classnames_default()(index_es/* colorVariants.deepGreen600 */.Jj.deepGreen600, (0,sprinkles_css/* sprinkles */.K)({
                                    flexShrink: 0
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                "data-testid": "request-feedback-bullet1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                                    i18Key: isVisitType ? "listing-detail:request_visit_modal_thankyou_item_1" : "listing-detail:RequestCall_ThankYou_Bullet1"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: requestContactItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Check */.Z.Check, {
                                className: classnames_default()(index_es/* colorVariants.deepGreen600 */.Jj.deepGreen600, (0,sprinkles_css/* sprinkles */.K)({
                                    flexShrink: 0
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                "data-testid": "request-feedback-bullet2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                                    i18Key: isVisitType ? "listing-detail:request_visit_modal_thankyou_item_2" : "listing-detail:request_feedback_call_bullet_2"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                center: true,
                className: (0,sprinkles_css/* sprinkles */.K)({
                    flexShrink: 0
                }),
                fullWidth: device === "mobile",
                label: Boolean(similarPropertiesRef === null || similarPropertiesRef === void 0 ? void 0 : similarPropertiesRef.current) ? t("listing-detail:form-body.success_button") : t("listing-detail:form-body.success_button_alt"),
                minWidth: 245,
                onClick: function() {
                    if (!(similarPropertiesRef === null || similarPropertiesRef === void 0 ? void 0 : similarPropertiesRef.current)) {
                        (0,eventsHandlers/* handleClick */.qk)("RequestContactModalThankYou", "ToListingPage");
                        closeModal();
                        return;
                    }
                    (0,eventsHandlers/* handleClick */.qk)("RequestContactModalThankYou", "ToSimilarPropertiesFromRequestContactModalThankYou");
                    closeModal();
                    setTimeout(function() {
                        similarPropertiesRef === null || similarPropertiesRef === void 0 ? void 0 : similarPropertiesRef.current.scrollIntoView({
                            behavior: "smooth"
                        });
                    }, 500);
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(21565);
// EXTERNAL MODULE: ./src/context/AuthProvider/index.ts + 2 modules
var AuthProvider = __webpack_require__(95374);
// EXTERNAL MODULE: ./src/context/BottomSheetContext.tsx + 2 modules
var BottomSheetContext = __webpack_require__(88628);
// EXTERNAL MODULE: ./src/design-lib/components/Toast/index.tsx
var Toast = __webpack_require__(15947);
// EXTERNAL MODULE: ./src/lib/api-gluglu-auth.ts
var api_gluglu_auth = __webpack_require__(636);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(63847);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(61978);
// EXTERNAL MODULE: ./src/utils/date.ts
var utils_date = __webpack_require__(41906);
;// CONCATENATED MODULE: ./src/utils/date-utils.ts



/** From the nex 10 days returns an array of dates excluding weekend days */ var getContactDates = function() {
    var fromToday = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, dayToGenerate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    var dateList = [];
    var offset = fromToday ? 0 : 1;
    for(var i = 0; i < dayToGenerate; i++){
        var date = addBusinessDays(new Date(), i + offset);
        dateList.push(getStartDatetime(date));
    }
    var d = new Date();
    d.setHours(16, 0, 0, 0);
    return dateList.filter(function(date) {
        if (isToday(date)) {
            return date.getHours() < 18;
        }
        return date > d;
    });
};
var getVisitDates = function() {
    var fromToday = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dateList = [];
    var offset = fromToday ? 0 : 1;
    for(var i = 0; i < 5; i++){
        var date = addBusinessDays(new Date(), i + offset);
        dateList.push(getStartDatetime(date));
    }
    var d = new Date();
    d.setHours(16, 0, 0, 0);
    return dateList.filter(function(date) {
        if (isToday(date)) {
            return date.getHours() < 18;
        }
        return date > d;
    });
};
var getStartDatetime = function(d) {
    if (isToday(d)) {
        var d1 = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours() + 2, 0, 0);
        if (d1.getHours() >= 9) return d1;
        d1.setHours(9, 0, 0);
        return d1;
    }
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 9, 0, 0);
};
function mapDatesToLabelValue(dates, lang) {
    var language = utils_date/* locales */.k1[lang] || "en-GB";
    return dates.map(function(date) {
        return {
            date: date,
            label: new Intl.DateTimeFormat(language, {
                day: "numeric",
                month: "short",
                weekday: "short"
            }).format(date),
            value: date.toISOString().substring(0, 10)
        };
    }).sort(function(date1, date2) {
        return date1.date.getTime() - date2.date.getTime();
    });
}
function getAvailableSchedulingDates() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    date.setHours(9, 0, 0, 0);
    date = dayjs(date).add(1, "day").toDate() // params only for testing
    ;
    var dateList = [];
    for(var i = 0; dateList.length < 10; i++){
        var nextDay = addDays(date, i);
        if (!isSunday(nextDay)) {
            dateList.push(nextDay);
        }
    }
    return dateList;
}
var date_utils_formatTime = function(date) {
    return "".concat(date.getHours(), ":").concat(date.toISOString().substring(14, 16));
};
var isSunday = function(date) {
    return date.getDay() === 0;
};
var isToday = function(date) {
    var d = new Date(date);
    d.setHours(0, 0, 0, 0);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return d.getTime() === today.getTime();
};
var addBusinessDays = function(date, n) {
    var d = new Date(date);
    for(var i = 0; i < n; i++){
        switch(d.getDay()){
            case 5:
                d = addDays(d, 3);
                break;
            case 6:
                d = addDays(d, 2);
                break;
            default:
                d = addDays(d, 1);
                break;
        }
    }
    return d;
};
// TO BE REMOVED
var getLocalizedDate = function(date, timeSlot, lang) {
    var dateNumber = date.getDate();
    var language = locales[lang] || "en-GB";
    var month = new Intl.DateTimeFormat(language, {
        month: "long"
    }).format(date);
    var time = timeSlot !== "" ? timeSlot.split("-")[0] : "--:--";
    return {
        date_number: "".concat(dateNumber),
        month: month,
        time: time
    };
};
var getReminderLocalizedDate = function(date, lang) {
    var language = utils_date/* locales */.k1[lang] || "en-GB";
    var dateNumber = date.getDate();
    var dayOfTheWeek = new Intl.DateTimeFormat(language, {
        weekday: "long"
    }).format(date);
    var month = new Intl.DateTimeFormat(language, {
        month: "long"
    }).format(date);
    var time = new Intl.DateTimeFormat(language, {
        hour: "numeric",
        minute: "numeric"
    }).format(date);
    return {
        date_number: "".concat(dateNumber),
        day_of_the_week: (0,lodash.capitalize)(dayOfTheWeek),
        month: (0,lodash.capitalize)(month),
        time: time
    };
};
var addDays = function(date, amountDays) {
    return dayjs_min_default()(date).add(amountDays, "day").toDate();
};

;// CONCATENATED MODULE: ./src/utils/encode-visit-hours.ts

/** Format date to YYYY-MM-DD format for browser compatibility */ var formatDate = function(year, month, day) {
    var parsedMonth = month >= 10 ? month : "0".concat(month);
    var parsedDay = day >= 10 ? day : "0".concat(day);
    return "".concat(year, "-").concat(parsedMonth, "-").concat(parsedDay);
};
/** Encodes the information about the time range of a booked visit in a format accepted by the backend */ var encodeVisitHours = function(date, hour) {
    var month = date.getMonth() + 1 // getMonth is zero-based 🥲
    ;
    var day = date.getDate();
    var year = date.getFullYear();
    var ref = (0,src_sliced_to_array/* default */.Z)(hour.split("-"), 2), startHour = ref[0], endHour = ref[1];
    var end = new Date(formatDate(year, month, day));
    var start = new Date(formatDate(year, month, day));
    end.setHours(parseInt(endHour));
    start.setHours(parseInt(startHour));
    return {
        end: end,
        start: start
    };
};
var formatTwoDigitMinutes = function(date) {
    return (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
};
var decodeVisitHours = function(visitDate) {
    return {
        endHour: "".concat(visitDate.end.getHours(), ":").concat(formatTwoDigitMinutes(visitDate.end)),
        startHour: "".concat(visitDate.start.getHours(), ":").concat(formatTwoDigitMinutes(visitDate.start))
    };
};

// EXTERNAL MODULE: ./src/utils/phoneNumberValidator.ts
var phoneNumberValidator = __webpack_require__(13917);
// EXTERNAL MODULE: ./src/components/auth/UserAuthentication/index.ts + 27 modules
var UserAuthentication = __webpack_require__(21682);
// EXTERNAL MODULE: ./src/components/Icon/CasavoLogoSmall/index.tsx
var CasavoLogoSmall = __webpack_require__(5260);
;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/CasavoPropertyTitle.tsx







var CasavoPropertyTitle = function(param) {
    var className = param.className, _hideLogo = param.hideLogo, hideLogo = _hideLogo === void 0 ? false : _hideLogo, titles = param.titles;
    var lang = (0,useTranslation/* default */.Z)().lang;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((0,sprinkles_css/* sprinkles */.K)({
            alignItems: "center",
            display: "flex",
            gap: "s-m",
            paddingBottom: "m"
        }), className),
        "data-testid": "casavo-property-title",
        children: [
            !hideLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(CasavoLogoSmall/* default */.Z, {
                "aria-hidden": "true",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    flexShrink: 0
                }),
                width: 16
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                color: "greyscale500",
                children: (0,get_translated_title/* default */.Z)(titles, lang)
            })
        ]
    });
};
/* harmony default export */ var ContactAgencyForm_CasavoPropertyTitle = (CasavoPropertyTitle);

// EXTERNAL MODULE: ./src/components/Icon/Chevron/index.tsx + 1 modules
var Chevron = __webpack_require__(71169);
// EXTERNAL MODULE: ./src/utils/locale-variables/index.ts
var locale_variables = __webpack_require__(98640);
// EXTERNAL MODULE: ./src/components/Disclaimer/index.tsx
var Disclaimer = __webpack_require__(6544);
// EXTERNAL MODULE: src/components/FormFields/FormikCheckbox/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/FormFields/FormikCheckbox/styles.css.ts.vanilla.css","source":"LnFsZXp3czAgewogIHVzZXItc2VsZWN0OiBub25lOwp9Ci5xbGV6d3MxIHsKICAtd2Via2l0LWFwcGVhcmFuY2U6IG5vbmU7CiAgYmFja2dyb3VuZC1jb2xvcjogI0ZGRkZGRjsKICBib3JkZXI6IDFweCBzb2xpZDsKICBib3JkZXItY29sb3I6IHJnYmEoNTEsIDY4LCA4NCwgMC4zKTsKICBib3JkZXItcmFkaXVzOiA0cHg7CiAgY3Vyc29yOiBwb2ludGVyOwogIGZsZXgtc2hyaW5rOiAwOwogIGhlaWdodDogMjRweDsKICB3aWR0aDogMjRweDsKfQoucWxlendzMTpjaGVja2VkIHsKICBhbmltYXRpb246IHNjYWxlIC4ycyBlYXNlLWluLW91dDsKICBiYWNrZ3JvdW5kOiAjMDYzRDM5IHVybCgvbGlzYS9pbWFnZXMvY2hlY2tlZC5zdmcpIG5vLXJlcGVhdCBjZW50ZXIgY2VudGVyOwogIGJhY2tncm91bmQtc2l6ZTogMTBweCAxMHB4OwogIGJvcmRlcjogMDsKfQoucWxlendzMyB7CiAgYm9yZGVyLWNvbG9yOiAjRUI1NzU3Owp9Ci5xbGV6d3M0IHsKICBjb2xvcjogcmdiYSgyOSwyOSwyNywwLjgpOwogIGZvbnQtc2l6ZTogMTBweDsKICBtYXJnaW4tdG9wOiA0cHg7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var _vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(71481);
;// CONCATENATED MODULE: ./src/components/FormFields/FormikCheckbox/styles.css.ts

var checkboxSubtext = 'qlezws4';
var formikCheckbox = {'default':'qlezws1',error:'qlezws3 qlezws1'};
var formikCheckboxCaption = 'qlezws0';
;// CONCATENATED MODULE: ./src/components/FormFields/FormikCheckbox/index.tsx








var FormikCheckbox = function(param) {
    var _center = param.center, center = _center === void 0 ? true : _center, className = param.className, handleTracking = param.handleTracking, id = param.id, label = param.label, name = param.name, required = param.required, subText = param.subText;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)({
        name: name
    }), 2), field = ref[0], meta = ref[1];
    var onChange = field.onChange, value = field.value;
    var error = meta.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className, (0,sprinkles_css/* sprinkles */.K)({
            display: "flex",
            justifyContent: center ? "center" : "flex-start",
            marginBottom: "s",
            userSelect: "none"
        })),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                checked: value,
                className: error ? formikCheckbox.error : formikCheckbox["default"],
                "data-testid": "checkbox-".concat(id),
                id: id,
                name: name,
                required: required,
                type: "checkbox",
                onChange: function(e) {
                    onChange(e);
                    typeof handleTracking === "function" && handleTracking();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginLeft: "m"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        strong: true,
                        as: "label",
                        className: classnames_default()(formikCheckboxCaption, (0,sprinkles_css/* sprinkles */.K)({
                            cursor: "pointer"
                        })),
                        htmlFor: id,
                        children: required ? "".concat(label, " *") : label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: checkboxSubtext,
                        children: subText
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/FormFields/FormikInput/index.tsx + 3 modules
var FormikInput = __webpack_require__(77995);
;// CONCATENATED MODULE: ./src/components/ReadMoreToggle/index.tsx


var ReadMoreToggle = function(param) {
    var className = param.className, fullText = param.fullText, shortText = param.shortText;
    var detailsRef = (0,react.useRef)(null);
    var clickHandler = function() {
        if (detailsRef.current) {
            detailsRef.current.open = false;
        }
        toggleSummary();
    };
    var ref = (0,react.useState)(true), showSummary = ref[0], setShowSummary = ref[1];
    var toggleSummary = function() {
        return setShowSummary(!showSummary);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "read-more-toggle",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
            ref: detailsRef,
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("summary", {
                    style: {
                        visibility: showSummary ? "visible" : "hidden"
                    },
                    onClick: toggleSummary,
                    children: shortText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    onClick: clickHandler,
                    children: fullText
                })
            ]
        })
    });
};
/* harmony default export */ var components_ReadMoreToggle = (ReadMoreToggle);

;// CONCATENATED MODULE: ./src/components/RequestContactCTA/RequestContactForm.tsx























var RequestContactForm = function(param) {
    var isVisitRequestType = param.isVisitRequestType, onBack = param.onBack, showErrorMessage = param.showErrorMessage, submitting = param.submitting;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var user = (0,AuthProvider/* useAuthentication */.JL)().user;
    var errorRef = (0,react.useRef)(null);
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)("name"), 3), _ = ref1[0], __ = ref1[1], ref2 = ref1[2], setNameValue = ref2.setValue;
    (0,react.useEffect)(function() {
        if (user) {
            var name = (user === null || user === void 0 ? void 0 : user.first_name) && (user === null || user === void 0 ? void 0 : user.last_name) ? "".concat(user === null || user === void 0 ? void 0 : user.first_name, " ").concat(user === null || user === void 0 ? void 0 : user.last_name) : "";
            setNameValue(name);
        }
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styles_css/* marginBottom.s */.yl.s,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                    required: true,
                    id: "name",
                    label: t("contact-form:casavo.name"),
                    name: "name",
                    type: "text",
                    onClick: function() {
                        return navigator.userAgent.match(/android/i) && window.scrollTo(0, 0);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styles_css/* marginBottom.l */.yl.l,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                    required: true,
                    id: "phoneNumber",
                    inputMode: "numeric",
                    label: t("contact-form:phone"),
                    name: "phoneNumber",
                    prefixName: "phoneNumberPrefix",
                    type: "tel"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styles_css/* marginBottom.s */.yl.s,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCheckbox, {
                    center: false,
                    id: "marketing-communications",
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                        components: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "0")
                        ],
                        i18nKey: "privacy:gdpr.marketing-consent-checkbox"
                    }),
                    name: "hasAcceptedMarketing",
                    subText: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("privacy:gdpr.marketing-consent-full-text")
                    })
                })
            }),
            (0,locale_variables/* isLocaleEnabledFor */.vw)("consentsCasavoForm", lang) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCheckbox, {
                center: false,
                className: styles_css/* marginRight.4xl */.wz["4xl"],
                id: "consentForCasavoMortgageService",
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    components: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "0")
                    ],
                    i18nKey: "privacy:mortgage.title"
                }),
                name: "consentForCasavoMortgageService",
                subText: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreToggle, {
                    fullText: t("privacy:mortgage.full-text"),
                    shortText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                        components: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    textDecoration: "underline"
                                })
                            }, "0")
                        ],
                        i18nKey: "privacy:mortgage.short-text"
                    })
                })
            }),
            showErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: errorRef,
                "data-testid": "error-message",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* Toast */.F, {
                    className: errorToast,
                    styleType: "error",
                    title: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                        components: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, "0")
                        ],
                        i18nKey: "listing-detail:request_visit_error"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(warn),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.PhoneSolid */.Z.PhoneSolid, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                            components: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    style: {
                                        color: theme/* theme.colors.warning700 */.r.colors.warning700
                                    }
                                }, "0")
                            ],
                            i18nKey: isVisitRequestType ? t("listing-detail:RequestVisit_Modal_Warn") : t("listing-detail:BookCall_Modal_Warn")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclaimer/* default */.Z, {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginTop: "m",
                    paddingBottom: "m"
                }),
                cta: isVisitRequestType ? t("listing-detail:request_visit") : t("listing-detail:request_call")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(styles_css/* gridCenter */.m9, styles_css/* marginBottom.l */.yl.l, (0,sprinkles_css/* sprinkles */.K)({
                    marginTop: "auto"
                })),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        ariaLabel: "back to previous step",
                        className: maxWidthZero,
                        Icon: function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Chevron */.Z.Chevron, {
                                direction: "left"
                            });
                        },
                        styleVariant: "tertiary",
                        onClick: onBack
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        center: true,
                        "data-testid": "submit-request",
                        disabled: submitting,
                        Icon: function(props) {
                            return isVisitRequestType ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar/* default */.Z, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
                        },
                        label: isVisitRequestType ? t("listing-detail:request_visit") : t("listing-detail:request_call"),
                        loading: submitting,
                        minWidth: 225,
                        type: "submit"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: src/components/SelectableButton/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/SelectableButton/styles.css.ts.vanilla.css","source":"LmZ3cW44NTAgewogIGJhY2tncm91bmQtY29sb3I6ICNGRkZGRkY7CiAgYm9yZGVyLWNvbG9yOiAjQjNCM0IyOwogIGJvcmRlci1yYWRpdXM6IDRweDsKICBib3JkZXItc3R5bGU6IHNvbGlkOwogIGJvcmRlci13aWR0aDogMXB4OwogIGNvbG9yOiAjMUQxRDFCOwogIGN1cnNvcjogcG9pbnRlcjsKICBtaW4td2lkdGg6IDcwcHg7CiAgcGFkZGluZzogOHB4OwogIHNjcm9sbC1zbmFwLWFsaWduOiBzdGFydDsKICB0cmFuc2l0aW9uOiBhbGwgMC4zcyBlYXNlOwp9Ci5md3FuODUyIHsKICBjdXJzb3I6IG5vdC1hbGxvd2VkOwp9Ci5md3FuODUzIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRkZGNUU5OwogIGJvcmRlci1jb2xvcjogI0ZGOTkxRjsKICBib3JkZXItd2lkdGg6IDJweDsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_LmZ3cW44NTAgewogIGJhY2tncm91bmQtY29sb3I6ICNGRkZGRkY7CiAgYm9yZGVyLWNvbG9yOiAjQjNCM0IyOwogIGJvcmRlci1yYWRpdXM6IDRweDsKICBib3JkZXItc3R5bGU6IHNvbGlkOwogIGJvcmRlci13aWR0aDogMXB4OwogIGNvbG9yOiAjMUQxRDFCOwogIGN1cnNvcjogcG9pbnRlcjsKICBtaW4td2lkdGg6IDcwcHg7CiAgcGFkZGluZzogOHB4OwogIHNjcm9sbC1zbmFwLWFsaWduOiBzdGFydDsKICB0cmFuc2l0aW9uOiBhbGwgMC4zcyBlYXNlOwp9Ci5md3FuODUyIHsKICBjdXJzb3I6IG5vdC1hbGxvd2VkOwp9Ci5md3FuODUzIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRkZGNUU5OwogIGJvcmRlci1jb2xvcjogI0ZGOTkxRjsKICBib3JkZXItd2lkdGg6IDJweDsKfQ_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(46151);
;// CONCATENATED MODULE: ./src/components/SelectableButton/styles.css.ts

var selectableButton = {'default':'fwqn850',disabled:'fwqn852 fwqn850',selected:'fwqn853 fwqn850'};
;// CONCATENATED MODULE: ./src/components/SelectableButton/index.tsx





var SelectableButton = function(param) {
    var children = param.children, className = param.className, dataTestId = param.dataTestId, disabled = param.disabled, onSelect = param.onSelect, selected = param.selected, value = param.value;
    var getClass = function() {
        if (selected) return selectableButton.selected;
        if (disabled) return selectableButton.disabled;
        return selectableButton["default"];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "aria-checked": selected,
        className: classnames_default()(getClass(), className),
        "data-testid": dataTestId,
        role: "radio",
        tabIndex: 0,
        onClick: function() {
            onSelect(value);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
            alignment: "center",
            children: children
        })
    });
};

// EXTERNAL MODULE: src/components/ButtonCarousel/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ButtonCarousel/styles.css.ts.vanilla.css","source":"Ll8yb2sxbnQwIHsKICBjb2xvcjogIzUyNTI1MTsKICB0cmFuc2Zvcm06IHJvdGF0ZSg5MGRlZyk7Cn0KLl8yb2sxbnQxIHsKICBjb2xvcjogIzUyNTI1MTsKICB0cmFuc2Zvcm06IHJvdGF0ZSgtOTBkZWcpOwp9Ci5fMm9rMW50MyB7CiAgbWF4LXdpZHRoOiAyNTBweDsKICBncmlkLWF1dG8tZmxvdzogY29sdW1uOwogIC1tcy1vdmVyZmxvdy1zdHlsZTogbm9uZTsKICBvdmVyc2Nyb2xsLWJlaGF2aW9yLXg6IGNvbnRhaW47CiAgc2Nyb2xsLXNuYXAtdHlwZTogeCBtYW5kYXRvcnk7CiAgc2Nyb2xsYmFyLXdpZHRoOiBub25lOwp9Ci5fMm9rMW50Mzo6LXdlYmtpdC1zY3JvbGxiYXIgewogIGRpc3BsYXk6IG5vbmU7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_Ll8yb2sxbnQwIHsKICBjb2xvcjogIzUyNTI1MTsKICB0cmFuc2Zvcm06IHJvdGF0ZSg5MGRlZyk7Cn0KLl8yb2sxbnQxIHsKICBjb2xvcjogIzUyNTI1MTsKICB0cmFuc2Zvcm06IHJvdGF0ZSgtOTBkZWcpOwp9Ci5fMm9rMW50MyB7CiAgbWF4LXdpZHRoOiAyNTBweDsKICBncmlkLWF1dG8tZmxvdzogY29sdW1uOwogIC1tcy1vdmVyZmxvdy1zdHlsZTogbm9uZTsKICBvdmVyc2Nyb2xsLWJlaGF2aW9yLXg6IGNvbnRhaW47CiAgc2Nyb2xsLXNuYXAtdHlwZTogeCBtYW5kYXRvcnk7CiAgc2Nyb2xsYmFyLXdpZHRoOiBub25lOwp9Ci5fMm9rMW50Mzo6LXdlYmtpdC1zY3JvbGxiYXIgewogIGRpc3BsYXk6IG5vbmU7Cn0_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(82176);
;// CONCATENATED MODULE: ./src/components/ButtonCarousel/styles.css.ts


var carousel = '_2ok1nt3 tfghjgk9 tfghjggr tfghjghx tfghjgj3 tfghjg1x tfghjg9f _1b5wm20br';
var chevronLeft = '_2ok1nt0';
var chevronRight = '_2ok1nt1';
;// CONCATENATED MODULE: ./src/components/ButtonCarousel/index.tsx








var ButtonCarousel = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var className = param.className, name = param.name, onSelectedItem = param.onSelectedItem, options = param.options, value = param.value;
    var scrollCarousel = function scrollCarousel(direction) {
        var position = carouselRef.current.scrollLeft;
        carouselRef.current.scrollTo({
            behavior: "smooth",
            left: direction === "prev" ? position - scrollAmount : position + scrollAmount
        });
    };
    var carouselRef = (0,react.useRef)(null);
    var t = (0,useTranslation/* default */.Z)().t;
    (0,react.useImperativeHandle)(ref, function() {
        return {
            current: carouselRef.current,
            resetScroll: resetScroll
        };
    });
    var resetScroll = function() {
        if (carouselRef.current) {
            carouselRef.current.scrollTo({
                behavior: "smooth",
                left: 0
            });
        }
    };
    var onSelect = function(v, i) {
        onSelectedItem(options[i]);
    };
    /** width of a button (80px) + gap (16px) */ var scrollAmount = 96;
    var checkIsSelected = function(value, selectedValue) {
        if (name === "hourRange") return value.toString() === selectedValue.toString();
        return value.toString().substring(0, 10) === selectedValue.toString().substring(0, 10);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((0,sprinkles_css/* sprinkles */.K)({
                display: "flex"
            }), className),
            role: "radiogroup",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    "aria-label": t("common:prev"),
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        padding: "m"
                    }),
                    type: "button",
                    onClick: function() {
                        return scrollCarousel("prev");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                        className: chevronLeft
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: carouselRef,
                    className: carousel,
                    "data-testid": "carousel-".concat(name),
                    children: options.map(function(option, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectableButton, {
                            dataTestId: "carousel-".concat(name, "-").concat(option.value),
                            selected: checkIsSelected(option.value, value),
                            value: option.value,
                            onSelect: function(s) {
                                return onSelect(s, idx);
                            },
                            children: option.label
                        }, option.value);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    "aria-label": t("common:next"),
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        padding: "m"
                    }),
                    type: "button",
                    onClick: function() {
                        return scrollCarousel("next");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                        className: chevronRight
                    })
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./src/utils/slot-utils.ts




var addMinutes = function(date, duration) {
    return dayjs_min_default()(date).add(duration, "minutes").toDate();
};
var slotMaker = function(slots, slotDurationMin, slotLimit) {
    if (slots.length === 0) return [];
    var ref = (0,src_sliced_to_array/* default */.Z)(slots[slots.length - 1], 2), end = ref[1];
    if (addMinutes(end, slotDurationMin).getTime() > slotLimit.getTime()) return slots;
    var nextSlots = (0,_to_consumable_array/* default */.Z)(slots).concat([
        [
            end,
            addMinutes(end, slotDurationMin)
        ]
    ]);
    return slotMaker(nextSlots, slotDurationMin, slotLimit);
};
var getSlotsFromDate = function(d) {
    var excludeLunch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var slotDuration = 60;
    var limit = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 18, 0, 0);
    var startSlot = (0,_to_consumable_array/* default */.Z)(addMinutes(d, slotDuration) <= limit ? [
        [
            d,
            addMinutes(d, slotDuration)
        ]
    ] : []);
    var slots = slotMaker(startSlot, slotDuration, limit);
    if (!excludeLunch) return slots;
    return slots.filter(function(slot) {
        if (slot[0].getHours() === 13) return false;
        return true;
    });
};
var mapSlotToLabelValue = function(ds) {
    return ds.map(function(value) {
        var _value = (0,src_sliced_to_array/* default */.Z)(value, 2), start = _value[0], end = _value[1];
        var label = "".concat(start.getHours(), " - ").concat(end.getHours());
        return {
            label: label,
            value: label
        };
    });
};
var mapAvailableSchedulingTimeSlot = function(ds) {
    return ds.map(fromSlotToDateValues);
};
var fromSlotToDateValues = function(slot) {
    var _slot = _sliced_to_array(slot, 2), from = _slot[0], to = _slot[1];
    var label = "".concat(formatTime(from), " ").concat(formatTime(to));
    return {
        label: label,
        slots: slot,
        value: "".concat(formatTime(from), "-").concat(formatTime(to))
    };
};

;// CONCATENATED MODULE: ./src/components/RequestContactCTA/RequestContactSlot.tsx











var RequestContactSlot = function(param) {
    var dateList = param.dateList, isVisitRequestType = param.isVisitRequestType;
    var ref = (0,react.useState)([]), timeSlotList = ref[0], setTimeSlotList = ref[1];
    var ref1 = (0,react.useState)(false), isSlotDateUpdated = ref1[0], setIsSlotDateUpdated = ref1[1];
    var ref2 = [
        (0,react.useRef)(null),
        (0,react.useRef)(null)
    ], dateSlotRef = ref2[0], timeSlotRef = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)("date"), 3), _ = ref3[0], ref4 = ref3[1], errorDate = ref4.error, touchedDate = ref4.touched, dateValue = ref4.value, ref5 = ref3[2], setDateValue = ref5.setValue;
    var ref6 = (0,src_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)("hourRange"), 3), __ = ref6[0], ref7 = ref6[1], errorSlot = ref7.error, touchedSlot = ref7.touched, slotValue = ref7.value, ref8 = ref6[2], setSlotValue = ref8.setValue;
    (0,react.useEffect)(function() {
        var slotList = getSlotsFromDate(new Date(dateValue), !isVisitRequestType);
        setTimeSlotList(slotList);
    }, [
        dateValue,
        isVisitRequestType
    ]);
    var t = (0,useTranslation/* default */.Z)().t;
    var onSelectedDate = function(d) {
        var ref;
        setIsSlotDateUpdated(true);
        setDateValue(d.date.toISOString());
        setSlotValue("");
        (ref = timeSlotRef.current) === null || ref === void 0 ? void 0 : ref.resetScroll();
    };
    var onSelectedSlot = function(d) {
        setSlotValue(d.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: slotOuter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                strong: true,
                className: styles_css/* marginBottom.m */.yl.m,
                children: isVisitRequestType ? t("listing-detail:select_request_visit_date") : t("listing-detail:select_call_date")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCarousel, {
                ref: dateSlotRef,
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginBottom: "3xl"
                }),
                error: errorDate,
                name: "dayRange",
                options: dateList,
                touched: touchedDate,
                value: dateValue,
                onSelectedItem: onSelectedDate
            }),
            isSlotDateUpdated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                        strong: true,
                        className: styles_css/* marginBottom.m */.yl.m,
                        children: isVisitRequestType ? t("listing-detail:select_visit_time") : t("listing-detail:select_call_time")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCarousel, {
                        ref: timeSlotRef,
                        error: errorSlot,
                        name: "hourRange",
                        options: mapSlotToLabelValue(timeSlotList),
                        touched: touchedSlot,
                        value: slotValue,
                        onSelectedItem: onSelectedSlot
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/design-lib/components/Divider/index.tsx + 1 modules
var Divider = __webpack_require__(84494);
;// CONCATENATED MODULE: ./src/components/RequestContactCTA/RequestInfo.tsx














var getEventOnInfoSelection = function(infoValue) {
    switch(infoValue){
        case InfoSelectionEnum.MORE_PHOTOS:
            return "ReasonList-Photo";
        case InfoSelectionEnum.OTHER:
            return "ReasonList-Question";
        case InfoSelectionEnum.VISIT:
            return "ReasonList-Visit";
    }
};
var RequestInfo = function(param) {
    var onSelection = param.onSelection;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)("reason"), 3), _ = ref[0], ref1 = ref[1], reason = ref1.value, ref2 = ref[2], setReason = ref2.setValue;
    var t = (0,useTranslation/* default */.Z)().t;
    var onItemClicked = function(infoValue) {
        (0,eventsHandlers/* handleClick */.qk)("RequestCallModal", getEventOnInfoSelection(infoValue));
        if ([
            InfoSelectionEnum.MORE_PHOTOS,
            InfoSelectionEnum.OTHER
        ].includes(infoValue)) {
            setReason(infoValue);
        }
        onSelection(infoValue);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            paddingBottom: "l"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: classnames_default()(requestInfoReasonButton, (0,sprinkles_css/* sprinkles */.K)({
                    marginBottom: "l"
                })),
                onClick: function() {
                    return onItemClicked(InfoSelectionEnum.MORE_PHOTOS);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(styles_css/* flexCenter */._7, styles_css/* gap.m */.SG.m),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                                height: 50,
                                name: "home-chapter",
                                width: 50
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                children: t("listing-detail:RequestCallModal_Reasonlist_MorePhoto")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Chevron */.Z.Chevron, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: requestInfoReasonButton,
                onClick: function() {
                    return onItemClicked(InfoSelectionEnum.OTHER);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(styles_css/* flexCenter */._7, styles_css/* gap.m */.SG.m),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                                height: 50,
                                name: "faq1",
                                width: 50
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                children: t("listing-detail:RequestCallModal_Reasonlist_Questions")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Chevron */.Z.Chevron, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                className: divider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: requestInfoReasonButton,
                onClick: function() {
                    return onSelection(InfoSelectionEnum.VISIT);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(styles_css/* flexCenter */._7, styles_css/* gap.m */.SG.m),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                                height: 50,
                                name: "home-chapter-woman",
                                width: 50
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                children: t("listing-detail:RequestCallModal_Reasonlist_Visit")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Chevron */.Z.Chevron, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/RequestContactCTA/RequestContactFlow.tsx





































var InfoSelectionEnum;
(function(InfoSelectionEnum) {
    InfoSelectionEnum["MORE_PHOTOS"] = "MORE_PHOTOS";
    InfoSelectionEnum["OTHER"] = "OTHER";
    InfoSelectionEnum["VISIT"] = "VISIT";
})(InfoSelectionEnum || (InfoSelectionEnum = {}));
var ERROR_ENUM;
(function(ERROR_ENUM) {
    ERROR_ENUM["ALREADY_BOOKED_SLOT"] = "ALREADY_BOOKED_SLOT";
    ERROR_ENUM["GENERIC_ERROR"] = "GENERIC_ERROR";
})(ERROR_ENUM || (ERROR_ENUM = {}));
var WIZARD_ENUM;
(function(WIZARD_ENUM) {
    WIZARD_ENUM["FIRST_STEP"] = "FIRST_STEP";
    WIZARD_ENUM["FORM_STEP"] = "FORM_STEP";
    WIZARD_ENUM["LOGIN_STEP"] = "LOGIN_STEP";
})(WIZARD_ENUM || (WIZARD_ENUM = {}));
var getValidationSchema = function(isVisitRequestType, t) {
    var standardParams = {
        consentForCasavoMortgageService: es/* boolean */.O7(),
        date: es/* string */.Z_().required(t("common:required-field-message")),
        hasAcceptedMarketing: es/* boolean */.O7(),
        hourRange: es/* string */.Z_().required(t("common:required-field-message")),
        name: es/* string */.Z_().required(t("common:required-field-message")),
        phoneNumber: (0,phoneNumberValidator/* getPhoneNumberValidator */.i)(t("common:required-field-message"), t("common:invalid-phone-message")),
        phoneNumberPrefix: es/* string */.Z_().required()
    };
    var visitParams = {
        date: isVisitRequestType ? es/* string */.Z_().required(t("common:required-field-message")) : es/* string */.Z_(),
        hourRange: isVisitRequestType ? es/* string */.Z_().required(t("common:required-field-message")) : es/* string */.Z_()
    };
    var infoParams = {
        reason: !isVisitRequestType ? es/* mixed */.nK().oneOf([
            InfoSelectionEnum.MORE_PHOTOS,
            InfoSelectionEnum.OTHER
        ]).required(t("common:required-field-message")) : es/* mixed */.nK().oneOf([
            InfoSelectionEnum.MORE_PHOTOS,
            InfoSelectionEnum.OTHER,
            null
        ])
    };
    return es/* object */.Ry((0,_object_spread/* default */.Z)({}, standardParams, visitParams, infoParams));
};
var REQUEST_VISIT_INFO_AFTER_LOGIN = "CASAVO@REQUEST_VISIT_INFO_AFTER_LOGIN";
var getDatetime = function(initDate, hourRange) {
    var date = new Date(initDate);
    var hrs = hourRange !== "" ? parseInt(hourRange.split(" - ")[0], 10) : date.getHours();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hrs, 0, 0, 0);
};
var RequestContactFlow = function(param) {
    var listing = param.listing, onSuccess = param.onSuccess, requestType = param.requestType;
    var ref = (0,react.useState)(WIZARD_ENUM.FIRST_STEP), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(false), submitting = ref1[0], setSubmitting = ref1[1];
    var ref2 = (0,react.useState)(false), showErrorMessage = ref2[0], setShowErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(requestType), currentRequestType = ref3[0], setCurrentRequestType = ref3[1];
    // const [isEmailInvalid, setIsEmailInvalid] = useState(false)
    var ref4 = (0,react.useState)(undefined), hasError = ref4[0], setError = ref4[1];
    var ref5 = (0,BottomSheetContext/* useBottomSheet */.a)(), closeBottomSheet = ref5.closeBottomSheet, openBottomSheet = ref5.openBottomSheet;
    var device = (0,Device/* useDevice */.Fy)();
    var ref6 = (0,AuthProvider/* useAuthentication */.JL)(), isLoading = ref6.isLoading, user = ref6.user;
    var ref7 = (0,src_sliced_to_array/* default */.Z)((0,esm/* useSessionStorage */.Xs)(REQUEST_VISIT_INFO_AFTER_LOGIN, null), 2), storedRequestData = ref7[0], setStoredRequestData = ref7[1];
    var isVisitRequestType = currentRequestType === "visit";
    var errorRef = (0,react.useRef)(null);
    var ref8 = (0,useTranslation/* default */.Z)(), lang = ref8.lang, t = ref8.t;
    var validationSchema = getValidationSchema(isVisitRequestType, t);
    var defaultLeadPhoneNumberPrefix = (0,prefix/* getPrefixFromCountryCode */.a)((0,prefix/* langToCountryCode */.J)(lang));
    var dateList = isVisitRequestType ? getContactDates(!isVisitRequestType, 15) : [];
    var initialDate = (storedRequestData === null || storedRequestData === void 0 ? void 0 : storedRequestData.requestType) === "visit" ? (storedRequestData === null || storedRequestData === void 0 ? void 0 : storedRequestData.date) || "" : "";
    var initHourRange = (storedRequestData === null || storedRequestData === void 0 ? void 0 : storedRequestData.requestType) === "visit" ? (storedRequestData === null || storedRequestData === void 0 ? void 0 : storedRequestData.hourRange) || "" : "";
    var initReason = (storedRequestData === null || storedRequestData === void 0 ? void 0 : storedRequestData.requestType) === "info" ? (storedRequestData === null || storedRequestData === void 0 ? void 0 : storedRequestData.reason) || null : null;
    var ref9 = (0,api_gluglu_auth/* initApi */.g8)(), bookVisit = ref9.bookVisit, requestInfoCasavoListing = ref9.requestInfoCasavoListing;
    (0,react.useEffect)(function() {
        if (showErrorMessage) {
            var ref;
            errorRef === null || errorRef === void 0 ? void 0 : (ref = errorRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        showErrorMessage
    ]);
    (0,react.useEffect)(function() {
        if (user && !isLoading && storedRequestData !== null) {
            setStep(WIZARD_ENUM.FORM_STEP);
            if (device === "mobile") {
                closeBottomSheet();
            }
        }
        return function() {
            if (user && !isLoading && storedRequestData !== null) {
                (0,isStorageSupported/* isStorageSupported */.p)(function() {
                    return sessionStorage;
                }) && sessionStorage.removeItem(REQUEST_VISIT_INFO_AFTER_LOGIN);
            }
        };
    }, [
        user,
        isLoading,
        storedRequestData
    ]);
    function onSubmitInfo(values) {
        return _onSubmitInfo.apply(this, arguments);
    }
    function _onSubmitInfo() {
        _onSubmitInfo = (0,_async_to_generator/* default */.Z)(function(values) {
            var payload, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowErrorMessage(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setSubmitting(true);
                        payload = {
                            consent_for_service_mortgage: values.consentForCasavoMortgageService,
                            consent_for_updates: values.hasAcceptedMarketing,
                            current_language: lang.toUpperCase(),
                            name: values.name,
                            phone_number: values.phoneNumberPrefix + values.phoneNumber.replace(/-/g, ""),
                            reason: values.reason,
                            tracking_client_id: getGAClientId()
                        };
                        return [
                            4,
                            requestInfoCasavoListing(listing.id, payload)
                        ];
                    case 2:
                        _state.sent();
                        setSubmitting(false);
                        onSuccess(currentRequestType);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setShowErrorMessage(true);
                        setSubmitting(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmitInfo.apply(this, arguments);
    }
    function onSubmitVisit(values) {
        return _onSubmitVisit.apply(this, arguments);
    }
    function _onSubmitVisit() {
        _onSubmitVisit = (0,_async_to_generator/* default */.Z)(function(values) {
            var visitSlot, payload, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowErrorMessage(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setSubmitting(true);
                        visitSlot = encodeVisitHours(new Date(values.date), values.hourRange);
                        payload = {
                            consentForCasavoMortgageService: values.consentForCasavoMortgageService,
                            currentLanguage: lang,
                            keepMeUpdated: values.hasAcceptedMarketing,
                            name: values.name,
                            phoneNumber: values.phoneNumberPrefix + values.phoneNumber.replace(/-/g, ""),
                            trackingClientId: getGAClientId(),
                            visitSlot: visitSlot
                        };
                        return [
                            4,
                            bookVisit(listing.id, payload)
                        ];
                    case 2:
                        _state.sent();
                        setSubmitting(false);
                        onSuccess(currentRequestType);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setShowErrorMessage(true);
                        setSubmitting(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmitVisit.apply(this, arguments);
    }
    var onBack = function() {
        setStep(WIZARD_ENUM.FIRST_STEP);
    };
    var onInfoSelection = function(reason) {
        if (reason === InfoSelectionEnum.VISIT) {
            setCurrentRequestType("visit");
            return;
        }
        if (user) {
            setStep(WIZARD_ENUM.FORM_STEP);
        } else {
            setStoredRequestData({
                reason: reason,
                requestType: "info"
            });
            showLoginWall();
        }
    };
    var showLoginWall = function() {
        if (device === "mobile") {
            openBottomSheet(/*#__PURE__*/ (0,jsx_runtime.jsx)(UserAuthentication/* UserAuthentication */.z, {
                conceptImage: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                    height: 80,
                    name: isVisitRequestType ? "write" : "phone",
                    width: 80
                }),
                mainTitle: isVisitRequestType ? "Login_RequestVisit_BottomSheet_Title" : "Login_FromContactFrom_Title",
                returnUrl: window.location.href,
                touchPoint: isVisitRequestType ? "FromBookVisit" : "FromContactForm",
                onLoggedIn: function() {
                    return closeBottomSheet();
                }
            }), {
                minHeight: 610
            });
        } else {
            setStep(WIZARD_ENUM.LOGIN_STEP);
        }
    };
    var onContinue = function(param) {
        var date = param.date, hourRange = param.hourRange;
        (0,eventsHandlers/* handleClick */.qk)(isVisitRequestType ? "BookVisitModalForm" : "ScheduleCallModalForm", "Continue");
        if (user) {
            setStep(WIZARD_ENUM.FORM_STEP);
        } else {
            setStoredRequestData({
                date: date,
                hourRange: hourRange,
                requestType: "visit"
            });
            showLoginWall();
        }
    };
    if (step === WIZARD_ENUM.LOGIN_STEP) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: styles_css/* backgroundColor.lightBlue */.Cz.lightBlue,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAuthentication/* UserAuthentication */.z, {
                conceptImage: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                    height: 120,
                    name: isVisitRequestType ? "write" : "phone",
                    width: 120
                }),
                mainTitle: isVisitRequestType ? "Login_RequestVisit_BottomSheet_Title" : "Login_FromContactFrom_Title",
                returnUrl: window.location.href,
                touchPoint: isVisitRequestType ? "FromBookVisit" : "FromContactForm"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((0,sprinkles_css/* sprinkles */.K)({
            display: "flex",
            flexDirection: "column",
            height: "100%",
            padding: "xl"
        }), styles_css/* backgroundColor.offWhite */.Cz.offWhite),
        children: [
            isVisitRequestType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                        className: styles_css/* marginBottom.l */.yl.l,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                            components: {
                                0: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: index_es/* colorVariants.deepGreen600 */.Jj.deepGreen600
                                })
                            },
                            i18Key: "listing-detail:request_visit_modal_title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_CasavoPropertyTitle, {
                        className: styles_css/* marginBottom.xl */.yl.xl,
                        titles: listing.detail.titles
                    })
                ]
            }),
            !isVisitRequestType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                        className: styles_css/* marginBottom.l */.yl.l,
                        children: t("listing-detail:request_call")
                    }),
                    step === WIZARD_ENUM.FIRST_STEP && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                        strong: true,
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginBottom: "2xl"
                        }),
                        children: t("contact-form:casavo.reason.placeholder")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: {
                    consentForCasavoMortgageService: false,
                    date: initialDate,
                    hasAcceptedMarketing: false,
                    hourRange: initHourRange,
                    name: "",
                    phoneNumber: "",
                    phoneNumberPrefix: defaultLeadPhoneNumberPrefix,
                    reason: initReason
                },
                validationSchema: validationSchema,
                onSubmit: isVisitRequestType ? onSubmitVisit : onSubmitInfo,
                children: function(param) {
                    var values = param.values;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                display: "flex",
                                flex: 1,
                                flexDirection: "column"
                            }),
                            children: [
                                step === WIZARD_ENUM.FIRST_STEP && isVisitRequestType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactSlot, {
                                            dateList: mapDatesToLabelValue(dateList, lang),
                                            isVisitRequestType: isVisitRequestType
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()(requestType === "info" && styles_css/* gridCenter */.m9, (0,sprinkles_css/* sprinkles */.K)({
                                                marginBottom: {
                                                    mobile: "m",
                                                    tablet: "xl"
                                                },
                                                marginTop: "auto"
                                            })),
                                            children: [
                                                requestType === "info" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                                    ariaLabel: "back to previous step",
                                                    className: maxWidthZero,
                                                    Icon: function() {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                                            direction: "left"
                                                        });
                                                    },
                                                    styleVariant: "tertiary",
                                                    onClick: function() {
                                                        return setCurrentRequestType("info");
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                                    iconRight: true,
                                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                                        alignSelf: "center",
                                                        marginX: "auto"
                                                    }),
                                                    "data-testid": "next-button",
                                                    disabled: values.date === "" || values.hourRange === "",
                                                    Icon: function() {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Chevron */.Z.Chevron, {});
                                                    },
                                                    label: t("listing-detail:schedule_visit_flow_next_button"),
                                                    minWidth: 210,
                                                    styleVariant: "primary",
                                                    type: "button",
                                                    onClick: function() {
                                                        onContinue(values);
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                step === WIZARD_ENUM.FIRST_STEP && currentRequestType === "info" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestInfo, {
                                    onSelection: onInfoSelection
                                }),
                                step === WIZARD_ENUM.FORM_STEP && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        isVisitRequestType && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                                            strong: true,
                                            className: styles_css/* marginBottom.xl */.yl.xl,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                i18nKey: isVisitRequestType ? "listing-detail:RequestVisit_Modal_Recap" : "listing-detail:BookCall_Modal_Recap",
                                                values: getReminderLocalizedDate(getDatetime(values.date, values.hourRange), lang)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactForm, {
                                            isVisitRequestType: isVisitRequestType,
                                            showErrorMessage: showErrorMessage,
                                            submitting: submitting,
                                            onBack: onBack
                                        }),
                                        hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "data-testid": "request-visit-error",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toast/* Toast */.F, {
                                                className: errorToast,
                                                styleType: "error",
                                                title: "",
                                                children: [
                                                    hasError === ERROR_ENUM.ALREADY_BOOKED_SLOT && /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                        components: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, "0")
                                                        ],
                                                        i18nKey: "listing-detail:slot_already_booked_error"
                                                    }),
                                                    hasError === ERROR_ENUM.GENERIC_ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                        components: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, "0")
                                                        ],
                                                        i18nKey: "listing-detail:request_visit_error"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/RequestContactCTA/RequestContactModal.tsx





var requestContactModalOptions = {
    desktopWidth: 492,
    overlay: true
};
var RequestContactModal = function(param) {
    var listing = param.listing, listingTitle = param.listingTitle, _requestType = param.requestType, requestType = _requestType === void 0 ? "visit" : _requestType, similarPropertiesRef = param.similarPropertiesRef;
    var ref = (0,react.useState)(null), feedbackRequestType = ref[0], setFeedbackRequestType = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: feedbackRequestType !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactFeedback, {
            listing: listing,
            listingTitle: listingTitle,
            requestType: feedbackRequestType || requestType,
            similarPropertiesRef: similarPropertiesRef
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBase/* ModalBase */.e, {
            noPadding: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactFlow, {
                listing: listing,
                requestType: requestType,
                onSuccess: function(type) {
                    setFeedbackRequestType(type);
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/RequestContactCTA/index.tsx













var RequestContactCTA = function(_param) {
    var className = _param.className, _isMobile = _param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, listing = _param.listing, listingTitle = _param.listingTitle, _requestType = _param.requestType, requestType = _requestType === void 0 ? "visit" : _requestType, similarPropertiesRef = _param.similarPropertiesRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "isMobile",
        "listing",
        "listingTitle",
        "requestType",
        "similarPropertiesRef"
    ]);
    var openModal = (0,ModalContext/* useModal */.dd)().openModal;
    var t = (0,useTranslation/* default */.Z)().t;
    var isVisitButton = requestType === "visit";
    var eventLabel = {
        call: "RequestCall",
        visit: "RequestVisit"
    }[requestType];
    var openRequestContactModal = function() {
        (0,eventsHandlers/* handleListingDetailClick */.L1)(eventLabel);
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactModal, {
            listing: listing,
            listingTitle: listingTitle,
            requestType: requestType,
            similarPropertiesRef: similarPropertiesRef
        }), requestContactModalOptions);
    };
    if (isVisitButton) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, (0,_object_spread/* default */.Z)({
            fullWidth: true,
            className: className,
            Icon: function(props) {
                return isVisitButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar/* default */.Z, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_FlashOn, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    color: index_es/* colors.orange600 */.O9.orange600,
                    height: "14",
                    viewBox: "0 0 7 14",
                    width: "7"
                }));
            },
            label: isMobile ? t("listing-detail:request_visit_CTA_mobile") : t("listing-detail:request_visit"),
            sizeVariant: isMobile ? "small" : "medium",
            onClick: openRequestContactModal
        }, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
        fullWidth: true,
        className: className,
        "data-testid": "request-call-button",
        Icon: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                height: 20,
                width: 20
            }));
        },
        label: t("listing-detail:request_call"),
        sizeVariant: isMobile ? "small" : "medium",
        styleVariant: "tertiary",
        onClick: openRequestContactModal
    });
};

// EXTERNAL MODULE: ./src/utils/tracking/trackingUtils.ts
var trackingUtils = __webpack_require__(4464);
// EXTERNAL MODULE: ./src/components/DisclaimerRecaptcha/index.tsx
var DisclaimerRecaptcha = __webpack_require__(24383);
// EXTERNAL MODULE: ./src/components/Label/index.tsx + 1 modules
var Label = __webpack_require__(4557);
// EXTERNAL MODULE: ./src/design-lib/components/StateDecorator/style.css.ts
var style_css = __webpack_require__(61810);
// EXTERNAL MODULE: src/components/TextArea/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/TextArea/styles.css.ts.vanilla.css","source":"LnFqOWw1bzAgewogIGJvcmRlcjogc29saWQgMXB4IHJnYmEoNTEsIDY4LCA4NCwgMC4zKTsKICBib3JkZXItcmFkaXVzOiA0cHg7CiAgbWluLWhlaWdodDogMTI4cHg7CiAgcGFkZGluZzogMjJweCAxMnB4IDhweDsKICB3aWR0aDogMTAwJTsKfQoucWo5bDVvMiB7CiAgYm9yZGVyLWNvbG9yOiAjRUI1NzU3Owp9Ci5xajlsNW8zIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRjVGNUY1OwogIGJvcmRlci1jb2xvcjogI0IzQjNCMjsKICBjb2xvcjogIzFEMUQxQjsKfQoucWo5bDVvNCB7CiAgbWFyZ2luLXRvcDogNHB4OwogIHRleHQtYWxpZ246IHJpZ2h0Owp9Ci5xajlsNW81IHsKICBjb2xvcjogcmdiYSg1MSwgNjgsIDg0LCAwLjgpOwogIGZvbnQtc2l6ZTogMTJweDsKICBsaW5lLWhlaWdodDogMS40MjsKfQoucWo5bDVvNiB7CiAgY29sb3I6ICNFQjU3NTc7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_LnFqOWw1bzAgewogIGJvcmRlcjogc29saWQgMXB4IHJnYmEoNTEsIDY4LCA4NCwgMC4zKTsKICBib3JkZXItcmFkaXVzOiA0cHg7CiAgbWluLWhlaWdodDogMTI4cHg7CiAgcGFkZGluZzogMjJweCAxMnB4IDhweDsKICB3aWR0aDogMTAwJTsKfQoucWo5bDVvMiB7CiAgYm9yZGVyLWNvbG9yOiAjRUI1NzU3Owp9Ci5xajlsNW8zIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRjVGNUY1OwogIGJvcmRlci1jb2xvcjogI0IzQjNCMjsKICBjb2xvcjogIzFEMUQxQjsKfQoucWo5bDVvNCB7CiAgbWFyZ2luLXRvcDogNHB4OwogIHRleHQtYWxpZ246IHJpZ2h0Owp9Ci5xajlsNW81IHsKICBjb2xvcjogcmdiYSg1MSwgNjgsIDg0LCAwLjgpOwogIGZvbnQtc2l6ZTogMTJweDsKICBsaW5lLWhlaWdodDogMS40MjsKfQoucWo5bDVvNiB7CiAgY29sb3I6ICNFQjU3NTc7Cn0_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(80995);
;// CONCATENATED MODULE: ./src/components/TextArea/styles.css.ts

var countExceeded = 'qj9l5o6';
var counterInner = 'qj9l5o5';
var counterOuter = 'qj9l5o4';
var textArea = {'default':'qj9l5o0',error:'qj9l5o2 qj9l5o0',disabled:'qj9l5o3 qj9l5o0'};
;// CONCATENATED MODULE: ./src/components/TextArea/index.tsx









var TextArea = function(_param) {
    var _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, error = _param.error, _isPrivate = _param.isPrivate, isPrivate = _isPrivate === void 0 ? true : _isPrivate, label = _param.label, name = _param.name, onBlur = _param.onBlur, onChange = _param.onChange, placeholder = _param.placeholder, _required = _param.required, required = _required === void 0 ? false : _required, value = _param.value, others = (0,_object_without_properties/* default */.Z)(_param, [
        "disabled",
        "error",
        "isPrivate",
        "label",
        "name",
        "onBlur",
        "onChange",
        "placeholder",
        "required",
        "value"
    ]);
    var id = "label_".concat(name);
    var className = others.className, othersNoClassName = (0,_object_without_properties/* default */.Z)(others, [
        "className"
    ]);
    var getClass = function() {
        if (disabled) return textArea.disabled;
        if (error) return textArea.error;
        return textArea["default"];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                htmlFor: id,
                label: label,
                required: required
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                className: classnames_default()(getClass(), isPrivate ? "ca-sensitive" : "", className),
                id: id,
                name: name,
                placeholder: placeholder,
                required: required,
                value: value,
                onBlur: onBlur,
                onChange: function(e) {
                    return onChange(e.currentTarget.value);
                }
            }, othersNoClassName)),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: style_css/* stateDecoration.error */.n.error,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                    as: "span",
                    "data-testid": "error",
                    children: error
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: counterOuter,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: counterInner,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: value.length > 1500 ? countExceeded : "",
                            children: value.length
                        }),
                        "/1500"
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_TextArea = (TextArea);

;// CONCATENATED MODULE: ./src/components/FormFields/FormikTextarea/index.tsx





var FormikTextarea = function(props) {
    var ref = (0,src_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    var onBlur = field.onBlur, value = field.value;
    var setValue = helpers.setValue;
    var error = meta.error, touched = meta.touched;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextArea, {
        error: touched && error,
        label: props.label,
        name: props.name,
        placeholder: props.placeholder,
        /**
       * FIXME investigate why Formik's onChange does not work here
       */ required: props.required,
        value: value,
        onBlur: function(e) {
            onBlur(e);
            typeof props.handleTracking === "function" && props.handleTracking();
        },
        onChange: setValue
    });
};

// EXTERNAL MODULE: src/components/ContactAgencyForm/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ContactAgencyForm/styles.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA51VwW6cMBC95yumiiq1B0fAZmHXe+lpf6PyYkOcGNuyTUJS5d8rjE0wS6q2ByQ0nnl+vJk33P3MmW3eKpPDrxuARkmHLH9jGPJ7PZxu3m/uYsbOZ1xI/dQa1UuKaiWUwXB7Ls/lOT+Nh8pQZpAhlPcWw2FEANDKcseVxGCYII4/szH6hrikbMBQJLfc+1s6Ylou0UU5pzoMebbisvdZmlDKZYsMbx/cfN0zM47XRCAieCsxODY45JROAMrtzw2hFzYhlll2mtlgyID0Tp2u+RWhOISd0svYgF44dQ8YiiKbYp5SoFcz6ZhJyFVbGmTwhXdaGUek275rgXBYIETekJfXjKq1ssdQ+ZGyD6Sj2pHQIQ17IocVGvlrtEjuj3DUw3nhEHessxgawQZkHTFeFMqtFuR1Cvt2jseUG1ZPE1gr0XcyAWUedB7m8/GYn5OExic8hJm4L5NeR/67YsW19VUzIS4FlwxdhKqfFuVhdPNie3YvxLKxLkHm1yrEIYoWxJDrAawSnMJttat2VbHhz/10afz0fbEv9t7HdW/sGNKKR9ylVQLZWZEwCY+9dbx5RbWSjkm3ZPWJX5QmNXevGPJF6+fJ2nIJQBikPMu+Jqo8pnpLtVLtKT2fBmRxLv53vQnWOAxZuunIxSrRO7/pQo99RrIanCEyFowemQSFu8ICI9bT/9ExygnY2jAmgUgK3zouo5uq8qCH7574ak0npivLMLPvy8TjdeIuunPDn8UGBPkniN0WxCVAzI1pDadT/fiGWqJnpUPIsU4L4hiazGwx5I0ZnytwOvNbL/APdlP7Dles408li6TffwOgXTckLAcAAA=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var APdlP7Dles408li6TffwOgXTckLAcAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(3841);
// EXTERNAL MODULE: ./node_modules/@vanilla-extract/recipes/createRuntimeFn/dist/vanilla-extract-recipes-createRuntimeFn.esm.js
var vanilla_extract_recipes_createRuntimeFn_esm = __webpack_require__(83331);
;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/styles.css.ts



var casavoAssistantPhoneWrapper = '_1esfz7r1 tfghjggc tfghjg6 tfghjg1u';
var casavoPropertyTitle = '_1esfz7rf';
var disclaimer = '_1esfz7r9';
var styles_css_errorToast = '_1esfz7r8';
var formInputTellUsMore = (0,vanilla_extract_recipes_createRuntimeFn_esm/* createRuntimeFn */.u)({defaultClassName:'_1esfz7ri _1esfz7rh',variantClassNames:{isMessageOpen:{true:'_1esfz7rj',false:'_1esfz7rk'}},defaultVariants:{},compoundVariants:[]});
var formWrapper = '_1esfz7r3 tfghjghb tfghjgih tfghjgjw tfghjgge';
var formWrapperBg = '_1esfz7rl';
var gdprMotionDiv = '_1esfz7rd tfghjgho tfghjgiu tfghjgfu';
var gridContainer = '_1esfz7rb';
var houseRentIcon = '_1esfz7rg';
var inputWrapper = '_1esfz7r4';
var marketingCommunicationsCheckbox = '_1esfz7r7';
var orange600 = '_1esfz7re';
var privacyGdprTitle = '_1esfz7r6';
var recaptchaDisclaimer = '_1esfz7ra';
var tellUsMoreCta = '_1esfz7r5';
;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/FormContentAgency.tsx






















var FormContentAgency = function(param) {
    var hasError = param.hasError, loading = param.loading, sendingMail = param.sendingMail;
    var ref = (0,formik_esm/* useFormikContext */.u6)(), errors = ref.errors, handleSubmit = ref.handleSubmit, values = ref.values;
    var ref1 = (0,react.useState)(false), showGdpr = ref1[0], setShowGdpr = ref1[1];
    var device = (0,Device/* useDevice */.Fy)();
    var ref2 = (0,useTranslation/* default */.Z)(), lang = ref2.lang, t = ref2.t;
    var ref3 = (0,react.useState)(false), isMessageOpen = ref3[0], setMessageOpen = ref3[1];
    var submitLabel = t("contact-form:submit");
    var isEmailValid = !errors.leadEmail && values.leadEmail !== "";
    var isPhoneNumberValid = !errors.leadPhoneNumber && values.leadPhoneNumber !== "";
    var isButtonDisabled = sendingMail || !isEmailValid || !isPhoneNumberValid;
    var onFormUpdate = function(fieldName, value) {
        if ((0,trackingUtils/* isValidForTracking */.Cz)(value)) {
            (0,eventsHandlers/* handleFormFieldSet */.qK)("ListingDetailForm", fieldName);
        }
    };
    (0,react.useEffect)(function() {
        setShowGdpr(Boolean(values.leadEmail) && Boolean(values.leadPhoneNumber));
    }, [
        values.leadEmail,
        values.leadPhoneNumber
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: formWrapper,
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: inputWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                        required: true,
                        handleTracking: function() {
                            return onFormUpdate("leadEmail", values.leadEmail);
                        },
                        id: "leadEmail",
                        label: t("contact-form:email.label"),
                        name: "leadEmail",
                        type: "email",
                        onClick: function() {
                            return navigator.userAgent.match(/android/i) && window.scrollTo(0, 0);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: inputWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                        required: true,
                        handleTracking: function() {
                            return onFormUpdate("leadPhoneNumber", values.leadPhoneNumber);
                        },
                        handleTrackingPrefix: function() {
                            return onFormUpdate("leadPhoneNumberPrefix", values.leadPhoneNumberPrefix);
                        },
                        id: "leadPhoneNumber",
                        inputMode: "tel",
                        label: t("contact-form:phone"),
                        name: "leadPhoneNumber",
                        prefixName: "leadPhoneNumberPrefix",
                        type: "tel"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: formInputTellUsMore({
                        isMessageOpen: isMessageOpen
                    }),
                    onClick: function() {
                        return setMessageOpen(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: tellUsMoreCta,
                            children: t("contact-form:agency.message.cta")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowUp */.Z.ArrowUp, {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                transform: "rotate(180deg)"
                            })
                        })
                    ]
                }),
                isMessageOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    initial: {
                        opacity: 0,
                        y: "-10%"
                    },
                    transition: {
                        duration: 0.6,
                        type: "tween"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextarea, {
                            handleTracking: function() {
                                return onFormUpdate("leadMessage", values.leadMessage);
                            },
                            label: t("contact-form:agency.message.label"),
                            name: "leadMessage",
                            placeholder: t("contact-form:agency.message.placeholder")
                        })
                    })
                }),
                showGdpr && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    animate: {
                        height: "100%",
                        opacity: 1
                    },
                    initial: {
                        height: 0,
                        opacity: 0
                    },
                    transition: {
                        duration: 0.6,
                        type: "tween"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: privacyGdprTitle,
                                children: t("privacy:gdpr.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    margin: "0 auto",
                                    padding: {
                                        mobile: "xl",
                                        tablet: "4xl"
                                    },
                                    paddingBottom: "xl",
                                    paddingTop: "s",
                                    paddingX: {
                                        mobile: "xl",
                                        tablet: "4xl"
                                    }
                                }),
                                children: [
                                    (0,locale_variables/* isLocaleEnabledFor */.vw)("consentsCasavoForm", lang) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCheckbox, {
                                        handleTracking: function() {
                                            return onFormUpdate("consentForCasavoMortgageService", values.consentForCasavoMortgageService);
                                        },
                                        id: "consentForCasavoMortgageService",
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                            components: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "0")
                                            ],
                                            i18nKey: "privacy:mortgage.title"
                                        }),
                                        name: "consentForCasavoMortgageService",
                                        subText: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreToggle, {
                                            fullText: t("privacy:mortgage.full-text"),
                                            shortText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                components: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                                            textDecoration: "underline"
                                                        })
                                                    }, "0")
                                                ],
                                                i18nKey: "privacy:mortgage.short-text"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCheckbox, {
                                        className: marketingCommunicationsCheckbox,
                                        handleTracking: function() {
                                            return onFormUpdate("marketingComunication", values.hasAcceptedMarketing);
                                        },
                                        id: "marketing-communications",
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                            components: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "0")
                                            ],
                                            i18nKey: "privacy:gdpr.marketing-consent-checkbox"
                                        }),
                                        name: "hasAcceptedMarketing",
                                        subText: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreToggle, {
                                            fullText: t("privacy:gdpr.marketing-consent-full-text"),
                                            shortText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                components: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                                            textDecoration: "underline"
                                                        })
                                                    }, "0")
                                                ],
                                                i18nKey: "privacy:gdpr.marketing-consent-details"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    animate: {
                        height: "100%",
                        opacity: 1,
                        y: 0
                    },
                    initial: {
                        height: 0,
                        opacity: 0,
                        y: -10
                    },
                    transition: {
                        duration: 0.6,
                        type: "tween"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* Toast */.F, {
                        className: styles_css_errorToast,
                        styleType: "error",
                        title: "".concat(t("common:form-error"), " \uD83D\uDE14")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclaimer/* default */.Z, {
                    className: disclaimer,
                    cta: submitLabel
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerRecaptcha/* DisclaimerRecaptcha */.y, {
                    className: recaptchaDisclaimer
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    center: true,
                    className: styles_css/* marginBottom.l */.yl.l,
                    "data-testid": "contact-agency-submit",
                    disabled: isButtonDisabled,
                    label: submitLabel,
                    loading: loading,
                    minWidth: 225,
                    type: "submit"
                })
            ]
        })
    });
};
/* harmony default export */ var ContactAgencyForm_FormContentAgency = (FormContentAgency);

;// CONCATENATED MODULE: ./src/components/Icon/CasavoAssistant/index.tsx





var CasavoAssistant = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,sprinkles_css/* sprinkles */.K)({
            fill: "none"
        }),
        height: "20",
        viewBox: "0 0 20 20",
        width: "20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10Z",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M10.0028 5.29395C11.6271 5.29395 12.9439 6.61075 12.9439 8.23512C12.9439 8.84236 12.7599 9.40661 12.4446 9.87516L12.3557 9.99983C13.6552 9.99983 14.7086 11.0533 14.7086 12.3528V14.7057H5.29688V12.3528C5.29688 11.0533 6.35032 9.99983 7.64982 9.99983C7.28058 9.50885 7.06158 8.89756 7.06158 8.23512C7.06158 6.61075 8.37839 5.29395 10.0028 5.29395ZM12.3557 11.1763H7.64982C7.0296 11.1763 6.52148 11.6562 6.47657 12.265L6.47335 12.3528V13.5292H13.5322V12.3528C13.5322 11.7326 13.0522 11.2244 12.4435 11.1795L12.3557 11.1763ZM10.0028 6.47042C9.02814 6.47042 8.23805 7.2605 8.23805 8.23512C8.23805 9.20974 9.02814 9.99983 10.0028 9.99983C10.9774 9.99983 11.7675 9.20974 11.7675 8.23512C11.7675 7.2605 10.9774 6.47042 10.0028 6.47042Z",
                fill: "currentColor",
                fillRule: "evenodd"
            })
        ]
    }));
};
/* harmony default export */ var Icon_CasavoAssistant = (CasavoAssistant);

;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/CasavoAssistantPhone.tsx









var CasavoAssistantPhone = function(param) {
    var className = param.className, isDesktop = param.isDesktop, number = param.number;
    var t = (0,useTranslation/* default */.Z)().t;
    var device = (0,Device/* useDevice */.Fy)();
    var iconSize = 34;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className, casavoAssistantPhoneWrapper),
        "data-testid": "casavo-assistant-phone",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_CasavoAssistant, {
                className: classnames_default()(index_es/* colorVariants.orange600 */.Jj.orange600, (0,sprinkles_css/* sprinkles */.K)({
                    marginRight: "s-m"
                })),
                height: iconSize,
                width: iconSize
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: !isDesktop && (0,sprinkles_css/* sprinkles */.K)({
                    alignItems: "center",
                    display: "flex",
                    flex: 1
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                        children: t("contact-form:casavo.assistant")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginLeft: "auto"
                        }),
                        children: device === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "tel:".concat(number),
                            onClick: function() {
                                (0,eventsHandlers/* handleClickCallAgency */.Iq)("ListingDetail", "Call");
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                children: number
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                            children: number
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ContactAgencyForm_CasavoAssistantPhone = (CasavoAssistantPhone);

// EXTERNAL MODULE: ./src/components/Select/index.tsx + 1 modules
var Select = __webpack_require__(75281);
// EXTERNAL MODULE: src/components/FormFields/FormikSelect/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/FormFields/FormikSelect/styles.css.ts.vanilla.css","source":"Ll8xOG85ZmlpMCB7CiAgZm9udC1zaXplOiAxNHB4Owp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_Ll8xOG85ZmlpMCB7CiAgZm9udC1zaXplOiAxNHB4Owp9_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(8104);
;// CONCATENATED MODULE: ./src/components/FormFields/FormikSelect/styles.css.ts

var formikSelect = '_18o9fii0';
;// CONCATENATED MODULE: ./src/components/FormFields/FormikSelect/index.tsx






var FormikSelect = function(param) {
    var _dataTestId = param.dataTestId, dataTestId = _dataTestId === void 0 ? "select" : _dataTestId, error = param.error, handleTracking = param.handleTracking, label = param.label, name = param.name, onClick = param.onClick, options = param.options, placeholder = param.placeholder, required = param.required, warning = param.warning;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)({
        name: name,
        onClick: onClick,
        placeholder: placeholder,
        required: required
    }), 3), field = ref[0], meta = ref[1], form = ref[2];
    var value = field.value;
    var errorFromFormik = meta.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
        className: formikSelect,
        dataTestId: dataTestId,
        error: errorFromFormik && error,
        label: label,
        name: name,
        options: options,
        placeholder: placeholder,
        required: required,
        value: value,
        warning: errorFromFormik && warning,
        onClick: onClick,
        onSelect: function(opt) {
            form.setValue(opt.value);
            typeof handleTracking === "function" && handleTracking();
        }
    });
};
/* harmony default export */ var FormFields_FormikSelect = (FormikSelect);

;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/FormContentCasavo.tsx























/** This component could be dead code */ var FormContentCasavo = function(param) {
    var hasError = param.hasError, loading = param.loading, phoneNumber = param.phoneNumber, property = param.property, sendingMail = param.sendingMail;
    var ref;
    var ref1 = (0,formik_esm/* useFormikContext */.u6)(), errors = ref1.errors, handleSubmit = ref1.handleSubmit, values = ref1.values;
    var ref2 = (0,react.useState)(false), showGdpr = ref2[0], setShowGdpr = ref2[1];
    var device = (0,Device/* useDevice */.Fy)();
    var ref3 = (0,useTranslation/* default */.Z)(), lang = ref3.lang, t = ref3.t;
    var submitLabel = t("contact-form:submit");
    var isEmailValid = !errors.leadEmail && values.leadEmail !== "";
    var isPhoneNumberValid = !errors.leadPhoneNumber && values.leadPhoneNumber !== "";
    var isReasonValid = !errors.leadReason && values.leadReason !== "";
    var isButtonDisabled = sendingMail || !isEmailValid || !isPhoneNumberValid || !isReasonValid;
    var onFormUpdate = function(fieldName, value) {
        if ((0,trackingUtils/* isValidForTracking */.Cz)(value)) {
            (0,eventsHandlers/* handleFormFieldSet */.qK)("ListingDetailForm", fieldName);
        }
    };
    (0,react.useEffect)(function() {
        setShowGdpr(Boolean(values.leadEmail) && Boolean(values.leadPhoneNumber) && Boolean(values.leadReason));
    }, [
        values.leadEmail,
        values.leadPhoneNumber,
        values.leadReason
    ]);
    var selectReasonOptions = [
        {
            label: t("contact-form:casavo.reason.options.morePhotos"),
            value: "MORE_PHOTOS"
        },
        {
            label: t("contact-form:casavo.reason.options.moreAboutHouse"),
            value: "MORE_ABOUT_HOUSE"
        },
        {
            label: t("contact-form:casavo.reason.options.other"),
            value: "OTHER"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: formWrapper,
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        position: {
                            mobile: "static",
                            tablet: "relative"
                        },
                        zIndex: 2
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: inputWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormFields_FormikSelect, {
                                dataTestId: "contact-reason-select",
                                error: t("contact-form:casavo.reason.warning"),
                                handleTracking: function() {
                                    onFormUpdate("leadReason", values.leadReason);
                                },
                                name: "leadReason",
                                options: selectReasonOptions,
                                placeholder: t("contact-form:casavo.reason.placeholder")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: gridContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: inputWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                                        handleTracking: function() {
                                            return onFormUpdate("leadName", values.leadName);
                                        },
                                        id: "leadName",
                                        label: t("contact-form:casavo.name"),
                                        name: "leadName",
                                        type: "text"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: inputWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                                        required: true,
                                        handleTracking: function() {
                                            return onFormUpdate("leadEmail", values.leadEmail);
                                        },
                                        id: "leadEmail",
                                        label: t("contact-form:email.label"),
                                        name: "leadEmail",
                                        type: "email"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: inputWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                                required: true,
                                handleTracking: function() {
                                    return onFormUpdate("leadPhoneNumber", values.leadPhoneNumber);
                                },
                                handleTrackingPrefix: function() {
                                    return onFormUpdate("leadPhoneNumberPrefix", values.leadPhoneNumberPrefix);
                                },
                                id: "leadPhoneNumber",
                                inputMode: "tel",
                                label: t("contact-form:phone"),
                                name: "leadPhoneNumber",
                                prefixName: "leadPhoneNumberPrefix",
                                type: "tel"
                            })
                        })
                    ]
                }),
                showGdpr && /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                    animate: {
                        height: "100%",
                        opacity: 1
                    },
                    className: gdprMotionDiv,
                    initial: {
                        height: 0,
                        opacity: 0
                    },
                    transition: {
                        duration: 0.6,
                        type: "tween"
                    },
                    children: [
                        (0,locale_variables/* isLocaleEnabledFor */.vw)("consentsAgencyForm", lang) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCheckbox, {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                marginBottom: 0,
                                marginTop: "l"
                            }),
                            handleTracking: function() {
                                return onFormUpdate("consentForCasavoMortgageService", values.consentForCasavoMortgageService);
                            },
                            id: "consentForCasavoMortgageService",
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                components: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "0")
                                ],
                                i18nKey: "privacy:mortgage.title"
                            }),
                            name: "consentForCasavoMortgageService",
                            subText: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreToggle, {
                                fullText: t("privacy:mortgage.full-text"),
                                shortText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (0,sprinkles_css/* sprinkles */.K)({
                                                textDecoration: "underline"
                                            })
                                        }, "0")
                                    ],
                                    i18nKey: "privacy:mortgage.short-text"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCheckbox, {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                marginBottom: 0,
                                marginTop: "l"
                            }),
                            handleTracking: function() {
                                return onFormUpdate("marketingComunication", values.hasAcceptedMarketing);
                            },
                            id: "marketing-communications",
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                components: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "0")
                                ],
                                i18nKey: "privacy:gdpr.marketing-consent-checkbox"
                            }),
                            name: "hasAcceptedMarketing",
                            subText: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreToggle, {
                                fullText: t("privacy:gdpr.marketing-consent-full-text"),
                                shortText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (0,sprinkles_css/* sprinkles */.K)({
                                                textDecoration: "underline"
                                            })
                                        }, "0")
                                    ],
                                    i18nKey: "privacy:gdpr.marketing-consent-details"
                                })
                            })
                        })
                    ]
                }),
                hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    animate: {
                        height: "100%",
                        opacity: 1,
                        y: 0
                    },
                    initial: {
                        height: 0,
                        opacity: 0,
                        y: -10
                    },
                    transition: {
                        duration: 0.6,
                        type: "tween"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* Toast */.F, {
                        className: styles_css_errorToast,
                        styleType: "error",
                        title: "".concat(t("common:form-error"), " \uD83D\uDE14")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        device === "mobile" && !((ref = property.detail) === null || ref === void 0 ? void 0 : ref.casavoDirectSale) && property.country !== "italy" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_CasavoAssistantPhone, {
                                    number: phoneNumber
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclaimer/* default */.Z, {
                            className: disclaimer,
                            cta: submitLabel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerRecaptcha/* DisclaimerRecaptcha */.y, {
                            className: recaptchaDisclaimer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            center: true,
                            className: styles_css/* marginBottom.m-l */.yl["m-l"],
                            disabled: isButtonDisabled,
                            label: submitLabel,
                            loading: loading,
                            minWidth: 225,
                            type: "submit"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ContactAgencyForm_FormContentCasavo = (FormContentCasavo);

// EXTERNAL MODULE: ./src/types/listing.ts
var types_listing = __webpack_require__(76362);
// EXTERNAL MODULE: ./src/components/LabelWithCheck/index.ts + 1 modules
var LabelWithCheck = __webpack_require__(53891);
;// CONCATENATED MODULE: ./src/containers/ListingDetail/CasavoAdvantage.ts


var casavoAdvantagesFor = function(listing) {
    switch(listing.detail.inventory){
        case types_listing/* CasavoInventory.Third_Party */.M.Third_Party:
            return [
                {
                    descriptionTranslationKey: "",
                    iconUrl: "",
                    titleTranslationKey: "listing-detail:form-header.agency.one"
                },
                {
                    descriptionTranslationKey: "",
                    iconUrl: "",
                    titleTranslationKey: "listing-detail:form-header.agency.two"
                }, 
            ];
        case types_listing/* CasavoInventory.iBuyer */.M.iBuyer:
            return listing.country === "italy" ? [
                {
                    descriptionTranslationKey: "",
                    iconUrl: "",
                    titleTranslationKey: "listing-detail:form-header.casavo.one"
                },
                {
                    descriptionTranslationKey: "",
                    iconUrl: "",
                    titleTranslationKey: "listing-detail:form-header.casavo.two"
                },
                {
                    descriptionTranslationKey: "",
                    iconUrl: "",
                    titleTranslationKey: "listing-detail:form-header.casavo.three"
                },
                {
                    descriptionTranslationKey: "",
                    iconUrl: "",
                    titleTranslationKey: "listing-detail:form-header.casavo.four"
                }, 
            ] : [
                {
                    descriptionTranslationKey: "",
                    iconUrl: "",
                    titleTranslationKey: "listing-detail:form-header.casavo.one"
                },
                {
                    descriptionTranslationKey: "",
                    iconUrl: "",
                    titleTranslationKey: "listing-detail:form-header.casavo.three"
                },
                {
                    descriptionTranslationKey: "",
                    iconUrl: "",
                    titleTranslationKey: "listing-detail:form-header.casavo.four"
                }, 
            ];
        case types_listing/* CasavoInventory.Agency */.M.Agency:
            return [
                {
                    descriptionTranslationKey: "PropertyAdvantages:PropertyAdvantages_FairPrice_CardDescription",
                    iconUrl: iconUrl("blocked-price"),
                    titleTranslationKey: "PropertyAdvantages:PropertyAdvantages_FairPrice_Title"
                },
                {
                    descriptionTranslationKey: "PropertyAdvantages:PropertyAdvantages_TransparencyDocumenation_CardDescription",
                    iconUrl: iconUrl("docs"),
                    titleTranslationKey: "PropertyAdvantages:PropertyAdvantages_TransparencyDocumenation_Title"
                },
                {
                    descriptionTranslationKey: "PropertyAdvantages:PropertyAdvantages_SelectedPartners_CardDescription",
                    iconUrl: iconUrl("trusted-collabs"),
                    titleTranslationKey: "PropertyAdvantages:PropertyAdvantages_SelectedPartners_Title"
                },
                {
                    descriptionTranslationKey: "PropertyAdvantages:PropertyAdvantages_Bureaucracy_CardDescription",
                    iconUrl: iconUrl("bureaucracy"),
                    titleTranslationKey: "PropertyAdvantages:PropertyAdvantages_Bureaucracy_Title"
                }, 
            ];
    }
};
var iconUrl = function(iconName) {
    var ref = config_default()(), imageBasePath = ref.publicRuntimeConfig.imageBasePath;
    return "".concat(imageBasePath, "/images/advantages/").concat(iconName, ".svg");
};

;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/FormInfoCasavo.tsx









var FormInfoCasavo = function(param) {
    var listing = param.listing;
    var ref;
    var t = (0,useTranslation/* default */.Z)().t;
    var advantages = casavoAdvantagesFor(listing);
    var italianListing = listing.country === "italy";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            display: "flex",
            flexDirection: "column",
            margin: "0 auto",
            marginBottom: "2xl",
            paddingLeft: "2xl",
            paddingRight: "2xl"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    display: "flex",
                    gap: "l",
                    justifyContent: "space-around",
                    margin: "0 auto",
                    paddingLeft: "2xl",
                    paddingRight: "2xl"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            minWidth: italianListing ? "initial" : "50%"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_CasavoPropertyTitle, {
                            className: casavoPropertyTitle,
                            titles: (ref = listing.detail) === null || ref === void 0 ? void 0 : ref.titles
                        })
                    }),
                    !italianListing && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            minWidth: "50%"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_CasavoAssistantPhone, {
                            isDesktop: true,
                            className: casavoPropertyTitle,
                            number: listing.contactInfo.telephoneNumberContact
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    columns: 2,
                    gap: "xl",
                    paddingX: "xl"
                }),
                children: advantages.map(function(a) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithCheck/* LabelWithCheck */.y, {
                            children: t(a.titleTranslationKey)
                        })
                    }, a.titleTranslationKey);
                })
            })
        ]
    });
};
/* harmony default export */ var ContactAgencyForm_FormInfoCasavo = (FormInfoCasavo);

;// CONCATENATED MODULE: ./src/components/Icon/HouseRent/index.tsx




var HouseSmall = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 0L16 4.44444V16H0V4.44444L8 0ZM8 2.288L2 5.62V14H8.53L7.753 11.101L5.36104 11.7424L4.58458 8.84461L11.3461 7.03287L12.1225 9.93065L9.685 10.583L10.6 14H14V5.621L8 2.288Z"
        })
    }));
};
/* harmony default export */ var HouseRent = (HouseSmall);

;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/FormInfoThirdParty.tsx








var FormInfoThirdParty = function(param) {
    var property = param.property;
    var t = (0,useTranslation/* default */.Z)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            display: "flex",
            gap: "m",
            justifyContent: "space-around",
            marginBottom: "2xl",
            paddingX: "5xl"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    flex: 1
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Typography */.ZT, {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            paddingBottom: "s"
                        }),
                        variant: "bodyM",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HouseRent, {
                                className: houseRentIcon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: property.contactInfo.agencyName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        color: "greyscale500",
                        children: property.contactInfo.agencyAddress
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    flex: 1
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithCheck/* LabelWithCheck */.y, {
                        children: t("listing-detail:form-header.agency.one")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithCheck/* LabelWithCheck */.y, {
                        children: t("listing-detail:form-header.agency.two")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ContactAgencyForm_FormInfoThirdParty = (FormInfoThirdParty);

// EXTERNAL MODULE: src/components/ContactAgencyForm/FormHeaderDesktop/index.css.tsx.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ContactAgencyForm/FormHeaderDesktop/index.css.tsx.vanilla.css","source":"Ll81eTQ3Y3IwIHsKICBtYXJnaW46IDAgYXV0bzsKICBtYXgtd2lkdGg6IDUwMHB4Owp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var index_css_tsx_vanilla_css_source_Ll81eTQ3Y3IwIHsKICBtYXJnaW46IDAgYXV0bzsKICBtYXgtd2lkdGg6IDUwMHB4Owp9_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(25791);
;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/FormHeaderDesktop/index.css.tsx

var formHeaderSubtitle = '_5y47cr0';
;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/FormHeaderDesktop/FormHeaderDesktop.tsx









var FormHeaderDesktop = function(param) {
    var property = param.property;
    var t = (0,useTranslation/* default */.Z)().t;
    var getHeader = function() {
        switch(property.detail.inventory){
            case types_listing/* CasavoInventory.Agency */.M.Agency:
                return "listing-detail:form-header.subtitle_casavo_inventory_agency";
            case types_listing/* CasavoInventory.iBuyer */.M.iBuyer:
                return "listing-detail:form-header.subtitle_casavo";
            case types_listing/* CasavoInventory.Third_Party */.M.Third_Party:
                return "listing-detail:form-header.subtitle_agency";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingBottom: "2xl",
                    textAlign: "center"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginBottom: "s",
                            whiteSpace: "pre-wrap"
                        }),
                        children: t("listing-detail:form-header.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                        className: formHeaderSubtitle,
                        children: t(getHeader())
                    })
                ]
            }),
            property.contactInfo.ownedByCasavo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_FormInfoCasavo, {
                listing: property
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_FormInfoThirdParty, {
                property: property
            })
        ]
    });
};
/* harmony default export */ var FormHeaderDesktop_FormHeaderDesktop = (FormHeaderDesktop);

;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/FormHeaderMobile.tsx









var FormHeaderMobile = function(param) {
    var property = param.property;
    var ref;
    var t = (0,useTranslation/* default */.Z)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingBottom: property.contactInfo.ownedByCasavo ? "l" : "2xl",
                    paddingRight: "m"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    components: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                display: "block"
                            })
                        }, "0"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: orange600
                        }, "1"), 
                    ],
                    i18nKey: property.contactInfo.ownedByCasavo ? "contact-form:casavo.title" : "listing-detail:at_your_service_agency"
                })
            }),
            property.contactInfo.ownedByCasavo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_CasavoPropertyTitle, {
                titles: (ref = property.detail) === null || ref === void 0 ? void 0 : ref.titles
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingBottom: "2xl"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            paddingBottom: "l"
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Typography */.ZT, {
                                variant: "bodyM",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: property.contactInfo.agencyName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                color: "greyscale500",
                                children: property.contactInfo.agencyAddress
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithCheck/* LabelWithCheck */.y, {
                        children: t("listing-detail:form-header.agency.one")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithCheck/* LabelWithCheck */.y, {
                        children: t("listing-detail:form-header.agency.two")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ContactAgencyForm_FormHeaderMobile = (FormHeaderMobile);

// EXTERNAL MODULE: ./src/design-lib/base-ui/Typography/index.ts + 1 modules
var Typography = __webpack_require__(54985);
// EXTERNAL MODULE: ./src/design-lib/components/ButtonLink/index.tsx
var ButtonLink = __webpack_require__(36898);
// EXTERNAL MODULE: ./src/i18n-routes.ts
var i18n_routes = __webpack_require__(31693);
;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/SuccessIBuyerOrOda.tsx





var SuccessIBuyerOrOda = function() {
    var t = (0,useTranslation/* default */.Z)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading1 */.nL, {
                as: "h2",
                className: styles_css/* paddingBottom.s-m */.Et["s-m"],
                children: t("contact-form:casavo.success.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                className: styles_css/* paddingBottom.l */.Et.l,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* TokenSupport */.B, {
                    children: t("contact-form:casavo.success.subtitle")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                strong: true,
                className: styles_css/* paddingBottom.l */.Et.l,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* TokenSupport */.B, {
                    children: [
                        t("contact-form:casavo.success.postScriptum"),
                        " "
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ContactAgencyForm_SuccessIBuyerOrOda = (SuccessIBuyerOrOda);

// EXTERNAL MODULE: ./src/design-lib/components/Icons/Bell/index.tsx
var Bell = __webpack_require__(12336);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/ListingContact/SaveSearchDetail.tsx + 1 modules
var SaveSearchDetail = __webpack_require__(76418);
;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/SuccessSaveSearch.tsx



















var SuccessSaveSearch = function(param) {
    var cities = param.cities, listing = param.listing, similarPropertiesLength = param.similarPropertiesLength, userEmail = param.userEmail;
    var t = (0,useTranslation/* default */.Z)().t;
    var openModal = (0,ModalContext/* useModal */.dd)().openModal;
    var device = (0,Device/* useDevice */.Fy)();
    var ref = (0,AuthProvider/* useAuthentication */.JL)(), isUserLoading = ref.isLoading, user = ref.user;
    var ref1 = (0,react.useState)(false), goToSimilarPropertiesClicked = ref1[0], setGoToSimilaPropertiesClicked = ref1[1];
    var closeModal = (0,ModalContext/* useModal */.dd)().closeModal;
    var ref2 = (0,react.useState)(false), isSaveSearchSuccess = ref2[0], setSaveSearchSuccess = ref2[1];
    var isIBuyerOrOdaInventory = listing.detail.inventory === types_listing/* CasavoInventory.iBuyer */.M.iBuyer || listing.detail.inventory === types_listing/* CasavoInventory.Agency */.M.Agency;
    (0,react.useEffect)(function() {
        if (!isUserLoading && user && (0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && sessionStorage.getItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN")) {
            openSaveSearchModal();
        }
    }, [
        user,
        isUserLoading
    ]);
    var openSaveSearchModal = function() {
        return openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(SaveSearchDetail/* default */.ZP, {
            cities: cities,
            listing: listing,
            similarPropertiesLength: similarPropertiesLength,
            userEmail: userEmail,
            onSaveSuccess: onSaveSuccess
        }), {
            background: "linear-gradient(to bottom, ".concat(theme/* theme.colors.white */.r.colors.white, ", ").concat(theme/* theme.colors.greyscale50 */.r.colors.greyscale50, ")"),
            desktopHeight: 670,
            desktopWidth: 670,
            overlay: true
        });
    };
    var onSaveSuccess = function() {
        setSaveSearchSuccess(true);
    };
    var handleOpenSaveSearchModal = function(e) {
        e.preventDefault();
        (0,eventsHandlers/* handleListingDetailClick */.L1)("SaveSearchAccepted", isIBuyerOrOdaInventory ? "Casavo" : "Agency");
        openSaveSearchModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                as: "h2",
                className: styles_css/* paddingBottom.s-m */.Et["s-m"],
                children: t("contact-form:ContactForm_SuccessSaveSearch_Title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                className: styles_css/* paddingBottom.2xl */.Et["2xl"],
                children: t("contact-form:ContactForm_SuccessSaveSearch_Subtitle")
            }),
            isSaveSearchSuccess && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(styles_css/* flexCenter */._7, styles_css/* gap.s */.SG.s, index_es/* colorVariants.success600 */.Jj.success600, (0,sprinkles_css/* sprinkles */.K)({
                    justifyContent: "center"
                })),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Check */.Z.Check, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                        strong: true,
                        children: t("contact-form:ContactForm_SuccessSaveSearch_OkFeedback")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                center: true,
                className: classnames_default()(isSaveSearchSuccess && (0,sprinkles_css/* sprinkles */.K)({
                    visibility: "hidden"
                }), styles_css/* marginBottom.l */.yl.l),
                Icon: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bell/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
                },
                label: t("contact-form:ContactForm_SuccessSaveSearch_CTA_Primary"),
                minWidth: 190,
                styleVariant: "primary",
                onClick: handleOpenSaveSearchModal
            }),
            similarPropertiesLength > 0 && !isSaveSearchSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                center: true,
                className: goToSimilarPropertiesClicked && (0,sprinkles_css/* sprinkles */.K)({
                    visibility: "hidden"
                }),
                label: t("contact-form:ContactForm_SuccessSaveSearch_CTA_Secondary"),
                minWidth: 190,
                styleVariant: "secondary",
                onClick: function() {
                    (0,eventsHandlers/* handleListingDetailClick */.L1)("SaveSearchRefused", isIBuyerOrOdaInventory ? "Casavo" : "Agency");
                    device === "desktop" && (0,dom_interactions_helpers/* anchorSmoothScroll */.e)("#similarProperties", -100);
                    device === "mobile" && closeModal();
                    setTimeout(function() {
                        device === "mobile" ? (0,dom_interactions_helpers/* anchorSmoothScroll */.e)("#similarProperties", 0) : setGoToSimilaPropertiesClicked(true);
                    }, 500);
                }
            })
        ]
    });
};
/* harmony default export */ var ContactAgencyForm_SuccessSaveSearch = (SuccessSaveSearch);

;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/Success.tsx




















var Success = function(param) {
    var cities = param.cities, listing = param.listing, onGoToSimilarProperties = param.onGoToSimilarProperties, similarPropertiesLength = param.similarPropertiesLength, userEmail = param.userEmail;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var device = (0,Device/* useDevice */.Fy)();
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var ctaMinWidth = 230;
    var isIBuyerOrOdaInventory = listing.detail.inventory === types_listing/* CasavoInventory.iBuyer */.M.iBuyer || listing.detail.inventory === types_listing/* CasavoInventory.Agency */.M.Agency;
    var ref1 = config_default()(), imageBasePath = ref1.publicRuntimeConfig.imageBasePath;
    var Illustration = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
            alt: "",
            className: (0,sprinkles_css/* sprinkles */.K)({
                marginBottom: "s",
                marginX: "auto"
            }),
            height: 150,
            loading: "lazy",
            src: "".concat(imageBasePath, "/images/concepts/we-buy-or-sell.svg"),
            width: 150
        }, props));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        animate: {
            opacity: 1
        },
        className: (0,sprinkles_css/* sprinkles */.K)({
            display: "flex",
            flex: 1,
            flexDirection: "column",
            marginBottom: "3xl",
            textAlign: "center"
        }),
        initial: {
            opacity: 0
        },
        transition: {
            duration: 0.6
        },
        children: (0,locale_variables/* isLocaleEnabledFor */.vw)("saveSearch", lang) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,sprinkles_css/* sprinkles */.K)({
                marginY: "auto"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration, {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        marginBottom: "2xl",
                        marginX: "auto"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_SuccessSaveSearch, {
                    cities: cities,
                    listing: listing,
                    similarPropertiesLength: similarPropertiesLength,
                    userEmail: userEmail
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        marginY: "auto"
                    }),
                    children: [
                        Illustration,
                        isIBuyerOrOdaInventory ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_SuccessIBuyerOrOda, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                            as: "h2",
                            className: styles_css/* paddingBottom.2xl */.Et["2xl"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                                i18Key: "contact-form:agency.success.message"
                            })
                        }),
                        similarPropertiesLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            center: true,
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                marginBottom: {
                                    tablet: "2xl"
                                }
                            }),
                            label: t(isIBuyerOrOdaInventory ? "contact-form:casavo.success.cta" : "contact-form:agency.success.cta"),
                            minWidth: ctaMinWidth,
                            styleVariant: "secondary",
                            onClick: function() {
                                onGoToSimilarProperties && onGoToSimilarProperties();
                                (0,eventsHandlers/* handleClick */.qk)("ListingDetailForm", "ToSimilarPropertiesFrom".concat(isIBuyerOrOdaInventory ? "Casavo" : "Agency"));
                                (0,dom_interactions_helpers/* anchorSmoothScroll */.e)("#similarProperties", device === "mobile" ? 0 : -100);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        marginTop: "auto"
                    }),
                    children: [
                        device === "mobile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                            strong: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* TokenSupport */.B, {
                                children: t("contact-form:success.toFlow.title")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                            strong: true,
                            className: styles_css/* paddingBottom.m */.Et.m,
                            children: t("contact-form:success.toFlow.subtitle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                            center: true,
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                margin: "auto"
                            }),
                            href: "".concat(publicRuntimeConfig.casavoWebsite).concat(i18n_routes/* sellersFlowUrlPath */.i_[lang]),
                            isNextLink: false,
                            label: t("contact-form:success.toFlow.cta"),
                            minWidth: ctaMinWidth,
                            styleVariant: "secondary",
                            onClick: function() {
                                (0,eventsHandlers/* handleClick */.qk)("ListingDetailForm", "ToFlowFrom".concat(isIBuyerOrOdaInventory ? "Casavo" : "Agency"));
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ContactAgencyForm_Success = (Success);

;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/validationSchema.tsx


// eslint-disable-next-line @typescript-eslint/no-unused-vars
var validationSchema_getValidationSchema = function(t, kind) {
    if (kind === "casavo") {
        return es/* object */.Ry().shape({
            consentForCasavoMortgageService: es/* boolean */.O7(),
            hasAcceptedMarketing: es/* boolean */.O7(),
            leadEmail: es/* string */.Z_().email(t("common:invalid-email-message")).required(t("common:required-field-message")),
            leadMessage: es/* string */.Z_(),
            leadName: es/* string */.Z_(),
            leadPhoneNumber: (0,phoneNumberValidator/* getPhoneNumberValidator */.i)(t("common:required-field-message"), t("common:invalid-phone-message")),
            leadPhoneNumberPrefix: es/* string */.Z_().required(),
            leadReason: es/* string */.Z_().required()
        });
    } else {
        return es/* object */.Ry().shape({
            consentForCasavoMortgageService: es/* boolean */.O7(),
            hasAcceptedMarketing: es/* boolean */.O7(),
            leadEmail: es/* string */.Z_().email(t("common:invalid-email-message")).required(t("common:required-field-message")),
            leadMessage: es/* string */.Z_(),
            leadPhoneNumber: (0,phoneNumberValidator/* getPhoneNumberValidator */.i)(t("common:required-field-message"), t("common:invalid-phone-message")),
            leadPhoneNumberPrefix: es/* string */.Z_().required()
        });
    }
};

;// CONCATENATED MODULE: ./src/components/ContactAgencyForm/index.tsx




























var labourIllusionTimeTimeout;
var ContactAgencyForm = function(param) {
    var cities = param.cities, className = param.className, onClose = param.onClose, onSuccess = param.onSuccess, property = param.property, similarPropertiesLength = param.similarPropertiesLength, similarPropertiesRef = param.similarPropertiesRef;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var ref1 = (0,react.useState)(false), isInSuccess = ref1[0], setIsInSuccess = ref1[1];
    var ref2 = (0,react.useState)(false), hasError = ref2[0], setHasError = ref2[1];
    var ref3 = (0,react.useState)(false), sendingMail = ref3[0], setSendingMail = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var headerHeightDesktop = 100;
    var ref5 = (0,react.useState)(""), emailValue = ref5[0], setEmailValue = ref5[1];
    var listingTitle = property.detail.titles.find(function(title) {
        return title.language === lang;
    }).text;
    var thirdParty = isThirdParty(property);
    (0,react.useEffect)(function() {
        return function() {
            return clearTimeout(labourIllusionTimeTimeout);
        };
    }, []);
    (0,react.useEffect)(function() {
        if ((0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && sessionStorage.getItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN")) {
            var saveSearchAfterLoginParams = JSON.parse(sessionStorage.getItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN"));
            if (saveSearchAfterLoginParams.origin === "LISTING_CONTACT" && saveSearchAfterLoginParams.pageUrl === window.location.href) {
                setIsInSuccess(true);
                return;
            } else {
                sessionStorage.removeItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN");
            }
        }
        setIsInSuccess(false);
    }, [
        property.slug
    ]);
    (0,react.useEffect)(function() {
        onSuccess && onSuccess(isInSuccess);
    }, [
        onSuccess,
        isInSuccess
    ]);
    var device = (0,Device/* useDevice */.Fy)();
    var Header = function() {
        return device === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_FormHeaderMobile, {
            property: property
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHeaderDesktop_FormHeaderDesktop, {
            property: property
        });
    };
    var handleSubmitContactForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var startApiCall, payload, payload1, diffFromStart, labourIllusionTime, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSendingMail(true);
                        setLoading(true);
                        setHasError(false);
                        setEmailValue(values.leadEmail);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        startApiCall = new Date().getTime();
                        return [
                            4,
                            (0,api/* isValidUserFor */.b)("contactAgency")
                        ];
                    case 2:
                        _state.sent();
                        if (!property.contactInfo.ownedByCasavo) return [
                            3,
                            4
                        ];
                        payload = {
                            consentForCasavoMortgageService: values.consentForCasavoMortgageService,
                            currentLanguage: lang,
                            email: values.leadEmail,
                            keepMeUpdated: values.hasAcceptedMarketing,
                            name: values.leadName,
                            phoneNumber: values.leadPhoneNumberPrefix + values.leadPhoneNumber.replace(/-/g, ""),
                            reason: values.leadReason,
                            trackingClientId: getGAClientId()
                        };
                        return [
                            4,
                            api_gluglu_open/* default.listingInfo */.ZP.listingInfo(property.id, payload)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        payload1 = {
                            currentLanguage: lang,
                            lead: {
                                consentForCasavoMortgageService: values.consentForCasavoMortgageService,
                                email: values.leadEmail,
                                hasAcceptedMarketing: values.hasAcceptedMarketing,
                                message: values.leadMessage,
                                phoneNumber: values.leadPhoneNumberPrefix + values.leadPhoneNumber.replace(/-/g, "")
                            },
                            listingId: property.id,
                            trackingClientId: getGAClientId()
                        };
                        return [
                            4,
                            api_gluglu_open/* default.contactAgency */.ZP.contactAgency(payload1)
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        (0,eventsHandlers/* handleFormSubmit */.xz)("ListingDetailForm", "ContactAgency");
                        diffFromStart = new Date().getTime() - startApiCall;
                        labourIllusionTime = Math.max(1000 - diffFromStart, 0);
                        labourIllusionTimeTimeout = setTimeout(function() {
                            setIsInSuccess(true);
                            setSendingMail(false);
                            setLoading(false);
                            device === "desktop" && (0,dom_interactions_helpers/* anchorSmoothScroll */.e)("#contactForm", -headerHeightDesktop);
                            device === "mobile" && property.detail.casavoDirectSale && (0,dom_interactions_helpers/* anchorSmoothScroll */.e)("#contactForm", parseInt(theme/* theme.spacings.-2xl */.r.spacings["-2xl"]));
                        }, labourIllusionTime);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e = _state.sent();
                        setHasError(true);
                        setSendingMail(false);
                        setLoading(false);
                        (0,eventsHandlers/* handleSystem */.o0)("ListingDetailForm", "ContactAgencyError");
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmitContactForm(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref6 = config_default()(), imageBasePath = ref6.publicRuntimeConfig.imageBasePath;
    var validationSchema = validationSchema_getValidationSchema(t, property.contactInfo.ownedByCasavo ? "casavo" : "agency");
    var defaultLeadPhoneNumberPrefix = (0,prefix/* getPrefixFromCountryCode */.a)((0,prefix/* langToCountryCode */.J)(lang));
    var initialValues = property.contactInfo.ownedByCasavo ? {
        consentForCasavoMortgageService: false,
        hasAcceptedMarketing: false,
        leadEmail: "",
        leadMessage: "",
        leadName: "",
        leadPhoneNumber: "",
        leadPhoneNumberPrefix: defaultLeadPhoneNumberPrefix,
        leadReason: ""
    } : {
        consentForCasavoMortgageService: false,
        hasAcceptedMarketing: false,
        leadEmail: "",
        leadMessage: "",
        leadPhoneNumber: "",
        leadPhoneNumberPrefix: defaultLeadPhoneNumberPrefix
    };
    var FormContent = (0,react.useMemo)(function() {
        return function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isThirdParty ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_FormContentAgency, {
                    hasError: hasError,
                    loading: loading,
                    sendingMail: sendingMail
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_FormContentCasavo, {
                    hasError: hasError,
                    loading: loading,
                    phoneNumber: property.contactInfo.telephoneNumberContact,
                    property: property,
                    sendingMail: sendingMail
                })
            });
        };
    }, [
        property.contactInfo.ownedByCasavo,
        property.contactInfo.telephoneNumberContact,
        hasError,
        loading,
        sendingMail
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        condition: device === "desktop",
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    alignItems: "flex-start",
                    display: "flex",
                    justifyContent: "space-between"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            flexShrink: 2,
                            marginTop: "2xl"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                width: "100%"
                            }),
                            loading: "lazy",
                            src: "".concat(imageBasePath, "/images/concepts/clouds-left").concat(device === "mobile" ? "-small" : "", ".svg")
                        })
                    }),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            flexShrink: 2,
                            marginTop: "2xl"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                width: "100%"
                            }),
                            loading: "lazy",
                            src: "".concat(imageBasePath, "/images/concepts/clouds-right").concat(device === "mobile" ? "-small" : "", ".svg")
                        })
                    })
                ]
            });
        },
        children: !isInSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: className,
            id: "contactForm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                thirdParty ? /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    validateOnBlur: true,
                    initialValues: initialValues,
                    validationSchema: validationSchema,
                    onSubmit: handleSubmitContactForm,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContent, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()(styles_css/* flexCenter */._7, styles_css/* gap.xl */.SG.xl, (0,sprinkles_css/* sprinkles */.K)({
                        paddingX: {
                            desktop: "5xl"
                        }
                    })),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactCTA, {
                            listing: property,
                            listingTitle: listingTitle,
                            requestType: "info",
                            similarPropertiesRef: similarPropertiesRef
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactCTA, {
                            listing: property,
                            listingTitle: listingTitle,
                            requestType: "visit",
                            similarPropertiesRef: similarPropertiesRef
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm_Success, {
            cities: cities,
            listing: property,
            similarPropertiesLength: similarPropertiesLength,
            userEmail: emailValue,
            onGoToSimilarProperties: onClose
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FranceGeologicalRiskDisclaimer/FranceGeologicalRiskDisclaimer.tsx




/**
 * Due to France regulation
 * for more legal info, see https://www.inc-conso.fr/content/1er-janvier-2023-une-information-renforcee-des-acquereurs-et-des-locataires-sur-les-risques
 *
 * @param country
 */ var FranceGeologicalRiskDisclaimer = function(param) {
    var country = param.country;
    var isFrance = country === "france";
    var href = "https://www.georisques.gouv.fr";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: isFrance && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,sprinkles_css/* sprinkles */.K)({
                marginBottom: "m",
                marginTop: "xl"
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* BodyM */.iO, {
                children: [
                    "Les informations sur les risques auxquels ce bien est expos\xe9 sont disponibles sur le site G\xe9orisques : ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: href,
                        rel: "noreferrer nofollow",
                        target: "_blank",
                        children: "www.georisques.gouv.fr"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FranceGeologicalRiskDisclaimer/index.ts


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(88569);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/ButtonCircleIcon/index.tsx + 1 modules
var ButtonCircleIcon = __webpack_require__(11161);
;// CONCATENATED MODULE: ./src/components/Icon/LocationZone/index.tsx




var LocationZone = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.185 10.28C15.32 10.885 16 11.658 16 12.5c0 1.933-3.582 3.5-8 3.5s-8-1.567-8-3.5c0-.843.68-1.616 1.815-2.22.267.503.593.97.97 1.39l.231.246-.055.025a3.554 3.554 0 00-.81.507l-.056.052.055.052c.183.163.458.338.811.507l.184.084C4.367 13.677 6.11 14 8 14c1.889 0 3.633-.323 4.855-.857.444-.194.781-.401.995-.59l.054-.054-.054-.051a3.556 3.556 0 00-.811-.507l-.056-.025a7.02 7.02 0 001.202-1.635zM8 0c2.914 0 6 2.206 6 5.984C14 9.418 8.931 13 8 13S2 9.424 2 5.984C2 2.206 5.086 0 8 0zm0 2C5.828 2 4 3.648 4 5.984c0 .87.751 2.126 2.034 3.353a11.812 11.812 0 001.716 1.367l.249.154.25-.154c.545-.35 1.159-.834 1.717-1.369C11.249 8.107 12 6.851 12 5.985 12 3.647 10.172 2 8 2zm0 2a2 2 0 110 4 2 2 0 010-4z"
        })
    }));
};
/* harmony default export */ var Icon_LocationZone = (LocationZone);

// EXTERNAL MODULE: ./src/design-lib/components/Badge/index.tsx + 1 modules
var Badge = __webpack_require__(53964);
// EXTERNAL MODULE: ./src/design-lib/components/Icons/index.tsx + 21 modules
var Icons = __webpack_require__(7984);
// EXTERNAL MODULE: ./src/components/Modal/ModalHeaderTitle.tsx
var ModalHeaderTitle = __webpack_require__(45873);
// EXTERNAL MODULE: ./src/components/Modal/Types/styles.css.ts
var Types_styles_css = __webpack_require__(87);
;// CONCATENATED MODULE: ./src/components/Modal/Types/StreetView.tsx
















var StreetView = function(_param) {
    var cities = _param.cities, props = (0,_object_without_properties/* default */.Z)(_param, [
        "cities"
    ]);
    var device = (0,Device/* useDevice */.Fy)();
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var ref1 = config_default()(), googleMapsApiKey = ref1.publicRuntimeConfig.googleMapsApiKey;
    var listingCity = cities.list.find(function(city) {
        return city.slug === props.property.detail.city;
    });
    var SVWindowHeight = device === "mobile" ? "100vh" : "calc(100vh - 167px)";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: Types_styles_css/* streetViewModalOuter */.i4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(Types_styles_css/* detailModalHeaderFullScreen */.lG, (0,sprinkles_css/* sprinkles */.K)({
                    display: "flex",
                    justifyContent: "flex-end"
                })),
                children: device === "desktop" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeaderTitle/* default */.Z, {
                            cityName: listingCity.translatedCityName,
                            closeModal: props.closeModal,
                            title: (0,get_translated_title/* default */.Z)(props.property.detail.titles, lang)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                alignItems: "center",
                                display: "flex"
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_LocationZone, {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        marginRight: "s"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                                    children: t("listing-detail:street-view.description")
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCircleIcon/* default */.Z, {
                    ariaLabel: "close dialog",
                    onClick: function() {
                        return props.closeModal();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default.Close */.Z.Close, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    height: SVWindowHeight,
                    position: "relative"
                },
                children: [
                    !props.property.showStreetNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                        className: Types_styles_css/* streetviewBadge */.Gy,
                        icon: "HouseSmall",
                        label: t("listing-detail:street-view.address-disclaimer"),
                        styleVariant: "greyscale"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        allowFullScreen: false,
                        height: "100%",
                        loading: "lazy",
                        referrerPolicy: "no-referrer-when-downgrade",
                        src: "https://www.google.com/maps/embed/v1/streetview?location=".concat(props.property.coordinates.lat, ",").concat(props.property.coordinates.lon, "&key=").concat(googleMapsApiKey, "&source=outdoor&radius=50&pitch=0&heading=0"),
                        style: {
                            border: 0
                        },
                        title: "streetview",
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: 20
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Types_StreetView = (StreetView);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./src/components/Icon/VirtualTour/index.tsx
var VirtualTour = __webpack_require__(96818);
// EXTERNAL MODULE: ./src/components/Modal/style.css.ts
var Modal_style_css = __webpack_require__(92589);
;// CONCATENATED MODULE: ./src/components/Modal/Types/VirtualTour.tsx











var ModalVirtualTour = function(param) {
    var cities = param.cities, city = param.city, closeModal = param.closeModal, device = param.device, listingDetailUrl = param.listingDetailUrl, slug = param.slug, t = param.t, title = param.title, virtualTourUrl = param.virtualTourUrl;
    var router = (0,next_router.useRouter)();
    var listingCity = cities.list.find(function(item) {
        return item.slug === city;
    });
    var modalType = "show-virtual-tour";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: Modal_style_css/* detailModalContent */.FF,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: Types_styles_css/* detailModalHeaderFullScreen */.lG,
                    children: device === "desktop" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeaderTitle/* default */.Z, {
                                cityName: listingCity.translatedCityName,
                                closeModal: closeModal,
                                title: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    alignItems: "center",
                                    display: "flex"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTour/* default */.Z, {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            marginRight: "s"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                                        children: t("common:cta_show_virtual_tour")
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCircleIcon/* default */.Z, {
                                ariaLabel: "close dialog",
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    marginRight: "m"
                                }),
                                onClick: function() {
                                    return closeModal();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        transform: "rotate(90deg)"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading3 */.aC, {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            paddingBottom: "xs"
                                        }),
                                        color: "white",
                                        children: t("common:cta_show_virtual_tour")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                        color: "white",
                                        children: title
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        height: "100%",
                        paddingY: {
                            tablet: "l"
                        }
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            allowFullScreen: true,
                            className: "lazyload",
                            frameBorder: "0",
                            height: "100%",
                            src: virtualTourUrl,
                            title: "".concat(slug, "_vt"),
                            width: "100%"
                        }),
                        listingDetailUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: Modal_style_css/* submitRow */.gJ,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: Modal_style_css/* submitButton */.Fq,
                                onClick: function() {
                                    document.body.classList.remove("fixed-body");
                                    router.push(listingDetailUrl);
                                },
                                children: t("common:view_property")
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Gallery/Buttons/DetailGalleryButton.tsx
var DetailGalleryButton = __webpack_require__(52202);
// EXTERNAL MODULE: ./src/components/Gallery/Buttons/Icon.tsx
var Buttons_Icon = __webpack_require__(57322);
// EXTERNAL MODULE: ./src/components/Gallery/Buttons/styles.css.tsx
var Buttons_styles_css = __webpack_require__(66369);
;// CONCATENATED MODULE: ./src/components/Gallery/Buttons/index.tsx













var ModalGalleryAndPlanimetry = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 51354)).then(function(module) {
        return module.ModalGalleryAndPlanimetry;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51354)
            ];
        }
    }
});
var Button = function(props) {
    var device = (0,Device/* useDevice */.Fy)();
    var ref = (0,ModalContext/* useModal */.dd)(), closeModal = ref.closeModal, openModal = ref.openModal;
    var ref1 = (0,useTranslation/* default */.Z)(), lang = ref1.lang, t = ref1.t;
    var hasVirtualTour = Boolean(props.property.virtualTours && props.property.virtualTours.url);
    var openStreetView = function(e) {
        e.preventDefault();
        (0,eventsHandlers/* handleListingDetailClick */.L1)("StreetView");
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(Types_StreetView, {
            cities: props.cities,
            closeModal: closeModal,
            property: props.property
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: Buttons_styles_css/* buttonsWrapper */.Bx,
        children: [
            hasVirtualTour && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailGalleryButton/* DetailGalleryButton */.F, {
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_Icon/* default */.Z, {
                        kind: "virtualTour"
                    });
                },
                label: device === "mobile" ? t("listing-detail:cta_show_virtual_tour_mobile") : t("listing-detail:cta_show_virtual_tour"),
                onClick: function(event) {
                    event.preventDefault();
                    openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalVirtualTour, {
                        cities: props.cities,
                        city: props.property.detail.city,
                        closeModal: closeModal,
                        device: device,
                        language: lang,
                        slug: props.property.slug,
                        t: t,
                        title: (0,get_translated_title/* default */.Z)(props.property.detail.titles, lang),
                        virtualTourUrl: props.property.virtualTours.url
                    }));
                    (0,eventsHandlers/* handleListingDetailClick */.L1)("VirtualTour");
                }
            }),
            props.property.planimetries && props.property.planimetries.url && props.showFloorPlan && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailGalleryButton/* DetailGalleryButton */.F, {
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_Icon/* default */.Z, {
                        kind: "floorplan"
                    });
                },
                label: t("listing-detail:planimetry"),
                onClick: function(event) {
                    event.preventDefault();
                    openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGalleryAndPlanimetry, {
                        cities: props.cities,
                        citySlug: props.property.detail.city,
                        closeModal: closeModal,
                        images: props.property.photos,
                        openType: "planimetry",
                        planimetryUrl: props.property.planimetries.url,
                        startIndex: 0,
                        title: (0,get_translated_title/* default */.Z)(props.property.detail.titles, lang)
                    }));
                    (0,eventsHandlers/* handleListingDetailClick */.L1)("Planimetry");
                }
            }),
            !props.obfuscateExactLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailGalleryButton/* DetailGalleryButton */.F, {
                "data-testid": "detail-gallery-button-map",
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_Icon/* default */.Z, {
                        kind: "location"
                    });
                },
                label: t("common:text-map"),
                onClick: props.openMap
            }),
            !props.obfuscateExactLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailGalleryButton/* DetailGalleryButton */.F, {
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_Icon/* default */.Z, {
                        kind: "streetView"
                    });
                },
                label: t("listing-detail:street-view.cta"),
                onClick: openStreetView
            })
        ]
    });
};
/* harmony default export */ var Buttons = (Button);

// EXTERNAL MODULE: ./src/components/Gallery/DesktopImageGallery/index.tsx + 1 modules
var DesktopImageGallery = __webpack_require__(82179);
// EXTERNAL MODULE: ./src/components/Gallery/MobileImageGallery/index.tsx + 1 modules
var MobileImageGallery = __webpack_require__(84604);
// EXTERNAL MODULE: ./src/components/InventoryBannerBig/index.ts + 4 modules
var InventoryBannerBig = __webpack_require__(93156);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 9 modules
var Layout = __webpack_require__(97275);
// EXTERNAL MODULE: ./src/components/Layout/index.css.tsx
var index_css = __webpack_require__(44290);
// EXTERNAL MODULE: src/components/ListingDetailSection/style.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ListingDetailSection/style.css.ts.vanilla.css","source":"Ll8xeHIydDExIHsKICB3aWR0aDogMTAwJTsKfQouXzF4cjJ0MTIgewogIHdpZHRoOiA3MCU7Cn0KLl8xeHIydDEzIHsKICBib3JkZXItdG9wOiAxcHggc29saWQgI2YyZjNmMzsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var style_css_ts_vanilla_css_source_Ll8xeHIydDExIHsKICB3aWR0aDogMTAwJTsKfQouXzF4cjJ0MTIgewogIHdpZHRoOiA3MCU7Cn0KLl8xeHIydDEzIHsKICBib3JkZXItdG9wOiAxcHggc29saWQgI2YyZjNmMzsKfQ_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(43392);
;// CONCATENATED MODULE: ./src/components/ListingDetailSection/style.css.ts



var listingDetailSection = (0,vanilla_extract_recipes_createRuntimeFn_esm/* createRuntimeFn */.u)({defaultClassName:'tfghjgeu tfghjgk6',variantClassNames:{wide:{true:'_1xr2t11',false:'_1xr2t12'},hasBorder:{true:'_1xr2t13'}},defaultVariants:{},compoundVariants:[]});
;// CONCATENATED MODULE: ./src/components/ListingDetailSection/index.tsx




var ListingDetailSection = function(param) {
    var children = param.children, hasBorder = param.hasBorder, title = param.title, wide = param.wide;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: listingDetailSection({
            hasBorder: hasBorder,
            wide: wide
        }),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginBottom: "m",
                    textTransform: "uppercase"
                }),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    textAlign: "justify"
                },
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Modal/Types/CasavoProperties.tsx




















var CasavoProperties = function(param) {
    var closeModal = param.closeModal;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var sections = t("casavo-properties-banner:modal_list_items", {}, {
        returnObjects: true
    });
    var ref1 = config_default()(), imageBasePath = ref1.publicRuntimeConfig.imageBasePath;
    var Illustration = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: "",
            className: (0,sprinkles_css/* sprinkles */.K)({
                marginX: "auto"
            }),
            height: 197,
            loading: "lazy",
            src: "".concat(imageBasePath, "/images/concepts/we-buy-or-sell.svg"),
            width: 197
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: Modal_style_css/* casavoPropertiesModalContent */.Iq,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: Types_styles_css/* casavoPropertiesModalInner */.GP,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCircleIcon/* default */.Z, {
                    ariaLabel: "close dialog",
                    onClick: function() {
                        closeModal();
                        (0,eventsHandlers/* handleCasavoPropertyModalClick */.xC)("Close");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                        className: index_es/* colorVariants.greyscale600 */.Jj.greyscale600
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    alignItems: "center",
                    display: "flex"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: Types_styles_css/* casavoPropertiesModalHeader */.gH,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    paddingY: "l"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, "0")
                                    ],
                                    i18nKey: "casavo-properties-banner:title"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    marginBottom: "xl"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: styles_css/* paddingBottom.m */.Et.m
                                        }, "0"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}, "1")
                                    ],
                                    i18nKey: "casavo-properties-banner:modal_subtitle"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThisIsACasavoClaim/* ThisIsACasavoClaim */.l, {
                i18nKey: "PropertyAdvantages:PropertyAdvantages_CasavoProperty_BannerIntro"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    display: {
                        tablet: "flex"
                    },
                    paddingBottom: {
                        mobile: "m",
                        tablet: "xl"
                    }
                }),
                children: [
                    sections[0] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            flex: {
                                tablet: 1
                            }
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                                strong: true,
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    paddingY: "l"
                                }),
                                children: sections[0].title
                            }),
                            sections[0].items.map(function(item, index) {
                                return /*#__PURE__*/ (0,react.createElement)(BannerList, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    key: "modal-item-0-".concat(index)
                                }));
                            })
                        ]
                    }),
                    (0,locale_variables/* isLocaleEnabledFor */.vw)("casavoAncillaryServicesOffered", lang) && sections[1] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: Modal_style_css/* bannerListRight */.rU,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                                strong: true,
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    paddingY: "l"
                                }),
                                children: sections[1].title
                            }),
                            sections[1].items.map(function(item, index) {
                                return /*#__PURE__*/ (0,react.createElement)(BannerList, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    key: "modal-item-1-".concat(index),
                                    imageSize: "m"
                                }));
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                center: true,
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginTop: "l"
                }),
                label: t("casavo-properties-banner:good_to_know"),
                styleVariant: "secondary",
                onClick: function() {
                    closeModal();
                    (0,trackingUtils/* dataLayerPush */.lQ)({
                        event: "casavo.user.interactions",
                        eventAction: "Click",
                        eventCategory: "CasavoPropertyModal",
                        eventLabel: "Close"
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var Types_CasavoProperties = (CasavoProperties);

// EXTERNAL MODULE: ./src/design-lib/components/Icons/Close/index.tsx
var Close = __webpack_require__(31459);
;// CONCATENATED MODULE: ./src/components/Modal/Types/DetailForm.tsx








var ModalDetailForm = function(param) {
    var cities = param.cities, closeModal = param.closeModal, property = param.property, similarPropertiesLength = param.similarPropertiesLength, similarPropertiesRef = param.similarPropertiesRef;
    var ref = (0,react.useState)(false), formIsInSuccess = ref[0], setFormIsInSuccess = ref[1];
    var getWrapperClassName = function() {
        if (formIsInSuccess) return Types_styles_css/* modalDetailFormInner.success */.$n.success;
        return navigator.userAgent.match(/android/i) ? Types_styles_css/* modalDetailFormInner.android */.$n.android : Types_styles_css/* modalDetailFormInner.default */.$n["default"];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                ariaLabel: "Close",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    position: "absolute",
                    right: "m",
                    top: "m"
                }),
                Icon: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
                },
                shapeVariant: "round",
                styleVariant: "tertiary",
                onClick: function() {
                    return closeModal();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: getWrapperClassName(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm, {
                    cities: cities,
                    property: property,
                    similarPropertiesLength: similarPropertiesLength,
                    similarPropertiesRef: similarPropertiesRef,
                    onClose: closeModal,
                    onSuccess: setFormIsInSuccess
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Icon/Location/index.tsx
var Location = __webpack_require__(31471);
// EXTERNAL MODULE: ./src/components/Icon/Tap/index.tsx
var Tap = __webpack_require__(26336);
// EXTERNAL MODULE: ./src/components/ListingCard/index.tsx + 2 modules
var ListingCard = __webpack_require__(59951);
// EXTERNAL MODULE: ./src/components/ListingCardMapMobile/index.tsx + 1 modules
var ListingCardMapMobile = __webpack_require__(59082);
// EXTERNAL MODULE: src/components/poi/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/poi/styles.css.ts.vanilla.css","source":"LnR4d2NjODAgewogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgYm9yZGVyLXJhZGl1czogMThweDsKICBjb2xvcjogIzFEMUQxQjsKICBkaXNwbGF5OiBmbGV4OwogIGZsZXgtc2hyaW5rOiAwOwogIG1hcmdpbi1yaWdodDogMTZweDsKICBwYWRkaW5nOiA3cHggMTRweDsKICB0cmFuc2l0aW9uOiBhbGwgMyBlYXNlOwogIHVzZXItc2VsZWN0OiBub25lOwp9Ci50eHdjYzgwOmZpcnN0LW9mLXR5cGUgewogIG1hcmdpbi1sZWZ0OiAxNnB4Owp9Ci50eHdjYzgxIHsKICBiYWNrZ3JvdW5kOiAjRkZGRkZGOwogIGJvcmRlcjogbm9uZTsKICBib3gtc2hhZG93OiAwIDFweCA0cHggMCByZ2JhKDI5LDI5LDI3LDAuMyk7Cn0KLnR4d2NjODIgewogIGJhY2tncm91bmQ6ICNGRkY1RTk7CiAgYm9yZGVyOiAwIDAgMCAycHggcmVkOwogIGJveC1zaGFkb3c6IDAgMCAwIDNweCAjRkY5OTFGIGluc2V0Owp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDEwMjRweCkgewogIC50eHdjYzgwOmhvdmVyIHsKICAgIGJhY2tncm91bmQtY29sb3I6ICNGRkI4NjI7CiAgICBib3gtc2hhZG93OiAwIDFweCA0cHggMCByZ2JhKDI5LDI5LDI3LDAuMyk7CiAgfQp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_LnR4d2NjODAgewogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgYm9yZGVyLXJhZGl1czogMThweDsKICBjb2xvcjogIzFEMUQxQjsKICBkaXNwbGF5OiBmbGV4OwogIGZsZXgtc2hyaW5rOiAwOwogIG1hcmdpbi1yaWdodDogMTZweDsKICBwYWRkaW5nOiA3cHggMTRweDsKICB0cmFuc2l0aW9uOiBhbGwgMyBlYXNlOwogIHVzZXItc2VsZWN0OiBub25lOwp9Ci50eHdjYzgwOmZpcnN0LW9mLXR5cGUgewogIG1hcmdpbi1sZWZ0OiAxNnB4Owp9Ci50eHdjYzgxIHsKICBiYWNrZ3JvdW5kOiAjRkZGRkZGOwogIGJvcmRlcjogbm9uZTsKICBib3gtc2hhZG93OiAwIDFweCA0cHggMCByZ2JhKDI5LDI5LDI3LDAuMyk7Cn0KLnR4d2NjODIgewogIGJhY2tncm91bmQ6ICNGRkY1RTk7CiAgYm9yZGVyOiAwIDAgMCAycHggcmVkOwogIGJveC1zaGFkb3c6IDAgMCAwIDNweCAjRkY5OTFGIGluc2V0Owp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDEwMjRweCkgewogIC50eHdjYzgwOmhvdmVyIHsKICAgIGJhY2tncm91bmQtY29sb3I6ICNGRkI4NjI7CiAgICBib3gtc2hhZG93OiAwIDFweCA0cHggMCByZ2JhKDI5LDI5LDI3LDAuMyk7CiAgfQp9_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(13281);
;// CONCATENATED MODULE: ./src/components/poi/styles.css.ts

var poiFilterButton = {'default':'txwcc81 txwcc80',active:'txwcc82 txwcc80'};
;// CONCATENATED MODULE: ./src/components/poi/PoiFilterButton.tsx






var PoiFilterButton = function(param) {
    var handlePoiFilter = param.handlePoiFilter, isActive = param.isActive, label = param.label, poiCategory = param.poiCategory;
    var poiCategoryIcon = function() {
        switch(poiCategory){
            case "TRANSPORT":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransportIcon, {
                    "aria-hidden": "true",
                    isActive: isActive
                });
            case "SCHOOL":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SchoolIcon, {
                    "aria-hidden": "true",
                    isActive: isActive
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopIcon, {
                    "aria-hidden": "true",
                    isActive: isActive
                });
        }
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: classnames_default()("poi-filter-button", isActive ? poiFilterButton.active : poiFilterButton["default"]),
        onClick: function() {
            return handlePoiFilter(poiCategory);
        },
        children: [
            poiCategoryIcon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginLeft: "s"
                }),
                children: label
            })
        ]
    });
};
var TransportIcon = function(param) {
    var isActive = param.isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "18",
        viewBox: "0 0 45 45",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.6562 28.125C12.6562 29.6783 13.9154 30.9375 15.4688 30.9375C17.0221 30.9375 18.2812 29.6783 18.2812 28.125C18.2812 26.5717 17.0221 25.3125 15.4688 25.3125C13.9154 25.3125 12.6562 26.5717 12.6562 28.125Z",
                fill: isActive ? index_es/* colors.greyscale600 */.O9.greyscale600 : index_es/* colors.orange600 */.O9.orange600
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.7188 28.125C26.7188 29.6783 27.9779 30.9375 29.5312 30.9375C31.0846 30.9375 32.3438 29.6783 32.3438 28.125C32.3438 26.5717 31.0846 25.3125 29.5312 25.3125C27.9779 25.3125 26.7188 26.5717 26.7188 28.125Z",
                fill: isActive ? index_es/* colors.greyscale600 */.O9.greyscale600 : index_es/* colors.orange600 */.O9.orange600
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.9375 11.25H14.0625V19.6875H30.9375V11.25Z",
                fill: isActive ? index_es/* colors.greyscale600 */.O9.greyscale600 : index_es/* colors.orange600 */.O9.orange600
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M14.0625 0C7.8493 0 2.8125 5.0368 2.8125 11.25V33.75C2.8125 36.8566 5.3309 39.375 8.4375 39.375H9.375L5.625 45H11.25L15 39.375H30L33.75 45H39.375L35.625 39.375H36.5625C39.6691 39.375 42.1875 36.8566 42.1875 33.75V11.25C42.1875 5.0368 37.1507 0 30.9375 0H14.0625ZM30.9375 5.625H14.0625C10.9559 5.625 8.4375 8.1434 8.4375 11.25L8.4375 33.75H36.5625V11.25C36.5625 8.1434 34.0441 5.625 30.9375 5.625Z",
                fill: isActive ? index_es/* colors.greyscale600 */.O9.greyscale600 : index_es/* colors.orange600 */.O9.orange600,
                fillRule: "evenodd"
            })
        ]
    });
};
var SchoolIcon = function(param) {
    var isActive = param.isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        height: "18",
        viewBox: "0 0 45 45",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M8.4375 23.2031L5.625 21.0938V30.9375C5.625 32.4908 4.3658 33.75 2.8125 33.75C1.2592 33.75 0 32.4908 0 30.9375V14.0625L22.5 0L45 16.875L36.5625 23.2031V39.6302C36.5625 40.3443 36.1878 41.0061 35.5754 41.3736C27.5272 46.2025 17.4728 46.2025 9.42459 41.3736C8.8122 41.0061 8.4375 40.3443 8.4375 39.6302V23.2031ZM22.5 7.03125L9.375 16.875L22.5 26.7188L35.625 16.875L22.5 7.03125ZM14.0625 27.4219V37.4816C19.4021 39.9998 25.5979 39.9998 30.9375 37.4816V27.4219L22.5 33.75L14.0625 27.4219Z",
            fill: isActive ? index_es/* colors.greyscale600 */.O9.greyscale600 : index_es/* colors.orange600 */.O9.orange600,
            fillRule: "evenodd"
        })
    });
};
var ShopIcon = function(param) {
    var isActive = param.isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        height: "18",
        viewBox: "0 0 45 45",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M5.625 0H0V5.625H5.625L8.18424 31.2174C8.32801 32.6551 9.53785 33.75 10.9828 33.75H34.5354C35.7459 33.75 36.8207 32.9754 37.2035 31.8269L45 8.4375H11.544L11.25 5.625C11.25 2.5184 8.7316 0 5.625 0ZM13.5281 28.125L12.1218 14.0625H37.1957L32.5082 28.125H13.5281Z",
                fill: isActive ? index_es/* colors.greyscale600 */.O9.greyscale600 : index_es/* colors.orange600 */.O9.orange600,
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.6562 45C10.3263 45 8.4375 43.1112 8.4375 40.7812C8.4375 38.4513 10.3263 36.5625 12.6562 36.5625C14.9862 36.5625 16.875 38.4513 16.875 40.7812C16.875 43.1112 14.9862 45 12.6562 45Z",
                fill: isActive ? index_es/* colors.greyscale600 */.O9.greyscale600 : index_es/* colors.orange600 */.O9.orange600
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.3438 45C30.0138 45 28.125 43.1112 28.125 40.7812C28.125 38.4513 30.0138 36.5625 32.3438 36.5625C34.6737 36.5625 36.5625 38.4513 36.5625 40.7812C36.5625 43.1112 34.6737 45 32.3438 45Z",
                fill: isActive ? index_es/* colors.greyscale600 */.O9.greyscale600 : index_es/* colors.orange600 */.O9.orange600
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/PoiCard/index.tsx + 1 modules
var PoiCard = __webpack_require__(64591);
// EXTERNAL MODULE: ./src/utils/points-of-interest.ts
var points_of_interest = __webpack_require__(13782);
;// CONCATENATED MODULE: ./src/components/Modal/Types/Map.tsx































var filterOrder = [
    "TRANSPORT",
    "SHOP",
    "SCHOOL"
];
var SimpleGoogleMapsNoSsr = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3801), __webpack_require__.e(7809)]).then(__webpack_require__.bind(__webpack_require__, 87809));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87809)
            ];
        }
    },
    ssr: false
});
var ModalMap = function(param) {
    var cities = param.cities, closeModal = param.closeModal, closestPointsOfInterest = param.closestPointsOfInterest, _filter = param.filter, filter = _filter === void 0 ? "CLOSEST" : _filter, handleOpenDetailFormModal = param.handleOpenDetailFormModal, handleTrackingCallAgency = param.handleTrackingCallAgency, listing = param.listing, pointsOfInterest = param.pointsOfInterest, _selectedMarker = param.selectedMarker, selectedMarker = _selectedMarker === void 0 ? null : _selectedMarker, similarPropertiesRef = param.similarPropertiesRef;
    var ref;
    var device = (0,Device/* useDevice */.Fy)();
    var coordinates = listing.coordinates, _detail = listing.detail, city = _detail.city, titles = _detail.titles;
    var ref1 = (0,react.useState)(selectedMarker), cardOpen = ref1[0], setCardOpen = ref1[1];
    var ref2 = (0,react.useState)(closestPointsOfInterest), visiblePois = ref2[0], setVisiblePois = ref2[1];
    var ref3 = (0,react.useState)(filter), currentFilter = ref3[0], setCurrentFilter = ref3[1];
    var ref4 = (0,useTranslation/* default */.Z)(), lang = ref4.lang, t = ref4.t;
    var listingCity = cities.list.find(function(item) {
        return item.slug === city;
    });
    var handleClickOnCard = function(prevCardOpen, clickedCard) {
        var newCard = prevCardOpen === clickedCard ? null : clickedCard;
        newCard !== null && (0,eventsHandlers/* handleListingDetailMapClick */.rt)(newCard === "property" ? "PropertyMarker" : "Poi".concat(newCard.poiType));
        setCardOpen(newCard);
    };
    var onMapClicked = (0,react.useCallback)(function() {
        handleClickOnCard(cardOpen, null);
    }, [
        handleClickOnCard
    ]);
    var handlePoiFilter = function(clickedFilter) {
        setCardOpen(null);
        if (currentFilter === clickedFilter) setCurrentFilter("CLOSEST");
        else {
            setCurrentFilter(clickedFilter);
            (0,eventsHandlers/* handleListingDetailMapClick */.rt)("PoiFilter".concat(clickedFilter));
        }
    };
    (0,react.useEffect)(function() {
        if (currentFilter === "CLOSEST") setVisiblePois(closestPointsOfInterest);
        else setVisiblePois(pointsOfInterest.filter(function(p) {
            return points_of_interest/* poiTypes */.Fq[currentFilter].types.includes(p.poiType);
        }));
    }, [
        currentFilter
    ]);
    // Show POIs only for main cities: eg. milano, roma, firenze, etc...
    var shouldShowPoi = cities.router.area.name === ((ref = cities.router.city) === null || ref === void 0 ? void 0 : ref.name) && (0,locale_variables/* isLocaleEnabledFor */.vw)("POIs", lang);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()(Modal_style_css/* detailModalContent */.FF, (0,sprinkles_css/* sprinkles */.K)({
                overflow: "hidden"
            })),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: Types_styles_css/* detailModalHeaderFullScreen */.lG,
                    children: device === "desktop" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeaderTitle/* default */.Z, {
                                cityName: listingCity.translatedCityName,
                                closeModal: closeModal,
                                title: (0,get_translated_title/* default */.Z)(titles, lang)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    alignItems: "center",
                                    display: "flex"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Location/* default */.Z, {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            marginRight: "s"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                                        children: t("common:text-map")
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCircleIcon/* default */.Z, {
                        ariaLabel: "close dialog",
                        onClick: function() {
                            return closeModal();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                            direction: "left"
                        })
                    })
                }),
                shouldShowPoi && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: Types_styles_css/* mapModalInner */.Dz,
                    "data-testid": "map-pois-filters",
                    children: [
                        device === "desktop" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Small */.x4, {
                            strong: true,
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                textTransform: "uppercase"
                            }),
                            children: t("listing-detail:poi_discover")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: Modal_style_css/* poiFilters */.lN,
                            children: [
                                filterOrder.map(function(p) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PoiFilterButton, {
                                        handlePoiFilter: handlePoiFilter,
                                        isActive: currentFilter === p,
                                        label: t("listing-detail:".concat(p, ".poi_category")),
                                        poiCategory: p
                                    }, p);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: Modal_style_css/* spacer */.OF
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        height: "100%",
                        paddingY: {
                            tablet: "l"
                        }
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGoogleMapsNoSsr, {
                        coordinates: coordinates,
                        currentFilter: currentFilter,
                        enableTouch: device === "mobile",
                        isInModal: true,
                        markerChild: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: device === "desktop" && cardOpen === "property" && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                animate: {
                                    opacity: 1,
                                    x: -215,
                                    y: -180
                                },
                                exit: {
                                    opacity: 0,
                                    x: -215,
                                    y: -170
                                },
                                initial: {
                                    opacity: 0,
                                    x: -215,
                                    y: -170
                                },
                                style: {
                                    width: 470
                                },
                                transition: {
                                    duration: 0.3,
                                    type: "tween"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingCard/* default */.Z, {
                                    isLoading: false,
                                    isOnMap: true,
                                    listing: listing,
                                    onListingCardHover: null
                                })
                            })
                        }),
                        markerClicked: cardOpen,
                        options: {
                            disableDoubleClickZoom: cardOpen !== null,
                            zoomControl: device === "desktop"
                        },
                        pointsOfInterest: visiblePois,
                        zoom: 16,
                        onClick: onMapClicked,
                        onClickOnMarker: function() {},
                        onClickPOI: function(poi) {
                            return handleClickOnCard(cardOpen, poi);
                        }
                    })
                }),
                device === "mobile" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingCardMobileDetail, {
                            handleOpenDetailFormModal: handleOpenDetailFormModal,
                            handleTrackingCallAgency: handleTrackingCallAgency,
                            property: listing,
                            similarPropertiesRef: similarPropertiesRef
                        }),
                        cardOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: Modal_style_css/* poiCardWrapperMobile */.nA,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoiCard/* default */.Z, {
                                poi: cardOpen
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var ListingCardMobileDetail = function(param) {
    var handleOpenDetailFormModal = param.handleOpenDetailFormModal, handleTrackingCallAgency = param.handleTrackingCallAgency, property = param.property, similarPropertiesRef = param.similarPropertiesRef;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    /** Display the call button only for third party properties */ var shouldShowCallCta = isThirdParty(property);
    /** Exclude unsupported locales and third party properties from the visit experience */ var canHaveVisitFunctionality = !isThirdParty(property);
    var listingTitle = property.detail.titles.find(function(title) {
        return title.language === lang;
    }).text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: Modal_style_css/* mapModalListingCard */.Lk,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingCardMapMobile/* default */.Z, {
                isAggregateListOpen: false,
                isOnDetail: true,
                property: property
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-testid": "map-contact-buttons-wrapper",
                children: [
                    shouldShowCallCta && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                        center: true,
                        fullWidth: true,
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            flex: 1
                        }),
                        href: "tel:".concat(property.contactInfo.telephoneNumberContact),
                        Icon: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                color: index_es/* colors.greyscale600 */.O9.greyscale600,
                                height: 20,
                                width: 20
                            }));
                        },
                        label: t("listing-detail:phone_call"),
                        sizeVariant: "small",
                        styleVariant: "secondary",
                        onClick: function() {
                            handleTrackingCallAgency("ListingDetailMap");
                        }
                    }),
                    canHaveVisitFunctionality ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            styles_css/* flexCenter */._7,
                            styles_css/* gap.s */.SG.s,
                            (0,sprinkles_css/* sprinkles */.K)({
                                marginTop: "l"
                            })
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactCTA, {
                                isMobile: true,
                                listing: property,
                                listingTitle: listingTitle,
                                requestType: "info",
                                similarPropertiesRef: similarPropertiesRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactCTA, {
                                isMobile: true,
                                "data-testid": "request-visit-button",
                                listing: property,
                                listingTitle: listingTitle,
                                requestType: "visit",
                                similarPropertiesRef: similarPropertiesRef
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        center: true,
                        fullWidth: true,
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            flex: 1
                        }),
                        Icon: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tap/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
                        },
                        label: t("listing-detail:contact_us"),
                        sizeVariant: "small",
                        onClick: handleOpenDetailFormModal
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/SimilarPropertiesCarousel/index.tsx
var SimilarPropertiesCarousel = __webpack_require__(11244);
// EXTERNAL MODULE: ./src/context/RelatedAdsBannerProvider.tsx
var RelatedAdsBannerProvider = __webpack_require__(96277);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(7680);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Link/linkBuilder.ts
var linkBuilder = __webpack_require__(13976);
// EXTERNAL MODULE: ./src/utils/breadcrumb-list.ts
var breadcrumb_list = __webpack_require__(15037);
;// CONCATENATED MODULE: ./src/utils/description-translations.ts
var get = function(descriptions, language) {
    var translatedDescription = descriptions.find(function(d) {
        return d.language.toLowerCase() === language.toLowerCase();
    });
    if (translatedDescription && translatedDescription.propertyDescription) {
        return translatedDescription;
    }
    return descriptions[0];
};
var descriptionTranslations = {
    get: get
};
/* harmony default export */ var description_translations = (descriptionTranslations);

// EXTERNAL MODULE: ./src/utils/getAlternatePageLinks.tsx
var getAlternatePageLinks = __webpack_require__(11755);
;// CONCATENATED MODULE: ./src/heads/listing-detail.tsx











var ListingDetailHead = function(param) {
    var cities = param.cities, listing = param.listing;
    var ref, ref1;
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var ref2 = (0,useTranslation/* default */.Z)(), lang = ref2.lang, t = ref2.t;
    var translatedCityName = cities.router.city.translatedCityName;
    var canonicalUrlPath = linkBuilder/* linkBuilder.listingDetail.url */.H.listingDetail.url(lang, listing.id);
    var canonicalFullUrl = "".concat(publicRuntimeConfig.lisaWebsite).concat(canonicalUrlPath);
    // Photo, title and description
    var photoUrl = (ref = listing.photos[0]) === null || ref === void 0 ? void 0 : ref.url;
    var metaTitle = "".concat((0,get_translated_title/* default */.Z)((ref1 = listing.detail) === null || ref1 === void 0 ? void 0 : ref1.titles, lang), " ").concat(t("listing-detail:title_0"), " ").concat(translatedCityName, " | Casavo");
    var metaDescriptions = description_translations.get(listing.descriptions, lang);
    var metaDescription = metaDescriptions.propertyDescription ? metaDescriptions.propertyDescription.substring(0, 250) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaDescription,
                        name: "description"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: lang,
                        property: "og:locale"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "article",
                        property: "og:type"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaTitle,
                        property: "og:title"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaDescription,
                        property: "og:description"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "".concat(photoUrl, "?auto=compress,format&fit=clamp&ar=1:1&h=400"),
                        property: "og:image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: canonicalFullUrl,
                        property: "og:url"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "Casavo",
                        property: "og:site_name"
                    }),
                    (0,getAlternatePageLinks/* getAlternatePageLinksForListingDetail */.Gd)(lang, listing.id),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: canonicalFullUrl,
                        rel: "canonical"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "summary_large_image",
                        name: "twitter:card"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaDescription,
                        name: "twitter:description"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaTitle,
                        name: "twitter:title"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: (0,breadcrumb_list/* getBreadcrumbList */.U)({
                    cities: cities.list,
                    city: cities.router.city,
                    depth: "listingDetail",
                    language: lang,
                    property: listing,
                    t: t
                })
            })
        ]
    });
};
/* harmony default export */ var listing_detail = (ListingDetailHead);

// EXTERNAL MODULE: ./src/hooks/usePageYOffset.ts
var usePageYOffset = __webpack_require__(29961);
// EXTERNAL MODULE: ./src/hooks/useTagManager.ts
var useTagManager = __webpack_require__(31551);
// EXTERNAL MODULE: ./src/shared-styles/common-variables.tsx
var common_variables = __webpack_require__(38730);
// EXTERNAL MODULE: ./src/types/poi.ts
var poi = __webpack_require__(28961);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(59879);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(36947);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
;// CONCATENATED MODULE: ./src/utils/fomo-helper.ts



// eslint-disable-next-line import/no-named-as-default-member
dayjs_min_default().extend((utc_default()));
// eslint-disable-next-line import/no-named-as-default-member
dayjs_min_default().extend((timezone_default()));
var hash = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return 10 + id.split("").reduce(function(acc, c) {
        return acc + c.charCodeAt(0);
    }, 0) % 10;
};
var coefficientPerHours = {
    "0": 0.4333333333,
    "1": 0.1666666667,
    "2": 0.06666666667,
    "3": 0.03333333333,
    "4": 0.1,
    "5": 0.2,
    "6": 0.4,
    "7": 0.8333333333,
    "8": 0.7666666667,
    "9": 0.6,
    "10": 0.6666666667,
    "11": 0.6666666667,
    "12": 0.8666666667,
    "13": 1.066666667,
    "14": 1.033333333,
    "15": 0.8,
    "16": 0.7666666667,
    "17": 0.7333333333,
    "18": 0.8666666667,
    "19": 0.8333333333,
    "20": 1.033333333,
    "21": 0.9,
    "22": 1.133333333,
    "23": 0.4
};
var getPreviousHourViews = function(id) {
    var value = hash(id);
    var tolerance = 12;
    var previousHour = dayjs_min_default().tz(new Date(), "Europe/Rome").subtract(1, "hour").hour();
    var dayOfMonth = dayjs_min_default().tz(new Date(), "Europe/Rome").date();
    var coefficient = coefficientPerHours[previousHour];
    var activeUser = value + (previousHour + dayOfMonth) % tolerance;
    var returnValue = Math.ceil(activeUser * coefficient);
    return returnValue < 1 ? 1 : returnValue;
};

// EXTERNAL MODULE: ./src/utils/getTranslatedStateOfMaintenance.ts
var getTranslatedStateOfMaintenance = __webpack_require__(77784);
// EXTERNAL MODULE: ./src/utils/new-property.ts
var new_property = __webpack_require__(69854);
// EXTERNAL MODULE: ./src/utils/tracking/eventCategory.ts
var eventCategory = __webpack_require__(66576);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-accordion/dist/index.module.js + 1 modules
var index_module = __webpack_require__(25932);
// EXTERNAL MODULE: src/design-lib/components/Accordion/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/components/Accordion/styles.css.ts.vanilla.css","source":"QGtleWZyYW1lcyBfMXllcHhwNDMgewogIGZyb20gewogICAgaGVpZ2h0OiAwOwogIH0KICB0byB7CiAgICBoZWlnaHQ6IHZhcigtLXJhZGl4LWFjY29yZGlvbi1jb250ZW50LWhlaWdodCk7CiAgfQp9CkBrZXlmcmFtZXMgXzF5ZXB4cDQ0IHsKICBmcm9tIHsKICAgIGhlaWdodDogdmFyKC0tcmFkaXgtYWNjb3JkaW9uLWNvbnRlbnQtaGVpZ2h0KTsKICB9CiAgdG8gewogICAgaGVpZ2h0OiAwOwogIH0KfQouXzF5ZXB4cDQyIHsKICBjb2xvcjogIzFEMUQxQjsKICBmb250LXdlaWdodDogNDAwOwogIGZvbnQtc2l6ZTogMTRweDsKfQouXzF5ZXB4cDQ2IHsKICBvdmVyZmxvdzogaGlkZGVuOwp9Ci5fMXllcHhwNDZbZGF0YS1zdGF0ZT0ib3BlbiJdIHsKICBhbmltYXRpb246IF8xeWVweHA0MyAzMDBtcyBjdWJpYy1iZXppZXIoMC44NywgMCwgMC4xMywgMSk7Cn0KLl8xeWVweHA0NltkYXRhLXN0YXRlPSJjbG9zZWQiXSB7CiAgYW5pbWF0aW9uOiBfMXllcHhwNDQgMzAwbXMgY3ViaWMtYmV6aWVyKDAuODcsIDAsIDAuMTMsIDEpOwp9Ci5fMXllcHhwNDggewogIGNvbG9yOiAjMUQxRDFCOwogIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpOwp9Ci5fMXllcHhwNDJbZGF0YS1zdGF0ZT0ib3BlbiJdID4gLl8xeWVweHA0OCB7CiAgdHJhbnNmb3JtOiByb3RhdGUoMTgwZGVnKTsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_QGtleWZyYW1lcyBfMXllcHhwNDMgewogIGZyb20gewogICAgaGVpZ2h0OiAwOwogIH0KICB0byB7CiAgICBoZWlnaHQ6IHZhcigtLXJhZGl4LWFjY29yZGlvbi1jb250ZW50LWhlaWdodCk7CiAgfQp9CkBrZXlmcmFtZXMgXzF5ZXB4cDQ0IHsKICBmcm9tIHsKICAgIGhlaWdodDogdmFyKC0tcmFkaXgtYWNjb3JkaW9uLWNvbnRlbnQtaGVpZ2h0KTsKICB9CiAgdG8gewogICAgaGVpZ2h0OiAwOwogIH0KfQouXzF5ZXB4cDQyIHsKICBjb2xvcjogIzFEMUQxQjsKICBmb250LXdlaWdodDogNDAwOwogIGZvbnQtc2l6ZTogMTRweDsKfQouXzF5ZXB4cDQ2IHsKICBvdmVyZmxvdzogaGlkZGVuOwp9Ci5fMXllcHhwNDZbZGF0YS1zdGF0ZT0ib3BlbiJdIHsKICBhbmltYXRpb246IF8xeWVweHA0MyAzMDBtcyBjdWJpYy1iZXppZXIoMC44NywgMCwgMC4xMywgMSk7Cn0KLl8xeWVweHA0NltkYXRhLXN0YXRlPSJjbG9zZWQiXSB7CiAgYW5pbWF0aW9uOiBfMXllcHhwNDQgMzAwbXMgY3ViaWMtYmV6aWVyKDAuODcsIDAsIDAuMTMsIDEpOwp9Ci5fMXllcHhwNDggewogIGNvbG9yOiAjMUQxRDFCOwogIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpOwp9Ci5fMXllcHhwNDJbZGF0YS1zdGF0ZT0ib3BlbiJdID4gLl8xeWVweHA0OCB7CiAgdHJhbnNmb3JtOiByb3RhdGUoMTgwZGVnKTsKfQ_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(21464);
;// CONCATENATED MODULE: ./src/design-lib/components/Accordion/styles.css.ts


var accordionChevron = '_1yepxp48 tfghjgco';
var accordionContent = '_1yepxp46 tfghjg2c';
var accordionHeader = 'tfghjg1u tfghjgac tfghjgaj';
var accordionHeaderTrigger = '_1yepxp42 tfghjggx tfghjgi3 tfghjgjr tfghjgg9 tfghjg6 tfghjgac tfghjgaj tfghjg8f tfghjg1u tfghjg8l tfghjgl6';
;// CONCATENATED MODULE: ./src/design-lib/components/Accordion/index.tsx








var AccordionRoot = /*#__PURE__*/ react.forwardRef(function(_param, forwardedRef) /*#__PURE__*/ {
    var children = _param.children, defaultOpenedItem = _param.defaultOpenedItem, onToggle = _param.onToggle, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "defaultOpenedItem",
        "onToggle"
    ]);
    return (0,jsx_runtime.jsx)(index_module/* Root */.fC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        collapsible: true,
        defaultValue: defaultOpenedItem,
        type: "single",
        onValueChange: onToggle
    }, props), {
        ref: forwardedRef,
        children: children
    }));
});
var AccordionTrigger = /*#__PURE__*/ react.forwardRef(function(_param, forwardedRef) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(index_module/* Header */.h4, {
        className: accordionHeader,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Trigger */.xz, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: accordionHeaderTrigger
        }, props), {
            ref: forwardedRef,
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                    "aria-hidden": true,
                    className: accordionChevron,
                    width: 15
                })
            ]
        }))
    });
});
var AccordionItem = /*#__PURE__*/ react.forwardRef(function(_param, forwardedRef) /*#__PURE__*/ {
    var children = _param.children, name = _param.name, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "name"
    ]);
    return (0,jsx_runtime.jsx)(index_module/* Item */.ck, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        value: name
    }, props), {
        ref: forwardedRef,
        children: children
    }));
});
var AccordionContent = /*#__PURE__*/ react.forwardRef(function(_param, forwardedRef) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(index_module/* Content */.VY, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: accordionContent
    }, props), {
        ref: forwardedRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "AccordionContentText",
            children: children
        })
    }));
});

// EXTERNAL MODULE: ./src/types/graphql-generated-types.ts
var graphql_generated_types = __webpack_require__(98733);
// EXTERNAL MODULE: ./src/utils/format-currency.ts
var format_currency = __webpack_require__(58577);
// EXTERNAL MODULE: ./src/containers/ListingDetail/styles.css.ts
var ListingDetail_styles_css = __webpack_require__(37389);
;// CONCATENATED MODULE: ./src/containers/ListingDetail/AccordionDetailInfo.tsx












var AccordionDetailInfo = function(param) {
    var listing = param.listing;
    var ref;
    var ref1 = (0,useTranslation/* default */.Z)(), lang = ref1.lang, t = ref1.t;
    var device = (0,Device/* useDevice */.Fy)();
    var dateFormat = device === "mobile" ? "short" : "long";
    var ref2 = (0,react.useState)(false), isOpening = ref2[0], setIsOpening = ref2[1];
    var listingCreationDate = listing.publishedAt !== undefined ? (0,utils_date/* formatDate */.p6)(dateFormat, lang, listing.publishedAt) : undefined;
    var listingUpdateDate = listing.updatedAt !== undefined ? (0,utils_date/* formatDate */.p6)(dateFormat, lang, listing.updatedAt) : undefined;
    var lastUpdateDate = listingUpdateDate || listingCreationDate;
    var detailInfo = [
        {
            condition: listing.additionalInfo.kitchen,
            label: "kitchen",
            value: t("listing-detail:kitchen_".concat(listing.additionalInfo.kitchen))
        },
        {
            condition: listing.additionalInfo.glazing,
            label: "glazing",
            value: t("listing-detail:glazing_".concat(listing.additionalInfo.glazing))
        },
        {
            condition: listing.additionalInfo.furnishings,
            label: "furniture",
            value: t("listing-detail:".concat(listing.additionalInfo.furnishings))
        },
        {
            condition: listing.additionalInfo.lastRenovationYear,
            label: "year_of_renovation",
            value: listing.additionalInfo.lastRenovationYear
        },
        {
            condition: listing.additionalInfo.constructionYear,
            label: "year_of_construction",
            value: listing.additionalInfo.constructionYear
        },
        {
            condition: listing.additionalInfo.condoFeesPerYearCate && listing.additionalInfo.condoFeesPerYearCate.cents,
            label: "condo_fees",
            value: "".concat((0,format_currency/* formatPrice */.T)(listing.additionalInfo.condoFeesPerYearCate, lang), " ").concat(t("listing-detail:per_year_label"))
        },
        {
            condition: listing.additionalInfo.stateAtDeed && listing.additionalInfo.stateAtDeed !== graphql_generated_types/* StateAtDeed.Unknown */.uV.Unknown,
            label: "state_at_deed",
            value: t("listing-detail:".concat(listing.additionalInfo.stateAtDeed))
        },
        {
            condition: listing.additionalInfo.exposure && listing.additionalInfo.exposure.length > 0,
            label: "exposure",
            value: listing.additionalInfo.exposure && listing.additionalInfo.exposure.map(function(exposure) {
                return t("listing-detail:".concat(exposure));
            }).join(", ")
        },
        {
            condition: listing.additionalInfo.views && listing.additionalInfo.views.length > 0,
            label: "view",
            value: listing.additionalInfo.views && listing.additionalInfo.views.map(function(view) {
                return t("listing-detail:view_".concat(view));
            }).join(", ")
        },
        {
            condition: listing.additionalInfo.heatingSystem,
            label: "heating_system",
            value: t("listing-detail:".concat(listing.additionalInfo.heatingSystem))
        },
        {
            condition: listing.additionalInfo.coolingSystem && listing.additionalInfo.coolingSystem !== "NONE",
            label: "coolingSystem_full",
            value: t("listing-detail:coolingSystem_".concat(listing.additionalInfo.coolingSystem))
        },
        {
            condition: listing.additionalInfo.energyRating && listing.additionalInfo.energyRating !== "NONE",
            label: "energy_rating_label",
            value: t("listing-detail:energy_rating.energy_".concat((ref = listing.additionalInfo.energyRating) === null || ref === void 0 ? void 0 : ref.toLowerCase()))
        },
        {
            condition: listing.additionalInfo.energyPerformanceIndex,
            label: "energy_performance_index_label",
            value: "".concat(listing.additionalInfo.energyPerformanceIndex, " ").concat(t("listing-detail:energy_performance_index_udm"))
        },
        {
            condition: listing.additionalInfo.estateRegistryClass && listing.additionalInfo.estateRegistryClass !== "NONE",
            label: "estate_registry_class",
            value: listing.additionalInfo.estateRegistryClass
        },
        {
            condition: lastUpdateDate,
            label: "last_update",
            value: lastUpdateDate
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionRoot, {
        defaultOpenedItem: "",
        onToggle: function(value) {
            setIsOpening(value === "characteristics");
            value === "characteristics" ? (0,eventsHandlers/* handleListingDetailClick */.L1)("ShowAllCharacteristics") : (0,eventsHandlers/* handleListingDetailClick */.L1)("ShowLessCharacteristics");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionItem, {
            name: "characteristics",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            display: "flex",
                            flexDirection: "column",
                            paddingTop: "xl"
                        }),
                        children: detailInfo.map(function(info, index) {
                            return info.condition ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: ListingDetail_styles_css/* detailInfoRow */.s3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                        children: t("listing-detail:".concat(info.label))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            textAlign: "right"
                                        }),
                                        color: "greyscale600",
                                        children: info.value
                                    })
                                ]
                            }, index) : null;
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionTrigger, {
                    children: t(isOpening ? "listing-detail:see_less_characteristics" : "listing-detail:see_all_characteristics")
                })
            ]
        })
    });
};
/* harmony default export */ var ListingDetail_AccordionDetailInfo = (AccordionDetailInfo);

// EXTERNAL MODULE: ./src/containers/ListingDetail/Characteristics.tsx
var Characteristics = __webpack_require__(9577);
;// CONCATENATED MODULE: ./src/components/Icon/Mail/index.tsx


var Mail = function(param) {
    var className = param.className, _filled = param.filled, filled = _filled === void 0 ? false : _filled;
    if (filled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, {
            className: className,
            viewBox: "0 0 14 12",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M6.99769 6.96891L13.6673 4.46891V10.3022C13.6673 11.2227 12.9211 11.9689 12.0007 11.9689H2.00065C1.08018 11.9689 0.333984 11.2227 0.333984 10.3022V4.46891L6.99769 6.96891ZM0.333984 1.96891C0.333984 1.04844 1.08018 0.302246 2.00065 0.302246H12.0007C12.9211 0.302246 13.6673 1.04844 13.6673 1.96891V2.80225L7.01517 5.30225L0.333984 2.80225V1.96891Z",
                fillRule: "evenodd"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, {
        className: className,
        viewBox: "0 0 16 17",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14 1.63477C15.1046 1.63477 16 2.5302 16 3.63477V13.6348C16 14.7393 15.1046 15.6348 14 15.6348H2C0.89543 15.6348 0 14.7393 0 13.6348V3.63477C0 2.5302 0.89543 1.63477 2 1.63477H14ZM14 7.38477L7.99645 9.63477L2 7.38477V13.6348H14V7.38477ZM14 3.63477H2V5.38277L8.01742 7.63477L14 5.38677V3.63477Z"
        })
    });
};
/* harmony default export */ var Icon_Mail = (Mail);

// EXTERNAL MODULE: src/components/RevealButton/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/RevealButton/styles.css.ts.vanilla.css","source":"Ll80b3gwNjQwIHsKICBjb2xvcjogdmFyKC0tXzFtdWg4bmtvKTsKICBmb250LXNpemU6IDE0cHg7CiAgZm9udC1zdHlsZTogbm9ybWFsOwogIGZvbnQtd2VpZ2h0OiBub3JtYWw7CiAgbGluZS1oZWlnaHQ6IDE4cHg7CiAgdGV4dC1kZWNvcmF0aW9uLWxpbmU6IHVuZGVybGluZTsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_Ll80b3gwNjQwIHsKICBjb2xvcjogdmFyKC0tXzFtdWg4bmtvKTsKICBmb250LXNpemU6IDE0cHg7CiAgZm9udC1zdHlsZTogbm9ybWFsOwogIGZvbnQtd2VpZ2h0OiBub3JtYWw7CiAgbGluZS1oZWlnaHQ6IDE4cHg7CiAgdGV4dC1kZWNvcmF0aW9uLWxpbmU6IHVuZGVybGluZTsKfQ_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(78054);
;// CONCATENATED MODULE: ./src/components/RevealButton/styles.css.ts


var showPhoneButton = '_4ox0640';
;// CONCATENATED MODULE: ./src/components/RevealButton/index.tsx








var RevealButton = function(_param) {
    var buttonLabel = _param.buttonLabel, children = _param.children, clickRevealButtonHandler = _param.clickRevealButtonHandler, shouldRevealContent = _param.shouldRevealContent, props = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonLabel",
        "children",
        "clickRevealButtonHandler",
        "shouldRevealContent"
    ]);
    return shouldRevealContent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        animate: {
            scale: [
                1,
                1.02,
                1
            ]
        },
        className: (0,sprinkles_css/* sprinkles */.K)({
            display: "inline-block"
        }),
        transition: {
            duration: 0.3,
            ease: "easeOut"
        },
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: showPhoneButton
    }, props), {
        onClick: clickRevealButtonHandler,
        children: buttonLabel
    }));
};
/* harmony default export */ var components_RevealButton = (RevealButton);

;// CONCATENATED MODULE: ./src/containers/ListingDetail/DetailContacts.tsx






















var getHeader = function(inventory) {
    switch(inventory){
        case types_listing/* CasavoInventory.Agency */.M.Agency:
            return "PropertyAdvantages:PropertyAdvantages_CasavoGuarantee_From_Title";
        case types_listing/* CasavoInventory.iBuyer */.M.iBuyer:
            return "listing-detail:at_your_service_casavo";
        case types_listing/* CasavoInventory.Third_Party */.M.Third_Party:
            return "listing-detail:at_your_service_agency";
    }
};
var DetailContacts = function(param) {
    var advantages = param.advantages, clickShowNumberButtonHandler = param.clickShowNumberButtonHandler, property = param.property, shouldShowPhoneNumber = param.shouldShowPhoneNumber, similarPropertiesRef = param.similarPropertiesRef;
    var t = (0,useTranslation/* default */.Z)().t;
    var device = (0,Device/* useDevice */.Fy)();
    var handleClickRequestInfo = function(e) {
        e.preventDefault();
        (0,dom_interactions_helpers/* anchorSmoothScroll */.e)("#contactForm", device === "mobile" ? -80 : -100);
        (0,eventsHandlers/* handleListingDetailClick */.L1)("RequestInfo");
    };
    var lang = (0,useTranslation/* default */.Z)().lang;
    var thirdParty = isThirdParty(property);
    var isPropriooListing = property.country === "france";
    var shouldShowAgencyPhoneNumber = thirdParty && !!property.contactInfo.agencyName && !!property.contactInfo.telephoneNumberContact && !isPropriooListing;
    var listingTitle = property.detail.titles.find(function(title) {
        return title.language === lang;
    }).text;
    var inventoryHeader = getHeader(property.detail.inventory);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ListingDetail_styles_css/* detailContactBox */.QS,
        "data-testid": "detail-contact-box",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: thirdParty ? ListingDetail_styles_css/* detailContactsOuter.thirdParty */.SA.thirdParty : ListingDetail_styles_css/* detailContactsOuter.default */.SA["default"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    components: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}, "0"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                fontWeight: 600
                            })
                        }, "1")
                    ],
                    i18nKey: inventoryHeader
                })
            }),
            thirdParty && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styles_css/* paddingBottom.xl */.Et.xl,
                "data-testid": "third-party-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* BodyM */.iO, {
                        className: ListingDetail_styles_css/* detailContactsAgencyName */.fP,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HouseRent, {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    display: "inline-block",
                                    marginRight: "s-m",
                                    verticalAlign: "baseline"
                                })
                            }),
                            property.contactInfo.agencyName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                        color: "greyscale500",
                        children: property.contactInfo.agencyAddress
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styles_css/* paddingBottom.l */.Et.l,
                children: advantages.filter(function(advantage) {
                    return t(advantage.titleTranslationKey) !== "";
                }).map(function(advantage) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithCheck/* LabelWithCheck */.y, {
                        children: t(advantage.titleTranslationKey)
                    }, advantage.titleTranslationKey);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ListingDetail_styles_css/* detailContactsRequestContactCta */.Hi,
                children: !thirdParty ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactCTA, {
                            listing: property,
                            listingTitle: listingTitle,
                            requestType: "info",
                            similarPropertiesRef: similarPropertiesRef
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactCTA, {
                            "data-testid": "request-visit-button",
                            listing: property,
                            listingTitle: listingTitle,
                            requestType: "visit",
                            similarPropertiesRef: similarPropertiesRef
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        shouldShowAgencyPhoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: ListingDetail_styles_css/* detailContactPhone */.$O,
                            "data-testid": "detailContacts-phone-contact",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, {
                                    className: classnames_default()(index_es/* colorVariants.greyscale600 */.Jj.greyscale600, (0,sprinkles_css/* sprinkles */.K)({
                                        display: "inline-block",
                                        marginRight: "s",
                                        marginTop: "xs"
                                    })),
                                    height: 20,
                                    width: 20
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RevealButton, {
                                    buttonLabel: t("listing-detail:show_number"),
                                    clickRevealButtonHandler: clickShowNumberButtonHandler,
                                    "data-testid": "agency-number-button",
                                    shouldRevealContent: shouldShowPhoneNumber,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                        color: "greyscale500",
                                        children: property.contactInfo.telephoneNumberContact
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            fullWidth: true,
                            "data-testid": "request-info-cta",
                            Icon: function(props) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_Mail, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                    height: 20,
                                    width: 20
                                }));
                            },
                            label: t("listing-detail:request_info"),
                            styleVariant: "primary",
                            onClick: handleClickRequestInfo
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ListingDetail_DetailContacts = (DetailContacts);

// EXTERNAL MODULE: ./src/components/Floor/index.ts + 1 modules
var Floor = __webpack_require__(37826);
// EXTERNAL MODULE: ./src/utils/format-listing-pricePerSquareMeter.ts
var format_listing_pricePerSquareMeter = __webpack_require__(47593);
// EXTERNAL MODULE: ./src/utils/format-listing-sellingPrice.ts
var format_listing_sellingPrice = __webpack_require__(65565);
// EXTERNAL MODULE: ./src/utils/navigation.ts + 1 modules
var navigation = __webpack_require__(59165);
;// CONCATENATED MODULE: ./src/containers/ListingDetail/DetailHeader.tsx



















var DetailHeader = function(param) {
    var cities = param.cities, listing = param.listing;
    var ref, ref1;
    var ref2 = (0,useTranslation/* default */.Z)(), lang = ref2.lang, t = ref2.t;
    var device = (0,Device/* useDevice */.Fy)();
    var _detail = listing.detail, buildingFloors = _detail.buildingFloors, entireBuilding = _detail.entireBuilding, entranceFloor = _detail.entranceFloor, floorPosition = _detail.floorPosition;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    alignItems: {
                        desktop: "center"
                    },
                    display: {
                        desktop: "flex"
                    },
                    marginBottom: "s-m"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            paddingBottom: {
                                desktop: 0,
                                mobile: "s"
                            },
                            textTransform: "uppercase"
                        }),
                        color: "greyscale600",
                        children: (ref = cities.router.city) === null || ref === void 0 ? void 0 : ref.translatedCityName
                    }),
                    listing.detail.zone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            device === "desktop" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: ListingDetail_styles_css/* pointShapeDivider */.wx
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                color: "greyscale500",
                                children: listing.detail.zone.label
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Heading2 */.XJ, {
                as: "h1",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginBottom: "m"
                }),
                children: [
                    (0,get_translated_title/* default */.Z)((ref1 = listing.detail) === null || ref1 === void 0 ? void 0 : ref1.titles, lang),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: "m"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            columnGap: {
                                tablet: "3xl"
                            },
                            display: {
                                mobile: "none",
                                tablet: "flex"
                            },
                            marginBottom: "l"
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Heading4 */.k8, {
                                as: "p",
                                children: [
                                    listing.detail.commercialArea,
                                    " m\xb2"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading4 */.k8, {
                                as: "p",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Floor/* Floor */.O, {
                                    buildingFloors: buildingFloors,
                                    entireBuilding: entireBuilding,
                                    entranceFloor: entranceFloor,
                                    floorPosition: floorPosition
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            alignItems: {
                                desktop: "center"
                            },
                            display: {
                                desktop: "flex"
                            },
                            gap: {
                                desktop: "xl"
                            },
                            marginBottom: {
                                desktop: "l"
                            }
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading3 */.aC, {
                                        as: "p",
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            paddingBottom: {
                                                mobile: "xs"
                                            }
                                        }),
                                        children: (0,format_listing_sellingPrice/* formatListingSellingPrice */.F)(listing.detail.privateNegotiation, listing.detail.sellingPrices, t, lang)
                                    }),
                                    !listing.detail.privateNegotiation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            display: {
                                                tablet: "none"
                                            }
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                            children: (0,format_listing_pricePerSquareMeter/* formatListingPricePerSquareMeter */.A)(listing.detail.sellingPrices, listing.detail.commercialArea, lang)
                                        })
                                    }),
                                    !listing.detail.privateNegotiation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            display: {
                                                mobile: "none",
                                                tablet: "flex"
                                            }
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                            color: "greyscale500",
                                            children: (0,format_listing_pricePerSquareMeter/* formatListingPricePerSquareMeter */.A)(listing.detail.sellingPrices, listing.detail.commercialArea, lang)
                                        })
                                    })
                                ]
                            }),
                            (0,locale_variables/* isLocaleEnabledFor */.vw)("affordability", lang) && !listing.detail.privateNegotiation && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                iconRight: true,
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    marginY: {
                                        desktop: 0,
                                        mobile: "m"
                                    }
                                }),
                                href: "".concat((0,navigation/* buildRelativeLocalizedLink */.JS)(i18n_routes/* affordabilityPath */.vW, lang), "?listing=").concat(listing.id),
                                Icon: function() {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Chevron */.Z.Chevron, {});
                                },
                                label: t("affordability:Affordability_ListingDetailCTA"),
                                sizeVariant: "small",
                                style: {
                                    backgroundColor: "#D6F5FF",
                                    color: theme/* theme.colors.greyscale600 */.r.colors.greyscale600
                                },
                                onClick: function() {
                                    return (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.Affordability */.z.Affordability, "StartFlow", "FromListingDetail");
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ListingDetail_styles_css/* detailInfoData */.Vv,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Heading4 */.k8, {
                                as: "p",
                                children: [
                                    listing.detail.commercialArea,
                                    " m\xb2"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Floor/* Floor */.O, {
                                buildingFloors: buildingFloors,
                                entireBuilding: entireBuilding,
                                entranceFloor: entranceFloor,
                                floorPosition: floorPosition
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ListingDetail_DetailHeader = (DetailHeader);

;// CONCATENATED MODULE: ./src/containers/ListingDetail/FomoMessage.tsx


var FomoMessage = function(param) {
    var userViews = param.userViews;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
        components: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "0")
        ],
        i18nKey: userViews > 1 ? "listing-detail:fomo_message_people" : "listing-detail:fomo_message_person",
        values: {
            userViews: userViews
        }
    });
};
/* harmony default export */ var ListingDetail_FomoMessage = (FomoMessage);

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(50033);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./src/containers/ListingDetail/ListingDescription.tsx





/**
 * A simple text container to allow HTML in listings we know to be safe.
 *
 * Actually, the only HTML we expect from safe content listings are <a/>
 *
 * @param safeContent true if you trust the text to now include malicious content
 * @param text the actual raw text of the description
 * @constructor
 */ var ListingDescription = function(param) {
    var safeContent = param.safeContent, text = param.text;
    if (safeContent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: ListingDetail_styles_css/* listingDescriptionClass.safe */.zZ.safe,
                dangerouslySetInnerHTML: {
                    __html: browser_default().sanitize(text)
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: ListingDetail_styles_css/* listingDescriptionClass.default */.zZ["default"],
            children: text
        })
    });
};

// EXTERNAL MODULE: src/containers/ListingDetail/MobileContactUs/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/containers/ListingDetail/MobileContactUs/styles.css.ts.vanilla.css","source":"Ll8xMWtvbWpmMCB7CiAgY29sb3I6ICM1MjUyNTE7CiAgZm9udC1zaXplOiAxMHB4Owp9Ci5fMTFrb21qZjEgewogIGJvdHRvbTogMDsKICBtYXJnaW46IDAgLTE2cHg7CiAgcG9zaXRpb246IHN0aWNreTsKICB6LWluZGV4OiAxMDsKfQouXzExa29tamYyIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRjVGNUY1OwogIGJvdHRvbTogMTAwJTsKICBib3gtc2hhZG93OiAwcHggMHB4IDZweCByZ2JhKDI5LDI5LDI3LDAuMjQpOwogIGZvbnQtc2l6ZTogMTNweDsKICBsZWZ0OiAwOwogIHBhZGRpbmc6IDE2cHggMDsKICBwb3NpdGlvbjogYWJzb2x1dGU7CiAgcmlnaHQ6IDA7CiAgdGV4dC1hbGlnbjogY2VudGVyOwogIHotaW5kZXg6IC0xOwp9Ci5fMTFrb21qZjMgewogIGJhY2tncm91bmQtY29sb3I6ICNGRkZGRkY7CiAgY29sdW1uLWdhcDogOHB4OwogIGRpc3BsYXk6IGZsZXg7CiAgcGFkZGluZzogMTZweDsKICBwYWRkaW5nLWJvdHRvbTogY2FsYygxNnB4ICsgZW52KHNhZmUtYXJlYS1pbnNldC1ib3R0b20pKTsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_Ll8xMWtvbWpmMCB7CiAgY29sb3I6ICM1MjUyNTE7CiAgZm9udC1zaXplOiAxMHB4Owp9Ci5fMTFrb21qZjEgewogIGJvdHRvbTogMDsKICBtYXJnaW46IDAgLTE2cHg7CiAgcG9zaXRpb246IHN0aWNreTsKICB6LWluZGV4OiAxMDsKfQouXzExa29tamYyIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiAjRjVGNUY1OwogIGJvdHRvbTogMTAwJTsKICBib3gtc2hhZG93OiAwcHggMHB4IDZweCByZ2JhKDI5LDI5LDI3LDAuMjQpOwogIGZvbnQtc2l6ZTogMTNweDsKICBsZWZ0OiAwOwogIHBhZGRpbmc6IDE2cHggMDsKICBwb3NpdGlvbjogYWJzb2x1dGU7CiAgcmlnaHQ6IDA7CiAgdGV4dC1hbGlnbjogY2VudGVyOwogIHotaW5kZXg6IC0xOwp9Ci5fMTFrb21qZjMgewogIGJhY2tncm91bmQtY29sb3I6ICNGRkZGRkY7CiAgY29sdW1uLWdhcDogOHB4OwogIGRpc3BsYXk6IGZsZXg7CiAgcGFkZGluZzogMTZweDsKICBwYWRkaW5nLWJvdHRvbTogY2FsYygxNnB4ICsgZW52KHNhZmUtYXJlYS1pbnNldC1ib3R0b20pKTsKfQ_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(22302);
;// CONCATENATED MODULE: ./src/containers/ListingDetail/MobileContactUs/styles.css.ts

var agencyAddressWrapper = '_11komjf0';
var mobileButtonWrapper = '_11komjf3';
var motionDiv = '_11komjf1';
var motionP = '_11komjf2';
;// CONCATENATED MODULE: ./src/containers/ListingDetail/MobileContactUs/MobileButtons.tsx

















var MobileButtons = function(param) {
    var handleOpenDetailFormModal = param.handleOpenDetailFormModal, handleTrackingCallAgency = param.handleTrackingCallAgency, inView = param.inView, property = param.property, similarPropertiesRef = param.similarPropertiesRef;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var userViews = getPreviousHourViews(property.id);
    var thirdParty = isThirdParty(property);
    var isPropriooListing = property.country === "france";
    var listingTitle = property.detail.titles.find(function(title) {
        return title.language === lang;
    }).text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        animate: {
            y: 0
        },
        className: motionDiv,
        initial: {
            y: "100%"
        },
        transition: {
            duration: 0.3,
            type: "tween"
        },
        children: !inView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (0,locale_variables/* isLocaleEnabledFor */.vw)("fomo", lang) && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
                    animate: {
                        opacity: 1
                    },
                    className: motionP,
                    initial: {
                        opacity: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetail_FomoMessage, {
                        userViews: userViews
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()(mobileButtonWrapper, "mobile-contact-us__button-wrapper"),
                    "data-testid": "mobile-buttons-wrapper",
                    children: [
                        thirdParty && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                !isPropriooListing && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                    center: true,
                                    fullWidth: true,
                                    "data-testid": "telephone-number-dial",
                                    href: "tel:".concat(property.contactInfo.telephoneNumberContact),
                                    Icon: function(props) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                            color: index_es/* colors.greyscale600 */.O9.greyscale600,
                                            height: 20,
                                            width: 20
                                        }));
                                    },
                                    label: t("listing-detail:phone_call"),
                                    sizeVariant: "small",
                                    styleVariant: "secondary",
                                    onClick: function() {
                                        handleTrackingCallAgency("ListingDetail");
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                    "data-testid": "contact-form-button",
                                    Icon: function(props) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tap/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
                                    },
                                    label: t("listing-detail:request_call"),
                                    sizeVariant: "small",
                                    styleVariant: "primary",
                                    onClick: handleOpenDetailFormModal(false)
                                })
                            ]
                        }),
                        !thirdParty && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactCTA, {
                                    isMobile: true,
                                    listing: property,
                                    listingTitle: listingTitle,
                                    requestType: "info",
                                    similarPropertiesRef: similarPropertiesRef
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactCTA, {
                                    isMobile: true,
                                    "data-testid": "request-visit-button",
                                    listing: property,
                                    listingTitle: listingTitle,
                                    requestType: "visit",
                                    similarPropertiesRef: similarPropertiesRef
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var MobileContactUs_MobileButtons = (MobileButtons);

;// CONCATENATED MODULE: ./src/containers/ListingDetail/MobileContactUs/index.tsx












var MobileContactUs = function(param) {
    var cities = param.cities, handleOpenDetailFormModal = param.handleOpenDetailFormModal, handleTrackingCallAgency = param.handleTrackingCallAgency, property = param.property, similarPropertiesLength = param.similarPropertiesLength, similarPropertiesRef = param.similarPropertiesRef;
    var t = (0,useTranslation/* default */.Z)().t;
    var ref = (0,react.useState)(false), areButtonsVisible = ref[0], setAreButtonsVisible = ref[1];
    var ref1 = (0,react_intersection_observer_modern/* useInView */.YD)(), inView = ref1.inView, refInView = ref1.ref;
    (0,react.useEffect)(function() {
        document.addEventListener("scroll", function() {
            setAreButtonsVisible(window.scrollY > 100);
        });
        return function() {
            return document.removeEventListener("scroll", function() {
                setAreButtonsVisible(window.scrollY > 100);
            });
        };
    }, []);
    var ref2 = config_default()(), imageBasePath = ref2.publicRuntimeConfig.imageBasePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    display: "flex",
                    gap: "s",
                    justifyContent: "space-between",
                    paddingBottom: "2xl"
                }),
                "data-component": "agency-contact-form",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            flexShrink: 0
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            loading: "lazy",
                            src: "".concat(imageBasePath, "/images/concepts/clouds-left-small.svg"),
                            width: 75
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            paddingY: "l",
                            textAlign: "center"
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    paddingBottom: "s"
                                }),
                                children: t("listing-detail:form-header.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                                children: t(property.contactInfo.ownedByCasavo ? "listing-detail:form-header.subtitle_casavo" : "listing-detail:form-header.subtitle_agency")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            flexShrink: 0
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            loading: "lazy",
                            src: "".concat(imageBasePath, "/images/concepts/clouds-right-small.svg"),
                            width: 75
                        })
                    })
                ]
            }),
            property.detail.casavoDirectSale && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: refInView,
                id: "contactForm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm, {
                    cities: cities,
                    property: property,
                    similarPropertiesLength: similarPropertiesLength,
                    similarPropertiesRef: similarPropertiesRef
                })
            }),
            !property.contactInfo.ownedByCasavo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingBottom: "s",
                    textAlign: "center"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: ListingDetail_styles_css/* mobileContactUsAgencyNameWrapper */.ZP,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HouseRent, {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    marginRight: "s"
                                })
                            }),
                            property.contactInfo.agencyName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: agencyAddressWrapper,
                        children: property.contactInfo.agencyAddress
                    })
                ]
            }),
            areButtonsVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileContactUs_MobileButtons, {
                handleOpenDetailFormModal: handleOpenDetailFormModal,
                handleTrackingCallAgency: handleTrackingCallAgency,
                inView: inView,
                property: property,
                similarPropertiesRef: similarPropertiesRef
            })
        ]
    });
};
/* harmony default export */ var ListingDetail_MobileContactUs = (MobileContactUs);

;// CONCATENATED MODULE: ./src/containers/ListingDetail/MortgageWidget.tsx



var MortgageWidget = function(param) {
    var listingId = param.listingId, sellingPricesInCents = param.sellingPricesInCents;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)(false), useFallback = ref1[0], setUseFallback = ref1[1];
    var showRef = (0,react.useRef)(show);
    /* This is necessary to avoid a race condition in readind show value */ (0,react.useEffect)(function() {
        var handler = function handler(e) {
            if (e.data === "CASAVOMUTUI-WIDGET-LOADED") {
                setShow(true);
                showRef.current = true;
            }
        };
        window.addEventListener("message", handler);
        return function() {
            return window.removeEventListener("message", handler);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (showRef.current) {
            return;
        }
        var id = setTimeout(function() {
            if (!showRef.current) {
                setUseFallback(true);
            }
        }, 5000);
        return function() {
            return clearTimeout(id);
        };
    }, [
        showRef
    ]);
    var url = "".concat("https://widget-mutui.casavo.com", "/widget-simulazione?importoImmobile=").concat(sellingPricesInCents / 100, "&traffic_source=listing-detail&listingid=").concat(listingId, "&utm_source=listing-platform&utm_medium=widget-iframe&utm_campaign=trafficfromlistingDetail");
    if (useFallback) {
        /* TODO: Use an ad-hoc UI element similar to <MortgageBanner /> */ return null;
    /* In case of problems loading the widgets remove the occupied space */ }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: show ? ListingDetail_styles_css/* mortgageWidgetClass.visible */.A5.visible : ListingDetail_styles_css/* mortgageWidgetClass.hidden */.A5.hidden,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            className: ListingDetail_styles_css/* mortgageIframe */.Ti,
            id: "mutui-widget",
            src: url,
            title: "mutui-widget"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(42493);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/FavouriteButton/index.tsx + 1 modules
var FavouriteButton = __webpack_require__(45931);
// EXTERNAL MODULE: ./src/context/UserNavigationProvider.tsx
var UserNavigationProvider = __webpack_require__(71750);
// EXTERNAL MODULE: ./src/design-lib/components/Icons/ArrowLeft/index.tsx
var ArrowLeft = __webpack_require__(431);
// EXTERNAL MODULE: ./src/design-lib/style-theme/theme.css.ts
var theme_css = __webpack_require__(81498);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(3607);
// EXTERNAL MODULE: ./src/components/Icon/Reply/index.tsx
var Reply = __webpack_require__(51100);
// EXTERNAL MODULE: src/components/ButtonSharing/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/ButtonSharing/styles.css.ts.vanilla.css","source":"LmEwdXNrZjAgewogIHdpZHRoOiA0MHB4OwogIG1pbi13aWR0aDogNDBweDsKICBoZWlnaHQ6IDQwcHg7CiAgYm9yZGVyLXJhZGl1czogNTAlOwogIGJhY2tncm91bmQtY29sb3I6IHZhcigtLV8xbXVoOG5raCk7CiAgZGlzcGxheTogZmxleDsKICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsKICBhbGlnbi1pdGVtczogY2VudGVyOwogIGNvbG9yOiB2YXIoLS1fMW11aDhua28pOwogIHBhZGRpbmc6IDA7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_LmEwdXNrZjAgewogIHdpZHRoOiA0MHB4OwogIG1pbi13aWR0aDogNDBweDsKICBoZWlnaHQ6IDQwcHg7CiAgYm9yZGVyLXJhZGl1czogNTAlOwogIGJhY2tncm91bmQtY29sb3I6IHZhcigtLV8xbXVoOG5raCk7CiAgZGlzcGxheTogZmxleDsKICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjsKICBhbGlnbi1pdGVtczogY2VudGVyOwogIGNvbG9yOiB2YXIoLS1fMW11aDhua28pOwogIHBhZGRpbmc6IDA7Cn0_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(46032);
;// CONCATENATED MODULE: ./src/components/ButtonSharing/styles.css.ts


var shareButton = 'a0uskf0';
;// CONCATENATED MODULE: ./src/components/ButtonSharing/index.tsx














var ButtonSharing = function(param) {
    var categoryForTracking = param.categoryForTracking, cities = param.cities, className = param.className, property = param.property;
    var ref = (0,react.useState)(false), nativeShareSupported = ref[0], setNativeShareSupported = ref[1];
    var ref1 = (0,useTranslation/* default */.Z)(), lang = ref1.lang, t = ref1.t;
    var listingCity = cities.list.find(function(city) {
        return city.slug === property.detail.city;
    });
    (0,react.useEffect)(function() {
        if (window.navigator && window.navigator.share) {
            setNativeShareSupported(true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: nativeShareSupported && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
            "aria-label": "Share this listing",
            className: classnames_default()(shareButton, className),
            Icon: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Reply/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
            },
            label: "",
            onClick: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                    var ref, sellingPrice, typology, area, city, l10n_in, street, textToShare, urlToShare, err;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                event.preventDefault();
                                sellingPrice = (0,format_listing_sellingPrice/* formatListingSellingPrice */.F)(property.detail.privateNegotiation, property.detail.sellingPrices, t, lang);
                                typology = (0,get_translated_title/* default */.Z)((ref = property.detail) === null || ref === void 0 ? void 0 : ref.titles, lang).split(" ")[0];
                                area = property.detail.commercialArea;
                                city = listingCity.name;
                                l10n_in = t("listing-detail:title_1");
                                street = property.addressesCate.street;
                                textToShare = "\uD83C\uDFE1 ".concat(typology, " - ").concat(area, " mq\n\uD83D\uDCEC ").concat(city, " ").concat(l10n_in, " ").concat(street, "\n✨ ").concat(sellingPrice, "\n\n\uD83D\uDC47\uD83C\uDFFB\n");
                                urlToShare = "".concat(document.location.protocol, "//").concat(document.location.host).concat(document.location.pathname);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    window.navigator.share({
                                        text: textToShare,
                                        url: urlToShare
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                if (err.toString().includes("AbortError")) {
                                // nothing to do here, user canceled the sharing action
                                // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share#exceptions
                                } else {
                                    console.error(err);
                                    esm_exports/* captureException */.Tb(err, function(scope) {
                                        scope.setExtra("channel", "lisa.buttonSharing");
                                        return scope;
                                    });
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                (0,eventsHandlers/* handleClickShare */.tv)(categoryForTracking);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(event) {
                    return _ref.apply(this, arguments);
                };
            }()
        })
    });
};
/* harmony default export */ var components_ButtonSharing = (ButtonSharing);

// EXTERNAL MODULE: src/containers/ListingDetail/NearbyPropertiesSection/MobileFloatingButtons/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/containers/ListingDetail/NearbyPropertiesSection/MobileFloatingButtons/styles.css.ts.vanilla.css","source":"Ll8xOXJybWlxMCB7CiAgZGlzcGxheTogZmxleDsKICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47CiAgcG9zaXRpb246IGFic29sdXRlOwogIHotaW5kZXg6IDU7CiAgd2lkdGg6IDEwMCU7CiAgcGFkZGluZzogdmFyKC0tXzFtdWg4bmsyYSkgdmFyKC0tXzFtdWg4bmsyOCk7Cn0KLl8xOXJybWlxMSB7CiAgd2lkdGg6IDQwcHg7CiAgaGVpZ2h0OiA0MHB4OwogIGJvcmRlci1yYWRpdXM6IDUwJTsKICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1fMW11aDhua2gpOwogIGRpc3BsYXk6IGZsZXg7CiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5fMTlycm1pcTAgewogICAgZGlzcGxheTogbm9uZTsKICB9Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_Ll8xOXJybWlxMCB7CiAgZGlzcGxheTogZmxleDsKICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47CiAgcG9zaXRpb246IGFic29sdXRlOwogIHotaW5kZXg6IDU7CiAgd2lkdGg6IDEwMCU7CiAgcGFkZGluZzogdmFyKC0tXzFtdWg4bmsyYSkgdmFyKC0tXzFtdWg4bmsyOCk7Cn0KLl8xOXJybWlxMSB7CiAgd2lkdGg6IDQwcHg7CiAgaGVpZ2h0OiA0MHB4OwogIGJvcmRlci1yYWRpdXM6IDUwJTsKICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1fMW11aDhua2gpOwogIGRpc3BsYXk6IGZsZXg7CiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5fMTlycm1pcTAgewogICAgZGlzcGxheTogbm9uZTsKICB9Cn0_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(59899);
;// CONCATENATED MODULE: ./src/containers/ListingDetail/NearbyPropertiesSection/MobileFloatingButtons/styles.css.ts


var roundedButton = '_19rrmiq1';
var wrapper = '_19rrmiq0';
;// CONCATENATED MODULE: ./src/containers/ListingDetail/NearbyPropertiesSection/MobileFloatingButtons/index.tsx










var MobileFloatingButtons = function(param) {
    var cities = param.cities, listing = param.listing, _topOffset = param.topOffset, topOffset = _topOffset === void 0 ? false : _topOffset;
    var ref;
    var ref1 = (0,UserNavigationProvider/* useUserNavigation */.yc)(), currentPage = ref1.currentPage, returnToLastCityPage = ref1.returnToLastCityPage, setLastCityFromListing = ref1.setLastCityFromListing;
    if (cities && !currentPage && !!((ref = cities.router.city) === null || ref === void 0 ? void 0 : ref.slug)) {
        setLastCityFromListing(cities.router.city.slug);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: wrapper,
        style: {
            top: topOffset ? 53 + 46 : 46
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Go back to list",
                className: roundedButton,
                "data-testid": "detail-back-button",
                onClick: function() {
                    (0,eventsHandlers/* handleListingDetailClick */.L1)("GoBack");
                    returnToLastCityPage();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    display: "flex",
                    gap: "s"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonSharing, {
                        categoryForTracking: "ListingDetail",
                        cities: cities,
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginRight: "m"
                        }),
                        property: listing
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FavouriteButton/* FavouriteButton */.A, {
                        className: classnames_default()(roundedButton, (0,sprinkles_css/* sprinkles */.K)({
                            padding: "s"
                        })),
                        gtmTouchpoint: "ListingDetail",
                        id: listing.id
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NearbyPropertiesSection_MobileFloatingButtons = (MobileFloatingButtons);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(66731);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: src/containers/ListingDetail/NearbyPropertiesSection/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/containers/ListingDetail/NearbyPropertiesSection/styles.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA71UQXKjMBC8+xVzSVV8kAuwY1jlkp+kFDSGiWFESSLB2fLftxA4wSSksnvYG0jdPT09A5vHfXrKSozg9wqgMY48GZbgPOXH0/0KgNihlxD1z2+CWGMnIYnuV+fVZiTHM7LFSnl6wStKPGUkgfGk8mNhTcta5KYyVsKLsrdCPMZ1W2Z8fF73CgfDXjh6Qwnxrun6o5pYlEhF6SXcbYczTa6p1EnCocJwoCoqWJDH2knIkT3aqYVtsPDOYsM4vd79yGEZHF6s7PaDlUZpTVxIiGbwJFv/i9V98FKrTryS9qWEOMmiMQllC+K+kmq9+bk4wEUqim7619xUbc2iUM28xyRdT82k3+eWDbswJCDsEEwyzu0S1Db5cmYfKr+uVCo8LIp8cFTg9EqzZXsKF/N9Gfv/u/UBeG6dp8NJ5IY9sv9qXDisjrEa7SUBZyrSEDfdLNxjWIgRO/T5PXSp++J/Fn2oUZMCl1tEBsUabvtPcow03WdNtw5+Nle/FwBvGglZPER+ngC2I+DTGKag3Rw0LN81KF1SWhzplJ0vlzj/AZs/U1YsBQAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var U1YsBQAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(62625);
;// CONCATENATED MODULE: ./src/containers/ListingDetail/NearbyPropertiesSection/styles.css.ts



var bannerPanel = '_67y8heg tfghjgju tfghjggc tfghjghi tfghjgio _1b5wm202u tfghjg1u tfghjga6 tfghjgag tfghjg6';
var centralPanel = '_67y8hea';
var innerWrapper = '_67y8he2';
var mobileButtons = '_67y8hec';
var mobileHeader = '_67y8he4';
var mobileHidden = '_67y8he3';
var navContainer = '_67y8he6 tfghjgh5 tfghjgib';
var navigationLink = '_67y8heb';
var navigationPanel = '_67y8hee tfghjghi tfghjgio tfghjg6 tfghjg1u tfghjga6';
var outerWrapper = {sticky:'_67y8he0','default':'_67y8he1'};
var panelLeft = '_67y8he9';
var panelRight = '_67y8he8';
var sidePanel = '_67y8he7';
;// CONCATENATED MODULE: ./src/containers/ListingDetail/NearbyPropertiesSection/NearbyBanner.tsx










var NearbyBanner = function(param) {
    var nextUrl = param.nextUrl, onCTAClick = param.onCTAClick, totalProperties = param.totalProperties;
    var t = (0,useTranslation/* default */.Z)().t;
    (0,react.useEffect)(function() {
        (0,eventsHandlers/* handleShow */.Hf)("NearPropertiesBanner", "SeeBanner");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: bannerPanel,
        "data-testid": "nearby-properties-banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Typography */.ZT, {
                variant: "description",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                    i18Key: t("listing-detail:NearPropertiesBanner_FirstStep_Description")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: nextUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        alignItems: "center",
                        display: "flex",
                        fontWeight: 600
                    }),
                    "data-testid": "reveal-index-button",
                    onClick: function() {
                        onCTAClick();
                        (0,eventsHandlers/* handleClick */.qk)("NearPropertiesBanner", "FirstStep");
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                            i18Key: "listing-detail:NearPropertiesBanner_FirstStep_CTA",
                            values: {
                                count: totalProperties - 1,
                                n: totalProperties - 1
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                            direction: "right"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/ListingDetail/NearbyPropertiesSection/NearbyNavigation.tsx







var NearbyNavigation = function(param) {
    var currentIndex = param.currentIndex, nextUrl = param.nextUrl, previousUrl = param.previousUrl, totalProperties = param.totalProperties;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: navigationPanel,
        "data-testid": "index-navigation",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: previousUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: navigationLink,
                    "data-testid": "prev-nearby-button",
                    onClick: function() {
                        (0,eventsHandlers/* handleClick */.qk)("NearPropertiesBanner", "Previous");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                        direction: "left"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-testid": "nearby-navigation-progress",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                    i18Key: "listing-detail:NearPropertiesBanner_PropertiesProgress",
                    values: {
                        n: currentIndex + 1,
                        tot: totalProperties
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    paddingX: "m"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: nextUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: navigationLink,
                        "data-testid": "next-nearby-button",
                        onClick: function() {
                            (0,eventsHandlers/* handleClick */.qk)("NearPropertiesBanner", "Next");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                            direction: "right"
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/ListingDetail/NearbyPropertiesSection/index.tsx
















var getPreviousUrl = function(nearbyProperties, listing) {
    var ref;
    if (!nearbyProperties.length) return "#";
    var currentIndex = nearbyProperties.findIndex(function(np) {
        return np.id === listing.id;
    });
    return ((ref = nearbyProperties[currentIndex - 1]) === null || ref === void 0 ? void 0 : ref.url) || nearbyProperties[nearbyProperties.length - 1].url;
};
var getNextUrl = function(nearbyProperties, listing) {
    var ref;
    if (!nearbyProperties.length) return "#";
    var currentIndex = nearbyProperties.findIndex(function(np) {
        return np.id === listing.id;
    });
    return ((ref = nearbyProperties[currentIndex + 1]) === null || ref === void 0 ? void 0 : ref.url) || nearbyProperties[0].url;
};
var NearbyPropertiesSection = function(param) {
    var cities = param.cities, isSticky = param.isSticky, listing = param.listing, nearbyProperties = param.nearbyProperties, setShowNavigation = param.setShowNavigation, showBanner = param.showBanner, showNavigation = param.showNavigation;
    var ref;
    var t = (0,useTranslation/* default */.Z)().t;
    var ref1 = (0,UserNavigationProvider/* useUserNavigation */.yc)(), currentPage = ref1.currentPage, returnToLastCityPage = ref1.returnToLastCityPage, setLastCityFromListing = ref1.setLastCityFromListing;
    if (cities && !currentPage && !!((ref = cities.router.city) === null || ref === void 0 ? void 0 : ref.slug)) {
        setLastCityFromListing(cities.router.city.slug);
    }
    var totalProperties = nearbyProperties.length;
    var currentIndex = nearbyProperties.findIndex(function(np) {
        return np.id === listing.id;
    });
    var previousUrl = getPreviousUrl(nearbyProperties, listing);
    var nextUrl = getNextUrl(nearbyProperties, listing);
    var showComponentInMobile = showBanner || showNavigation;
    var progressPercentage = Math.floor((currentIndex + 1) / totalProperties * 100);
    var progressStyle = {
        backgroundImage: "linear-gradient(90deg, ".concat(theme_css/* theme.colors.orange600 */.r.colors.orange600, " ").concat(progressPercentage, "%, ").concat(theme_css/* theme.colors.greyscale200 */.r.colors.greyscale200, " ").concat(progressPercentage, "%)"),
        backgroundPosition: "bottom",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 2px"
    };
    var ref2 = config_default()(), casavoUiCdn = ref2.publicRuntimeConfig.casavoUiCdn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: mobileHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    "aria-label": "Return to city page",
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        alignItems: "center",
                        display: "flex"
                    }),
                    onClick: function() {
                        returnToLastCityPage();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        height: 30,
                        src: "".concat(casavoUiCdn, "/logo/main-wordmark-black-mobile.svg"),
                        width: 110
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: outerWrapper[isSticky ? "sticky" : "default"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: showComponentInMobile ? innerWrapper : classnames_default()(innerWrapper, mobileHidden),
                    "data-testid": "navigate-and-favorite-bar",
                    style: showNavigation ? progressStyle : {},
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                        className: navContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: sidePanel,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: panelRight,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        "aria-label": "Go back to list",
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            alignItems: "center",
                                            display: "flex",
                                            gap: "s"
                                        }),
                                        "data-testid": "detail-back-button-desktop",
                                        tabIndex: 0,
                                        onClick: function() {
                                            (0,eventsHandlers/* handleListingDetailClick */.L1)("GoBack");
                                            returnToLastCityPage();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* default */.Z, {
                                                height: 16,
                                                width: 16
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,sprinkles_css/* sprinkles */.K)({
                                                    paddingLeft: "s"
                                                }),
                                                children: t("listing-detail:properties")
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: centralPanel,
                                children: [
                                    showNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(NearbyNavigation, {
                                        currentIndex: currentIndex,
                                        nextUrl: nextUrl,
                                        previousUrl: previousUrl,
                                        totalProperties: totalProperties
                                    }),
                                    showBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(NearbyBanner, {
                                        nextUrl: nextUrl,
                                        totalProperties: totalProperties,
                                        onCTAClick: function() {
                                            setShowNavigation(true);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: sidePanel,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: panelLeft,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FavouriteButton/* FavouriteButton */.A, {
                                        extended: true,
                                        gtmTouchpoint: "ListingDetail",
                                        id: listing.id
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NearbyPropertiesSection_MobileFloatingButtons, {
                cities: cities,
                listing: listing,
                topOffset: showComponentInMobile
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/AnimatedButton/index.tsx
var AnimatedButton = __webpack_require__(21753);
;// CONCATENATED MODULE: ./src/hooks/useIntersectionObserver.ts


function useIntersectionObserver(elementRef, param) {
    var _freezeOnceVisible = param.freezeOnceVisible, freezeOnceVisible = _freezeOnceVisible === void 0 ? false : _freezeOnceVisible, _root = param.root, root = _root === void 0 ? null : _root, _rootMargin = param.rootMargin, rootMargin = _rootMargin === void 0 ? "0%" : _rootMargin, _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold;
    var ref = (0,react.useState)(), entry = ref[0], setEntry = ref[1];
    var frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    var updateEntry = function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
        setEntry(entry);
    };
    (0,react.useEffect)(function() {
        var node = elementRef === null || elementRef === void 0 // DOM Ref
         ? void 0 : elementRef.current;
        var hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node) return;
        var observerParams = {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold
        };
        var observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return function() {
            return observer.disconnect();
        };
    }, [
        elementRef,
        threshold,
        root,
        rootMargin,
        frozen
    ]);
    return entry;
}
/* harmony default export */ var hooks_useIntersectionObserver = (useIntersectionObserver);

// EXTERNAL MODULE: ./src/utils/cities-mapper.ts
var cities_mapper = __webpack_require__(1966);
// EXTERNAL MODULE: ./src/utils/keyboard-helper.ts
var keyboard_helper = __webpack_require__(8123);
// EXTERNAL MODULE: src/components/poi/CardPoi/index.css.tsx.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/poi/CardPoi/index.css.tsx.vanilla.css","source":"Ll8xcjBvam84MCB7CiAgYm9yZGVyLXJhZGl1czogOHB4OwogIGJveC1zaGFkb3c6IDAgMXB4IDRweCAwIHJnYmEoMjksMjksMjcsMC4zKTsKICBjb2xvcjogIzFEMUQxQjsKICBmbGV4OiAxOwogIG1pbi13aWR0aDogMDsKICBwYWRkaW5nOiAxMnB4IDE2cHg7CiAgdGV4dC1hbGlnbjogbGVmdDsKICB0cmFuc2l0aW9uOiBib3gtc2hhZG93IC4zcyBlYXNlOwp9Ci5fMXIwb2pvODA6aG92ZXIgewogIGJveC1zaGFkb3c6IDAgMnB4IDhweCAwIHJnYmEoMjksMjksMjcsMC4zKTsKfQouXzFyMG9qbzgwOm5vdCg6bGFzdC1jaGlsZCkgewogIG1hcmdpbi1ib3R0b206IDE2cHg7Cn0KLl8xcjBvam84MSB7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICBkaXNwbGF5OiBmbGV4OwogIGdhcDogczsKICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kOwp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDEwMjRweCkgewogIC5fMXIwb2pvODA6bm90KDpsYXN0LWNoaWxkKSB7CiAgICBtYXJnaW4tYm90dG9tOiAwOwogICAgbWFyZ2luLXJpZ2h0OiAxNnB4OwogIH0KfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var index_css_tsx_vanilla_css_source_Ll8xcjBvam84MCB7CiAgYm9yZGVyLXJhZGl1czogOHB4OwogIGJveC1zaGFkb3c6IDAgMXB4IDRweCAwIHJnYmEoMjksMjksMjcsMC4zKTsKICBjb2xvcjogIzFEMUQxQjsKICBmbGV4OiAxOwogIG1pbi13aWR0aDogMDsKICBwYWRkaW5nOiAxMnB4IDE2cHg7CiAgdGV4dC1hbGlnbjogbGVmdDsKICB0cmFuc2l0aW9uOiBib3gtc2hhZG93IC4zcyBlYXNlOwp9Ci5fMXIwb2pvODA6aG92ZXIgewogIGJveC1zaGFkb3c6IDAgMnB4IDhweCAwIHJnYmEoMjksMjksMjcsMC4zKTsKfQouXzFyMG9qbzgwOm5vdCg6bGFzdC1jaGlsZCkgewogIG1hcmdpbi1ib3R0b206IDE2cHg7Cn0KLl8xcjBvam84MSB7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICBkaXNwbGF5OiBmbGV4OwogIGdhcDogczsKICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kOwp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDEwMjRweCkgewogIC5fMXIwb2pvODA6bm90KDpsYXN0LWNoaWxkKSB7CiAgICBtYXJnaW4tYm90dG9tOiAwOwogICAgbWFyZ2luLXJpZ2h0OiAxNnB4OwogIH0KfQ_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(28070);
;// CONCATENATED MODULE: ./src/components/poi/CardPoi/index.css.tsx

var cardPoi = '_1r0ojo80';
var cardPoiFooter = '_1r0ojo81';
;// CONCATENATED MODULE: ./src/components/poi/CardPoi/index.tsx












var CardPoi = function(param) {
    var openMap = param.openMap, _poi = param.poi, distance = _poi.distance, name = _poi.name, poiType = _poi.poiType;
    var t = (0,useTranslation/* default */.Z)().t;
    var ref = config_default()(), imageBasePath = ref.publicRuntimeConfig.imageBasePath;
    var poiCategory = (0,points_of_interest/* getPoiCategoryFromType */.Qv)(poiType);
    var icon = "".concat(poiCategory.toLocaleLowerCase(), "-icon");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: cardPoi,
        onClick: function() {
            return openMap(poiCategory);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(styles_css/* flexCenter */._7, styles_css/* gap.s */.SG.s, styles_css/* paddingBottom.s */.Et.s),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "",
                        "data-testid": icon,
                        height: "21",
                        src: "".concat(imageBasePath, "/images/poi/").concat(icon, ".svg")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                        children: t("listing-detail:".concat(poiCategory, ".poi_nearby_card_title"))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styles_css/* paddingBottom.s-m */.Et["s-m"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                        className: styles_css/* paddingBottom.xs */.Et.xs,
                        color: "greyscale500",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                            components: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "0"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        display: {
                                            desktop: "block",
                                            mobile: "none"
                                        }
                                    })
                                }, "1"), 
                            ],
                            i18nKey: "listing-detail:".concat(poiCategory, ".poi_nearby_card_distance"),
                            values: {
                                distance: distance
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        className: styles_css/* ellipsis */.LH,
                        color: "greyscale400",
                        children: name ? name : t("listing-detail:".concat(poiCategory, ".").concat(poiType, "_label"))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cardPoiFooter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Small */.x4, {
                        strong: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* TokenSupport */.B, {
                            children: "listing-detail:".concat(poiCategory, ".poi_nearby_card_all")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "",
                        className: styles_css/* rotate90 */.wK,
                        height: 16,
                        src: "".concat(imageBasePath, "/images/chevron-dark.svg")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/ListingDetail/PoiSection/Nearby.tsx









var Nearby = function(props) {
    var t = (0,useTranslation/* default */.Z)().t;
    var ref = (0,ModalContext/* useModal */.dd)(), closeModal = ref.closeModal, openModal = ref.openModal;
    var handleNearbyCardClick = function(filter) {
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalMap, {
            cities: props.cities,
            closeModal: closeModal,
            closestPointsOfInterest: props.closestPointsOfInterest,
            filter: filter,
            handleOpenDetailFormModal: props.onOpenDetailFormModal(true),
            handleTrackingCallAgency: props.handleTrackingCallAgency,
            listing: props.listing,
            pointsOfInterest: props.pointsOfInterest,
            selectedMarker: null,
            similarPropertiesRef: props.similarPropertiesRef
        }));
        (0,eventsHandlers/* handleClickOpenMap */.t9)("ListingDetail");
        (0,eventsHandlers/* handleListingDetailMapClick */.rt)("PoiButton".concat(filter));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            marginBottom: "2xl"
        }),
        "data-testid": "nearby-pois",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                strong: true,
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingBottom: "l"
                }),
                color: "greyscale600",
                children: t("listing-detail:poi_nearby")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    display: "flex",
                    flexDirection: {
                        desktop: "row",
                        mobile: "column"
                    }
                }),
                children: props.closestPointsOfInterest.map(function(poi, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPoi, {
                        openMap: handleNearbyCardClick,
                        poi: poi
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var PoiSection_Nearby = (Nearby);

// EXTERNAL MODULE: src/containers/ListingDetail/PoiSection/style.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/containers/ListingDetail/PoiSection/style.css.ts.vanilla.css","source":"Ll8xYWQ0N2Y1MCB7CiAgbWFyZ2luLWJvdHRvbTogMjRweDsKICBwb3NpdGlvbjogcmVsYXRpdmU7Cn0KLl8xYWQ0N2Y1MSB7CiAgYmFja2dyb3VuZC1jb2xvcjogIzczNzM3MjsKICBoZWlnaHQ6IDI1MHB4OwogIHdpZHRoOiAxMDAlOwp9Ci5fMWFkNDdmNTIgewogIGJhY2tncm91bmQtY29sb3I6ICNGRkZGRkY7CiAgYm9yZGVyLXJhZGl1czogOHB4OwogIGJveC1zaGFkb3c6IDAgMCA2cHggMCByZ2JhKDUxLCA2OCwgODQsIDAuMjQpOwogIGN1cnNvcjogcG9pbnRlcjsKICBmb250LXNpemU6IDEzcHg7CiAgaGVpZ2h0OiAzNnB4OwogIGxpbmUtaGVpZ2h0OiAxNnB4OwogIHBhZGRpbmc6IDAgMTZweDsKICB0cmFuc2l0aW9uOiBib3gtc2hhZG93IC4ycyBlYXNlLWluLW91dDsKICBsZWZ0OiBhdXRvOwogIHBvc2l0aW9uOiBhYnNvbHV0ZTsKICByaWdodDogMTZweDsKICB0b3A6IDE2cHg7CiAgei1pbmRleDogMTsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5fMWFkNDdmNTAgewogICAgbWFyZ2luLWJvdHRvbTogMzJweDsKICB9CiAgLl8xYWQ0N2Y1MSB7CiAgICBoZWlnaHQ6IDMyMHB4OwogIH0KICAuXzFhZDQ3ZjUyIHsKICAgIGZvbnQtc2l6ZTogMTVweDsKICB9CiAgLl8xYWQ0N2Y1Mjpob3ZlciB7CiAgICBib3gtc2hhZG93OiAwIDAgMTBweCAwIHJnYmEoNTEsIDY4LCA4NCwgMC4yNCk7CiAgfQp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var style_css_ts_vanilla_css_source_Ll8xYWQ0N2Y1MCB7CiAgbWFyZ2luLWJvdHRvbTogMjRweDsKICBwb3NpdGlvbjogcmVsYXRpdmU7Cn0KLl8xYWQ0N2Y1MSB7CiAgYmFja2dyb3VuZC1jb2xvcjogIzczNzM3MjsKICBoZWlnaHQ6IDI1MHB4OwogIHdpZHRoOiAxMDAlOwp9Ci5fMWFkNDdmNTIgewogIGJhY2tncm91bmQtY29sb3I6ICNGRkZGRkY7CiAgYm9yZGVyLXJhZGl1czogOHB4OwogIGJveC1zaGFkb3c6IDAgMCA2cHggMCByZ2JhKDUxLCA2OCwgODQsIDAuMjQpOwogIGN1cnNvcjogcG9pbnRlcjsKICBmb250LXNpemU6IDEzcHg7CiAgaGVpZ2h0OiAzNnB4OwogIGxpbmUtaGVpZ2h0OiAxNnB4OwogIHBhZGRpbmc6IDAgMTZweDsKICB0cmFuc2l0aW9uOiBib3gtc2hhZG93IC4ycyBlYXNlLWluLW91dDsKICBsZWZ0OiBhdXRvOwogIHBvc2l0aW9uOiBhYnNvbHV0ZTsKICByaWdodDogMTZweDsKICB0b3A6IDE2cHg7CiAgei1pbmRleDogMTsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5fMWFkNDdmNTAgewogICAgbWFyZ2luLWJvdHRvbTogMzJweDsKICB9CiAgLl8xYWQ0N2Y1MSB7CiAgICBoZWlnaHQ6IDMyMHB4OwogIH0KICAuXzFhZDQ3ZjUyIHsKICAgIGZvbnQtc2l6ZTogMTVweDsKICB9CiAgLl8xYWQ0N2Y1Mjpob3ZlciB7CiAgICBib3gtc2hhZG93OiAwIDAgMTBweCAwIHJnYmEoNTEsIDY4LCA4NCwgMC4yNCk7CiAgfQp9_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(42012);
;// CONCATENATED MODULE: ./src/containers/ListingDetail/PoiSection/style.css.ts

var detailButton = '_1ad47f52';
var poiSectionWrapper = '_1ad47f50';
var spacer = '_1ad47f51';
;// CONCATENATED MODULE: ./src/containers/ListingDetail/PoiSection/index.tsx












var StaticGoogleMapNoSsr = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9237).then(__webpack_require__.bind(__webpack_require__, 49237));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49237)
            ];
        }
    },
    ssr: false
});
var SectionPoi = function(props) {
    var device = (0,Device/* useDevice */.Fy)();
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var currentCity = props.cities.list.find(function(city) {
        return city.slug === props.listing.detail.city;
    });
    var ref1 = (0,react.useRef)(null);
    var entry = hooks_useIntersectionObserver(ref1, {});
    var ref2 = (0,react.useState)(false), isStaticMapVisibile = ref2[0], setIsStaticMapVisibile = ref2[1];
    (0,react.useEffect)(function() {
        if (ref1.current && !isStaticMapVisibile) {
            setIsStaticMapVisibile(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
        }
    }, [
        ref1.current,
        entry === null || entry === void 0 ? void 0 : entry.isIntersecting
    ]);
    /** Hide points of interest from cities that don't yet implement this feature */ if (!(0,cities_mapper/* isCityReferenceArea */.V1)(currentCity)) {
        return null;
    }
    var mapHeight = device === "mobile" ? 250 : 320;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref1,
                className: poiSectionWrapper,
                "data-testid": "section-poi",
                role: "button",
                tabIndex: 0,
                onClick: function(event) {
                    return props.onMapModalOpen({
                        event: event,
                        eventCategory: "ListingDetailMap"
                    });
                },
                onKeyPress: function(e) {
                    if ((0,keyboard_helper/* isEnter */.t)(e)) {
                        props.onMapModalOpen({
                            event: e,
                            eventCategory: "ListingDetailMap"
                        });
                    }
                },
                children: isStaticMapVisibile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedButton/* default */.Z, {
                            className: detailButton,
                            children: t("common:open-map")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticGoogleMapNoSsr, {
                            coordinates: props.listing.coordinates,
                            handleOpenMapModal: function(markerClicked) {
                                return props.onOpenMapModalWithoutEvent({
                                    eventCategory: "ListingDetailMap",
                                    selectedMarker: markerClicked
                                });
                            },
                            height: mapHeight,
                            pointsOfInterest: (0,locale_variables/* isLocaleEnabledFor */.vw)("POIs", lang) ? props.closestPointsOfInterest : []
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: spacer
                })
            }),
            (0,locale_variables/* isLocaleEnabledFor */.vw)("POIs", lang) && props.closestPointsOfInterest.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PoiSection_Nearby, {
                cities: props.cities,
                closestPointsOfInterest: props.closestPointsOfInterest,
                handleTrackingCallAgency: props.handleTrackingCallAgency,
                listing: props.listing,
                pointsOfInterest: props.pointsOfInterest,
                similarPropertiesRef: props.similarPropertiesRef,
                onOpenDetailFormModal: props.onOpenDetailFormModal
            })
        ]
    });
};
/* harmony default export */ var PoiSection = (SectionPoi);

// EXTERNAL MODULE: ./src/containers/ListingDetail/RelatedAdsBanner/index.tsx
var RelatedAdsBanner = __webpack_require__(92166);
// EXTERNAL MODULE: ./src/containers/ListingDetail/RelatedAdsBanner/style.css.ts
var RelatedAdsBanner_style_css = __webpack_require__(74369);
// EXTERNAL MODULE: ./src/utils/listing-facilities.ts
var listing_facilities = __webpack_require__(55600);
;// CONCATENATED MODULE: ./src/containers/ListingDetail/ServicesList.tsx










var ServicesList = function(param) {
    var listing = param.listing;
    var t = (0,useTranslation/* default */.Z)().t;
    var services = listing_facilities/* default.get */.Z.get(listing);
    var ref = config_default()(), imageBasePath = ref.publicRuntimeConfig.imageBasePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: ListingDetail_styles_css/* detailInfoBox */.pN,
        children: services && services.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()(ListingDetail_styles_css/* detailFeaturesContainer */.Ei, (0,sprinkles_css/* sprinkles */.K)({
                flexDirection: "column"
            })),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        paddingBottom: "m",
                        textTransform: "uppercase"
                    }),
                    children: t("listing-detail:services")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: ListingDetail_styles_css/* servicesContainer */.Rg,
                    children: services.map(function(service, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                alignItems: "center",
                                display: "flex",
                                flexDirection: "column",
                                gap: "xs",
                                textAlign: "center"
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    height: 18,
                                    src: "".concat(imageBasePath, "/images/property-details-icons/").concat(service, ".svg"),
                                    width: 18
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                    color: "greyscale500",
                                    children: t("listing-detail:".concat(service))
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ListingDetail_ServicesList = (ServicesList);

;// CONCATENATED MODULE: ./src/containers/ListingDetail/index.tsx






























































var partialIdfromPropertySlug = function(slug) {
    var slugSplittedByDash = slug.split("-");
    var lastPartOfTheSlug = slugSplittedByDash.length;
    var positionOfThePartialId = lastPartOfTheSlug - 1;
    return slugSplittedByDash[positionOfThePartialId];
};
var parseListingPrice = function(price) {
    if (Number.isFinite(price)) return Number(price / 100).toFixed(0);
};
var ListingDetail = function(param) {
    var cities = param.cities, _isDirectPageVisit = param.isDirectPageVisit, isDirectPageVisit = _isDirectPageVisit === void 0 ? false : _isDirectPageVisit, listing = param.listing, nearbyProperties = param.nearbyProperties, similarListings = param.similarListings, similarPriorities = param.similarPriorities;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var device = (0,Device/* useDevice */.Fy)();
    var ref6 = (0,useTranslation/* default */.Z)(), lang = ref6.lang, t = ref6.t;
    var ref7 = (0,react.useState)(false), shouldShowPhoneNumber = ref7[0], setShouldShowPhoneNumber = ref7[1];
    var userViews = getPreviousHourViews(listing.id);
    var isIBuyerInventory = listing.detail.inventory === types_listing/* CasavoInventory.iBuyer */.M.iBuyer;
    var isOdaInventory = listing.detail.inventory === types_listing/* CasavoInventory.Agency */.M.Agency;
    var advantages = casavoAdvantagesFor(listing);
    var ref8 = (0,react.useState)(false), showSimilarPropertiesBannerOnScroll = ref8[0], setShowSimilarPropertiesBannerOnScroll = ref8[1];
    var ref9 = (0,react.useState)(false), showSimilarPropertiesBannerOnSwipe = ref9[0], setShowSimilarPropertiesBannerOnSwipe = ref9[1];
    var similarProperties = (0,_to_consumable_array/* default */.Z)(similarPriorities).concat((0,_to_consumable_array/* default */.Z)(similarListings));
    var ref10 = (0,RelatedAdsBannerProvider/* useRelatedAdsBanner */.k)(), hasUserClickedOnBanner = ref10.hasUserClickedOnBanner, showRelatedAdsBanner = ref10.showRelatedAdsBanner, similarPropertiesRef = ref10.similarPropertiesRef;
    var shouldShowMortgageBanner = // widget only in Italian language
    lang === "it" && !listing.detail.privateNegotiation && // FIXME this is always available, comes from nika_to_cate mapping
    listing.detail.sellingPrices && // FIXME this is always a number, comes from nika_to_cate mapping, when price is null, the mapping performs a price*100 -> 0
    typeof listing.detail.sellingPrices.cents === "number";
    var obfuscateExactLocation = (0,locale_variables/* isLocaleEnabledFor */.vw)("obfuscateExactLocation", lang);
    var showPlanimetryButton = listing.country !== "france";
    var ref11 = (0,src_sliced_to_array/* default */.Z)((0,esm/* useSessionStorage */.Xs)(REQUEST_VISIT_INFO_AFTER_LOGIN, null), 2), requestVisitInfoAfterLogin = ref11[0], setRequestVisitInfoAfterLogin = ref11[1];
    (0,usePageYOffset/* usePageYOffset */.S)(function(scrollY) {
        if (scrollY > 650) {
            setShowSimilarPropertiesBannerOnScroll(true);
        }
    });
    (0,useTagManager/* useTagManager */.F)({
        agencyName: listing.contactInfo.agencyName,
        city: listing.detail.city.toLowerCase(),
        language: lang,
        listingId: listing.id,
        listingPrice: parseListingPrice((ref = listing.detail) === null || ref === void 0 ? void 0 : (ref1 = ref.sellingPrices) === null || ref1 === void 0 ? void 0 : ref1.cents),
        pageType: "listing",
        propertyIsOwnedByCasavo: listing.contactInfo.ownedByCasavo,
        propertyStreetAddress: listing.addressesCate.street + " " + listing.addressesCate.streetNumber + ", " + listing.addressesCate.zipCode + ", " + listing.detail.city
    }, [
        listing.slug
    ]);
    (0,react.useEffect)(function() {
        setShouldShowPhoneNumber(false);
    }, [
        listing.slug
    ]);
    var ref12 = (0,ModalContext/* useModal */.dd)(), closeModal = ref12.closeModal, openModal = ref12.openModal;
    var description = description_translations.get(listing.descriptions, lang);
    var pois = (0,poi/* buildPoiFrom */.Z)(listing.pointsOfInterest);
    var pointsOfInterest = (0,points_of_interest/* sortedPointsOfInterestByDistance */.OI)(pois);
    var closestPointsOfInterest = (0,points_of_interest/* nearbyUniqueByTypePois */.Ut)(pois);
    (0,react.useEffect)(function() {
        if ((0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && typeof window.sessionStorage !== "undefined") {
            sessionStorage.setItem("CASAVO@LISTING-BACK", "true");
        }
        return function() {
            (0,new_property/* storePropertyVisited */.yG)(listing.id);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (requestVisitInfoAfterLogin !== null) {
            var ref;
            openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContactModal, {
                listing: listing,
                listingTitle: (0,get_translated_title/* default */.Z)((ref = listing.detail) === null || ref === void 0 ? void 0 : ref.titles, lang),
                requestType: requestVisitInfoAfterLogin.requestType,
                similarPropertiesRef: similarPropertiesRef
            }), requestContactModalOptions);
        }
        return function() {
            return setRequestVisitInfoAfterLogin(null);
        };
    }, []);
    var handleOpenMapModalWithoutEvent = function(param) {
        var eventCategory = param.eventCategory, isReopening = param.isReopening, selectedMarker = param.selectedMarker;
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalMap, {
            cities: cities,
            closeModal: closeModal,
            closestPointsOfInterest: closestPointsOfInterest,
            handleOpenDetailFormModal: handleOpenDetailFormModal(true),
            handleTrackingCallAgency: handleTrackingCallAgency,
            listing: listing,
            pointsOfInterest: pointsOfInterest,
            selectedMarker: selectedMarker,
            similarPropertiesRef: similarPropertiesRef
        }));
        if (!isReopening) {
            (0,eventsHandlers/* handleClickOpenMap */.t9)(eventCategory);
            selectedMarker && (0,eventsHandlers/* handleListingDetailMapClick */.rt)(selectedMarker === "property" ? "PropertyMarker" : "Poi".concat(selectedMarker.poiType));
        }
    };
    var onMapModalOpen = function(param) {
        var event = param.event, eventCategory = param.eventCategory, isReopening = param.isReopening;
        event && event.preventDefault();
        handleOpenMapModalWithoutEvent({
            eventCategory: eventCategory,
            isReopening: isReopening
        });
    };
    var clickShowNumberButtonHandler = function() {
        (0,eventsHandlers/* handleListingDetailClick */.L1)("DisplayPhoneNumber");
        setShouldShowPhoneNumber(true);
    };
    var handleOpenDetailFormModal = function(reopenMap) {
        return function(event) {
            event.preventDefault();
            openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetailForm, {
                cities: cities,
                closeModal: function() {
                    closeModal();
                    // if (reopenMap) {
                    //   onMapModalOpen({
                    //     event,
                    //     eventCategory: '',
                    //     isReopening: reopenMap,
                    //   })
                    // }
                    (0,eventsHandlers/* handleListingDetailClick */.L1)("CloseContactModal");
                },
                property: listing,
                similarPropertiesLength: similarProperties.length,
                similarPropertiesRef: similarPropertiesRef
            }), {
                background: theme/* theme.colors.offWhite */.r.colors.offWhite
            });
            reopenMap ? (0,eventsHandlers/* handleListingDetailMapClick */.rt)("RequestInfo") : (0,eventsHandlers/* handleListingDetailClick */.L1)("RequestInfo");
        };
    };
    var handleOpenCasavoPropertiesModal = function() {
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(Types_CasavoProperties, {
            closeModal: function() {
                return closeModal();
            }
        }), {
            background: theme/* theme.colors.offWhite */.r.colors.offWhite,
            borderRadius: common_variables/* baseRadius */.Qi,
            desktopHeight: 903,
            desktopWidth: 1000,
            overlay: true
        });
    };
    var handleTrackingCallAgency = function(eventCategory) {
        (0,eventsHandlers/* handleClickCallAgency */.Iq)(eventCategory);
    };
    var casavoInventoryBannerBigRef = (0,react.useRef)(null);
    // NOTE: we lack a proper Proprioo inventory by now :/
    var listingDescriptionEntrusted = isIBuyerInventory || isOdaInventory || listing.country === "france";
    var characteristics = [
        {
            amount: listing.characteristics.bathrooms,
            icon: "bathroom",
            title: "bathrooms",
            value: listing.characteristics.bathrooms
        },
        {
            amount: listing.characteristics.bedrooms,
            icon: "bedroom",
            title: "bedrooms",
            value: listing.characteristics.bedrooms
        },
        {
            amount: listing.characteristics.balconies.counter,
            icon: "balcony",
            title: "balconies",
            value: listing.characteristics.balconies.counter
        },
        {
            amount: listing.characteristics.terraces.counter,
            icon: "terrace",
            title: "terraces",
            value: listing.characteristics.terraces.counter
        },
        {
            amount: (0,getTranslatedStateOfMaintenance/* getTranslatedStateOfMaintenance */.o)(listing.characteristics.stateOfMaintenance.toLowerCase(), t),
            icon: null,
            title: "status",
            value: listing.characteristics.stateOfMaintenance
        }, 
    ];
    var rooms = {
        amount: listing.characteristics.rooms,
        icon: "rooms",
        title: "rooms",
        value: listing.characteristics.rooms
    };
    /* NEARBY PROPERTIES LOGIC ________________________________________________________________________ */ var ref13 = (0,react.useState)(false), showNearbyPropertiesBanner = ref13[0], setShowNearbyPropertiesBanner = ref13[1];
    var ref14 = (0,react.useState)(false), showNearbyPropertiesNavigation = ref14[0], setShowNearbyPropertiesNavigation = ref14[1];
    var ref15 = (0,react.useState)(showNearbyPropertiesNavigation), isNearbyPropertiesNavigationSticky = ref15[0], setIsNearbyPropertiesNavigationSticky = ref15[1];
    var navigationBannerHeight = isNearbyPropertiesNavigationSticky ? 53 : 0;
    (0,react.useEffect)(function() {
        if (nearbyProperties.length > 1 && isDirectPageVisit) {
            setShowNearbyPropertiesBanner(!showNearbyPropertiesNavigation);
        }
    }, [
        isDirectPageVisit,
        nearbyProperties,
        showNearbyPropertiesNavigation
    ]);
    (0,react.useEffect)(function() {
        // Hide banner when user enters navigation
        if (showNearbyPropertiesNavigation) setShowNearbyPropertiesBanner(false);
    }, [
        showNearbyPropertiesNavigation
    ]);
    (0,react.useEffect)(function() {
        // Nearby Properties Banner is always sticky on mobile
        setIsNearbyPropertiesNavigationSticky(device === "mobile");
    }, [
        device,
        setIsNearbyPropertiesNavigationSticky
    ]);
    (0,react.useEffect)(function() {
        // Nearby Properties Banner becomes sticky when navigating
        if (showNearbyPropertiesNavigation) setIsNearbyPropertiesNavigationSticky(true);
    }, [
        showNearbyPropertiesNavigation,
        setIsNearbyPropertiesNavigationSticky
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            position: "relative"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(listing_detail, {
                cities: cities,
                listing: listing
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
                cities: cities,
                contentWidth: "full",
                showHeaderOnMobile: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NearbyPropertiesSection, {
                        cities: cities,
                        isSticky: isNearbyPropertiesNavigationSticky,
                        listing: listing,
                        nearbyProperties: nearbyProperties,
                        setShowNavigation: setShowNearbyPropertiesNavigation,
                        showBanner: showNearbyPropertiesBanner,
                        showNavigation: showNearbyPropertiesNavigation
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ListingDetail_styles_css/* contentWrapper */.Fh,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()(index_css/* layoutContentInnerStretched */.F$, ListingDetail_styles_css/* detailGalleryBg */.ao),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: index_css/* contentLayoutInner.default */.yx["default"],
                                    children: [
                                        device === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileImageGallery/* MobileImageGallery */.f, {
                                            cities: cities,
                                            citySlug: listing.detail.city,
                                            eventCategory: eventCategory/* GTMEventCategory.ListingDetail */.z.ListingDetail,
                                            photos: listing.photos,
                                            planimetryUrl: (ref2 = listing.planimetries) === null || ref2 === void 0 ? void 0 : ref2.url,
                                            swipeCallback: function(index) {
                                                index >= Math.round(listing.photos.length / 2) && setShowSimilarPropertiesBannerOnSwipe(true);
                                            },
                                            title: (0,get_translated_title/* default */.Z)((ref3 = listing.detail) === null || ref3 === void 0 ? void 0 : ref3.titles, lang)
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopImageGallery/* DesktopImageGallery */.S, {
                                            cities: cities,
                                            citySlug: listing.detail.city,
                                            eventCategory: eventCategory/* GTMEventCategory.ListingDetail */.z.ListingDetail,
                                            id: listing.id,
                                            photos: listing.photos,
                                            planimetryUrl: (ref4 = listing.planimetries) === null || ref4 === void 0 ? void 0 : ref4.url,
                                            title: (0,get_translated_title/* default */.Z)((ref5 = listing.detail) === null || ref5 === void 0 ? void 0 : ref5.titles, lang)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons, {
                                            cities: cities,
                                            obfuscateExactLocation: obfuscateExactLocation,
                                            openMap: function(event) {
                                                return onMapModalOpen({
                                                    event: event,
                                                    eventCategory: "ListingDetail"
                                                });
                                            },
                                            property: listing,
                                            showFloorPlan: showPlanimetryButton
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: ListingDetail_styles_css/* responsiveContainerDetail */.aE,
                                children: [
                                    device === "mobile" && showRelatedAdsBanner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                                children: showSimilarPropertiesBannerOnSwipe && !showSimilarPropertiesBannerOnScroll && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedAdsBanner/* RelatedAdsBanner */.C, {
                                                    touchPoint: "FromCarousel"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                                children: showSimilarPropertiesBannerOnScroll && !hasUserClickedOnBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedAdsBanner/* RelatedAdsBanner */.C, {
                                                    className: classnames_default()((0,sprinkles_css/* sprinkles */.K)({
                                                        borderRadius: 0
                                                    }), styles_css/* sticky */.CA, RelatedAdsBanner_style_css/* relatedAdsBannerOnScrollStyle */._4),
                                                    touchPoint: "FromPage"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetail_DetailHeader, {
                                                cities: cities,
                                                listing: listing
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Characteristics/* default */.Z, {
                                                characteristics: characteristics,
                                                rooms: rooms
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetail_ServicesList, {
                                                listing: listing
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetail_AccordionDetailInfo, {
                                                listing: listing
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,sprinkles_css/* sprinkles */.K)({
                                                    paddingBottom: "2xl"
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetailSection, {
                                                        hasBorder: true,
                                                        wide: true,
                                                        title: t("listing-detail:description"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDescription, {
                                                            safeContent: listingDescriptionEntrusted,
                                                            text: description.propertyDescription
                                                        })
                                                    }),
                                                    description.neighbourhoodDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetailSection, {
                                                        wide: true,
                                                        title: t("listing-detail:the_district"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                                            children: description.neighbourhoodDescription
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FranceGeologicalRiskDisclaimer, {
                                                        country: listing.country
                                                    })
                                                ]
                                            }),
                                            !obfuscateExactLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(PoiSection, {
                                                cities: cities,
                                                closestPointsOfInterest: closestPointsOfInterest,
                                                handleTrackingCallAgency: handleTrackingCallAgency,
                                                listing: listing,
                                                pointsOfInterest: pointsOfInterest,
                                                similarPropertiesRef: similarPropertiesRef,
                                                onMapModalOpen: onMapModalOpen,
                                                onOpenDetailFormModal: handleOpenDetailFormModal,
                                                onOpenMapModalWithoutEvent: handleOpenMapModalWithoutEvent
                                            }),
                                            isIBuyerInventory && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BannerCasavoProperties, {
                                                onClickCta: function() {
                                                    handleOpenCasavoPropertiesModal();
                                                    (0,eventsHandlers/* handleClickOpenCasavoPropertyModal */.Hp)("ListingDetail");
                                                }
                                            }),
                                            shouldShowMortgageBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(MortgageWidget, {
                                                listingId: listing.id,
                                                sellingPricesInCents: listing.detail.sellingPrices.cents
                                            })
                                        ]
                                    }),
                                    device === "desktop" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                position: "sticky",
                                                top: "calc(".concat(common_variables/* headerHeightDesktop */.QV, "px + ").concat(navigationBannerHeight, "px + ").concat(theme/* theme.spacings.l */.r.spacings.l, ")")
                                            },
                                            children: [
                                                showRelatedAdsBanner && device === "desktop" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedAdsBanner/* RelatedAdsBanner */.C, {
                                                        touchPoint: "FromPage"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetail_DetailContacts, {
                                                    advantages: advantages,
                                                    clickShowNumberButtonHandler: clickShowNumberButtonHandler,
                                                    property: listing,
                                                    shouldShowPhoneNumber: shouldShowPhoneNumber,
                                                    similarPropertiesRef: similarPropertiesRef
                                                }),
                                                (0,locale_variables/* isLocaleEnabledFor */.vw)("fomo", lang) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: ListingDetail_styles_css/* fomoMessageWrapper */.eI,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetail_FomoMessage, {
                                                        userViews: userViews
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            isOdaInventory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: casavoInventoryBannerBigRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InventoryBannerBig/* InventoryBannerBig */.c, {
                                    advantages: advantages,
                                    inventory: listing.detail.inventory
                                })
                            }),
                            device === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingDetail_MobileContactUs, {
                                cities: cities,
                                handleOpenDetailFormModal: handleOpenDetailFormModal,
                                handleTrackingCallAgency: handleTrackingCallAgency,
                                property: listing,
                                similarPropertiesLength: similarProperties.length,
                                similarPropertiesRef: similarPropertiesRef
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "contactForm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactAgencyForm, {
                                    cities: cities,
                                    property: listing,
                                    similarPropertiesLength: similarProperties.length,
                                    similarPropertiesRef: similarPropertiesRef
                                })
                            }),
                            similarProperties.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                ref: similarPropertiesRef,
                                className: ListingDetail_styles_css/* similarPropertiesWrapper */.J,
                                id: "similarProperties",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            paddingBottom: "4xl",
                                            paddingTop: "2xl",
                                            paddingX: "4xl",
                                            textAlign: "center"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                                                children: t("listing-detail:might_interest_you")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                                                className: (0,sprinkles_css/* sprinkles */.K)({
                                                    marginTop: "s"
                                                }),
                                                children: t("listing-detail:based_on_your_searches")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarPropertiesCarousel/* SimilarPropertiesCarousel */.E, {
                                        similarListings: similarListings,
                                        similarPriorities: similarPriorities
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var containers_ListingDetail = (ListingDetail);


/***/ }),

/***/ 59185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ ListingNotFound; }
});

// UNUSED EXPORTS: getDefaultCityOfCurrentLocale

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/Header/index.tsx + 14 modules
var Header = __webpack_require__(19588);
// EXTERNAL MODULE: ./src/components/Link/linkBuilder.ts
var linkBuilder = __webpack_require__(13976);
// EXTERNAL MODULE: ./src/design-lib/components/ButtonLink/index.tsx
var ButtonLink = __webpack_require__(36898);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/heads/listing-not-found.tsx



var ListingNotFoundHead = function() {
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var metaTitle = t("listing-detail:title_not_found") + " | Casavo";
    var metaDescription = t("common:listing_not_found_title");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: metaDescription,
                name: "description"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: metaTitle,
                property: "og:title"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: metaDescription,
                property: "og:description"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: lang,
                property: "og:locale"
            })
        ]
    });
};
/* harmony default export */ var listing_not_found = (ListingNotFoundHead);

// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/utils/locale-variables/index.ts
var locale_variables = __webpack_require__(98640);
// EXTERNAL MODULE: ./src/utils/locale-variables/menuLinks.ts
var menuLinks = __webpack_require__(87264);
// EXTERNAL MODULE: src/design-lib/style-theme/theme.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/theme.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx+PN+HpviGoxnG0Q/yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx/6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I/MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN/xuQI/Ob/nviaZJHQ+EFSd7nQndD4SVF577QV/Yv+VVVbo3PF5EyYU9zgxVxhQ+P/M+psxDoLv2X+TYhT+vxBUwfbJi/s98L34vrE+50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ/mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE/Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K+3m+8qnvHrz5qf+odIeOQENc0Qvhb/xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV+AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6/+y/r7Dy2XybuPCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(19636);
// EXTERNAL MODULE: src/containers/ListingNotFound/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/containers/ListingNotFound/styles.css.ts.vanilla.css","source":"Ll8xN2JucGtvMSB7CiAgbWFyZ2luLXRvcDogdmFyKC0tXzFtdWg4bmsxcSk7CiAgbWFyZ2luLWJvdHRvbTogdmFyKC0tXzFtdWg4bmsyMik7CiAgbWF4LXdpZHRoOiAxMjAwcHg7Cn0KQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogMTAyNHB4KSB7CiAgLl8xN2JucGtvMCB7CiAgICBtYXgtd2lkdGg6IDY0MHB4OwogIH0KfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(15250);
;// CONCATENATED MODULE: ./src/containers/ListingNotFound/styles.css.ts


var imgContainer = '_17bnpko0';
var suggestedLinkContainer = '_17bnpko1';
;// CONCATENATED MODULE: ./src/containers/ListingNotFound/index.tsx















/** Redirects to the default city of the locale if the user lands on the page of a city that does not
 *  match to the current locale (to prevent nasty error pages) */ var getDefaultCityOfCurrentLocale = function(locale) {
    // const countryOfCurentCity = currentCity.country || lang
    var localesOfCurrentCity = localesByCountryName[locale] || [];
    if (!localesOfCurrentCity.includes(locale)) {
        return defaultCitiesByLocale[locale];
    }
    // return currentCity.slug
    return locale;
};
var ListingNotFound = function() {
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var headerData = (0,menuLinks/* getMenuLinks */.h)(lang);
    var ref1 = config_default()(), _publicRuntimeConfig = ref1.publicRuntimeConfig, imageBasePath = _publicRuntimeConfig.imageBasePath, lisaWebsite = _publicRuntimeConfig.lisaWebsite;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(listing_not_found, {}),
            typeof headerData !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                links: headerData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(styles_css/* backgroundColor.lightBlue */.Cz.lightBlue, (0,sprinkles_css/* sprinkles */.K)({
                    textAlign: "center"
                })),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(imgContainer, (0,sprinkles_css/* sprinkles */.K)({
                            margin: "auto",
                            paddingBottom: "5xl",
                            paddingTop: {
                                mobile: "xl"
                            },
                            paddingX: "m"
                        })),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "",
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    marginBottom: "m",
                                    marginX: "auto"
                                }),
                                height: "300",
                                loading: "lazy",
                                src: "".concat(imageBasePath, "/images/concepts/home-chapter-woman.svg"),
                                width: "300"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    textAlign: "center"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                                        className: styles_css/* marginBottom.2xl */.yl["2xl"],
                                        children: t("common:listing_not_found_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            paddingX: {
                                                mobile: "xl"
                                            }
                                        }),
                                        children: t("common:listing_not_found_similar_properties_subtitle")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            paddingBottom: "4xl",
                            textAlign: "center"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                            isNextLink: true,
                            href: lisaWebsite + linkBuilder/* linkBuilder.housesForSale.url */.H.housesForSale.url(lang),
                            label: t("common:listing_not_found_cta"),
                            styleVariant: "secondary"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 54985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* reexport */ TokenSupport; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/Translated.tsx
var Translated = __webpack_require__(36510);
;// CONCATENATED MODULE: ./src/design-lib/base-ui/Typography/TokenSupport.tsx



/**
 * @deprecated The < TokenSupport > component should not be used.
 * You should use < Translated i18Key='your:translation-key' > component instead
 */ var TokenSupport = function(param) {
    var children = param.children, components = param.components, values = param.values;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: react.Children.map(children, function(child) {
            if (typeof child === "string") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                    components: components,
                    i18Key: child,
                    values: values
                });
            }
            return child;
        })
    });
};

;// CONCATENATED MODULE: ./src/design-lib/base-ui/Typography/index.ts



/***/ }),

/***/ 36898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ButtonLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3292);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79713);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66731);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32466);
/* harmony import */ var _components_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28820);
/* harmony import */ var _design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20579);
/* eslint-disable react/display-name */ 








var ButtonLink = function(_param) {
    var Icon = _param.Icon, ariaLabel = _param.ariaLabel, center = _param.center, className = _param.className, colorVariant = _param.colorVariant, fullWidth = _param.fullWidth, href = _param.href, _isNextLink = _param.isNextLink, isNextLink = _isNextLink === void 0 ? true : _isNextLink, label = _param.label, onClick = _param.onClick, rel = _param.rel, sizeVariant = _param.sizeVariant, styleVariant = _param.styleVariant, target = _param.target, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "Icon",
        "ariaLabel",
        "center",
        "className",
        "colorVariant",
        "fullWidth",
        "href",
        "isNextLink",
        "label",
        "onClick",
        "rel",
        "sizeVariant",
        "styleVariant",
        "target"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_5__/* .ConditionalWrapper */ .M, {
        condition: isNextLink,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                passHref: true,
                href: href,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((0,_design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_6__/* .sprinkles */ .K)({
                cursor: "pointer",
                display: "inline-block"
            }), className),
            href: !isNextLink && href,
            rel: rel,
            target: target,
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                asLink: true,
                ariaLabel: ariaLabel,
                center: center,
                colorVariant: colorVariant,
                fullWidth: fullWidth,
                Icon: Icon,
                label: label,
                sizeVariant: sizeVariant,
                styleVariant: styleVariant
            }, props))
        })
    });
};


/***/ }),

/***/ 28961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ PoiType; },
/* harmony export */   "Z": function() { return /* binding */ buildPoiFrom; }
/* harmony export */ });
var buildPoiFrom = function(pois) {
    return pois.map(function(poi) {
        return {
            coordinates: poi.coordinates,
            distance: poi.distance,
            name: poi.name,
            poiType: poi.poiType
        };
    });
};
var PoiType;
(function(PoiType) {
    PoiType["BusStop"] = "BUS_STOP";
    PoiType["School"] = "SCHOOL";
    PoiType["Shop"] = "SHOP";
    PoiType["SubwayStation"] = "SUBWAY_STATION";
    PoiType["TrainStation"] = "TRAIN_STATION";
    PoiType["TramStop"] = "TRAM_STOP";
})(PoiType || (PoiType = {}));


/***/ }),

/***/ 13782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fq": function() { return /* binding */ poiTypes; },
/* harmony export */   "OI": function() { return /* binding */ sortedPointsOfInterestByDistance; },
/* harmony export */   "Qv": function() { return /* binding */ getPoiCategoryFromType; },
/* harmony export */   "Ut": function() { return /* binding */ nearbyUniqueByTypePois; }
/* harmony export */ });
/* unused harmony exports isTransportType, getPoiCategoryFromTypeString */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62271);
/* harmony import */ var _types_poi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28961);
/* harmony import */ var _uuid_request_id__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33973);




var isTransportType = function(poiType) {
    return poiTypes.TRANSPORT.types.includes(poiType);
};
var sortedPointsOfInterestByDistance = function(pois) {
    return pois.map(function(poi) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, poi), {
            slug: (0,_uuid_request_id__WEBPACK_IMPORTED_MODULE_3__/* .generateUuidRequestId */ .l)()
        });
    }).sort(function(a, b) {
        return a.distance - b.distance;
    });
};
var nearbyPoiSchool = function(pois) {
    return pois.find(function(poi) {
        return poi.poiType === _types_poi__WEBPACK_IMPORTED_MODULE_0__/* .PoiType.School */ .O.School;
    });
};
var nearbyPoiShop = function(pois) {
    return pois.find(function(poi) {
        return poi.poiType === _types_poi__WEBPACK_IMPORTED_MODULE_0__/* .PoiType.Shop */ .O.Shop;
    });
};
var nearbyPoiTransport = function(pois, priorityType) {
    if (priorityType) {
        var nearbyPriorityPoi = pois.find(function(poi) {
            return poi.poiType === priorityType;
        });
        if (nearbyPriorityPoi) {
            return nearbyPriorityPoi;
        }
    }
    return pois.find(function(poi) {
        return isTransportType(poi.poiType);
    });
};
var nearbyUniqueByTypePois = function(pois, transportPriorityType) {
    var sortedPois = sortedPointsOfInterestByDistance(pois);
    return [
        nearbyPoiTransport(sortedPois, transportPriorityType),
        nearbyPoiShop(sortedPois),
        nearbyPoiSchool(sortedPois), 
    ].filter(function(poi) {
        return poi;
    });
};
var poiTypes = {
    SCHOOL: {
        types: [
            _types_poi__WEBPACK_IMPORTED_MODULE_0__/* .PoiType.School */ .O.School
        ]
    },
    SHOP: {
        types: [
            _types_poi__WEBPACK_IMPORTED_MODULE_0__/* .PoiType.Shop */ .O.Shop
        ]
    },
    TRANSPORT: {
        types: [
            _types_poi__WEBPACK_IMPORTED_MODULE_0__/* .PoiType.BusStop */ .O.BusStop,
            _types_poi__WEBPACK_IMPORTED_MODULE_0__/* .PoiType.TrainStation */ .O.TrainStation,
            _types_poi__WEBPACK_IMPORTED_MODULE_0__/* .PoiType.TramStop */ .O.TramStop,
            _types_poi__WEBPACK_IMPORTED_MODULE_0__/* .PoiType.SubwayStation */ .O.SubwayStation
        ]
    }
};
var getPoiCategoryFromType = function(poiType) {
    var strings = Object.keys(poiTypes);
    var category = strings.find(function(category) {
        return poiTypes[category].types.includes(poiType);
    });
    if (!category) throw new Error("Unexpected Point of interest type: ".concat(poiType));
    return category;
};
var getPoiCategoryFromTypeString = function(poiType) {
    var strings = Object.keys(poiTypes);
    var category = strings.find(function(category) {
        return poiTypes[category].types.map(function(t) {
            return t.toString();
        }).includes(poiType);
    });
    if (!category) throw new Error("Unexpected Point of interest type: ".concat(poiType));
    return category;
};


/***/ }),

/***/ 27405:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 82176:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 46032:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25791:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3841:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 71481:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8104:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 43392:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 71766:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31675:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 78054:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 46151:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 80995:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 28070:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 13281:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 22302:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 59899:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 62625:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 42012:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 15250:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21464:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);